<!-- <ngx-spinner bdColor="rgba(51,51,51,0.8)" size="large" color="#fff" type="ball-circus" [fullScreen]="true">
</ngx-spinner> -->
<style>
  .k-loader-primary {
    color: rgb(255, 255, 255, 0.7)
  }

  ::ng-deep.k-loader-md ::ng-deep.k-loader-segment {
    width: 14px;
    height: 14px;
  }

  ::ng-deep.k-loader-spinner-4.k-loader-md ::ng-deep.k-loader-canvas {
    width: 40px;
    height: 40px;
  }
</style>
<div class="k-loading-panel" *ngIf="showSpinner">
  <div class="k-loading-panel-mask"></div>
  <div class="k-loading-panel-wrapper">
    <kendo-loader type="converging-spinner"></kendo-loader>

    <div class="k-loading-panel-text">Loading...</div>
  </div>
</div>
<div *ngIf="IsFormShow === true" class="container-fluid" id="grad1">
  <!-- <div class="row justify-content-center" style="background-color: #003b71"> -->
  <div class="row justify-content-center">
    <div class="col-sm-12 col-md-11 col-lg-10 my-4">
      <div class="card pt-4 pb-2">
        <app-header></app-header>
        <div class="row" id="convertToPdf">
          <div class="col-md-12 mx-0">
            <form id="msform" #msform [formGroup]="companyForm">
              <!-- progressbar -->
              <ul id="progressbar">
                <li [ngClass]="step >= 1 ? 'active ' : 'inactive'" id="company">
                  <strong>Company Information</strong>
                </li>
                <li [ngClass]="step >= 2 ? 'active ' : 'inactive'" id="employee">
                  <strong>Program Information</strong>
                </li>
                <li [ngClass]="step >= 3 ? 'active ' : 'inactive'" id="agreement">
                  <strong>Acknowledgment/Agreement</strong>
                </li>
                <li [ngClass]="step >= 4 ? 'active ' : 'inactive'" id="summary">
                  <strong>Summary</strong>
                </li>
                <!-- <li [ngClass]="step>=5 ? 'active ' : 'inactive'" id="program-cost"><strong>Program Cost</strong></li> -->
                <li [ngClass]="step >= 5 ? 'active ' : 'inactive'" id="payment">
                  <strong>Payment</strong>
                </li>
                <li [ngClass]="step >= 6 ? 'active ' : 'inactive'" id="confirm">
                  <strong>Finish</strong>
                </li>
              </ul>

              <div style="position: absolute; left: -1000px; top: -10000px">

                <kendo-pdf-export #pdf paperSize="A4" margin="1cm" [scale]=0.8>
                  <div id="Summary" #Summary class="invoice-items px-3">
                    <div class="pdf-header pb-3">
                      
                      <div>
                        <img src="../../assets/Images/PTC_Drug_Programs_Compliance.png" class="logo" />
                      </div>
                      <div class="text-right"><b>9 Compound Dr.</b></div>
                      <div class="text-right"><b>Hutchinson, KS 67502</b></div>
                      <div class="text-right"><b>620.669.8800</b></div>
                    </div>
                    <div>
                      <!-- col-lg-12 start here -->
                      <table style="width: 100%">
                        <tbody class="invoice-details">
                          <tr>
                            <td><strong>Invoice:</strong> {{ InvoiceNumber}}</td>
                          </tr>
                          <tr>
                            <td>
                              <strong>Date:</strong> {{formatDateToLong(AckAndAgreement.AckDate)}}
                            </td>
                          </tr>
                         
                          <tr>
                            <td>
                              <strong>Status:</strong><span class="badge badge-danger ms-2">UNPAID</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <br />
                    </div>
                    <div class="text-left"><strong>Invoiced To:</strong></div>
                    <table class="container" style="width: 100%; max-width:100%">
                      <tbody class="invoice-details">
                        <tr>
                          <td>
                            <strong>Company Name: </strong>{{  objCompanyInfo.CompanyName }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <strong>Name: </strong>{{
                             objCompanyInfo.BillingContact
                            .BillingContactName
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <strong>Email: </strong>{{
                             objCompanyInfo.BillingContact
                            .BillingContactEmail
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <strong>Address: </strong>{{
                             objCompanyInfo.BillingContact.BillingAddress
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {{
                             objCompanyInfo.BillingContact.BillingCity +
                            ", " +
                             objCompanyInfo.BillingContact.BillingState +
                            ", " +
                            GetZipFormat( objCompanyInfo.BillingContact.BillingZip) +
                            ", " +
                             objCompanyInfo.BillingContact.BillingCountry

                            }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <br />
                    <div class="table-responsive" style="overflow: hidden; outline: none; letter-spacing: 0.01px;">
                      <table class="table table-bordered td_padding" style="width: 100%;letter-spacing: 0.01px;">
                        <thead>
                          <tr>
                            <th style="
                            width: 50%;
                            background-color: #003b71;
                            color: white;
                          " class="per70 text-center">
                              Description
                            </th>
                            <th style="
                            width: 25%;
                            background-color: #003b71;
                            color: white;" class="per5 text-center">
                              Qty
                            </th>
                            <th style="
                            width: 25%;
                            background-color: #003b71;
                            color: white;
                          " class="per25 text-center">
                              Total
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td class="text-left">Account Setup Fee</td>
                            <td class="text-center">1</td>
                            <td class="text-right">
                              ${{
                              NumberWithCommasWithTwoDecimal(CustomerInfo?.CustomerDetails.FeeDetails.SetupFee)
                              }}
                              USD&nbsp;
                            </td>
                          </tr>
                          <tr>
                            <td class="text-left">Annual Subscription</td>
                            <td class="text-center">1</td>
                            <td class="text-right">
                              ${{
                              NumberWithCommasWithTwoDecimal(CustomerInfo?.CustomerDetails.FeeDetails
                              .AnnualSubscription)
                              }}
                              USD
                            </td>
                          </tr>
                          <tr>
                            <td class="text-left">Annual Employee Fee</td>
                            <td class="text-center">
                              {{
                              (objProgramInfo.NumberOfEmployees )
                              }}
                            </td>
                            <td class="text-right">
                              ${{ NumberWithCommasWithTwoDecimal(randomPool) }}
                              USD
                            </td>
                          </tr>
                          <tr>
                            <td class="text-left">Shipping & Handling</td>
                            <td class="text-center">1</td>
                            <td class="text-right">
                              ${{
                              NumberWithCommasWithTwoDecimal(CustomerInfo?.CustomerDetails.FeeDetails
                              .ExpeditedShippingFee)
                              }}
                              USD&nbsp;
                            </td>
                          </tr>
                          <tr>
                            <td class="text-left">Sales Tax ({{SalesTax > 0? SalesTaxPercent : 0}}%)**</td>
                            <td class="text-center">1</td>
                            <td class="text-right">
                              ${{
                              NumberWithCommasWithTwoDecimal(SalesTax)
                              }}
                              USD
                            </td>
                          </tr>
                          <tr>
                            <th colspan="2" class="text-right">
                              Enrollment Total
                            </th>
                            <th class="text-right">
                              ${{
                               NumberWithCommasWithTwoDecimal(EnrollmentTotalFee )
                              }}
                              USD
                            </th>
                          </tr>
                        </tbody>
                       
                      </table>
                    </div>
                    <div style="margin-top: .75rem; font-size: 12px; text-align: left; line-height:14px; ">**All South
                      Dakota based accounts are subject to sales tax. Completing and submitting this enrollment
                      authorizes PTC to charge the applicable sales tax rate based upon your jurisdiction at the time
                      the credit card is processed or invoice is issued.</div>
                    <div style="margin-top: 6rem; text-align: left;">
                      <table style="width:100%;font-weight:normal; font-size:11px; line-height:14px;">
                        <tr>
                          <td>
                            <div style="font-size: 12px;"><strong>No Refund & Credit Policy:</strong></div>
                            Due to the nature of our services, we have, without exception, a NO REFUND policy. For this reason, we strongly recommend that before payment, you make certain that you understand the nature and cost of the services we provide. Invoices sent by PTC under this agreement are due upon receipt. The company shall owe a finance charge on any balance not paid within 30 days of the date of the invoice at the rate of 1.5% per month or 18% annually and the account may be subject to hold. In the event the company fails to make payments of amounts due under this agreement, PTC is authorized to suspend performance of its obligations to the company until full payment of the amount which the company is in default is received. PTC is not obligated to keep accounts open once an invoice balance has reached 60 days. By way of illustration and not limitation, PTC is expressly allowed, during such period of default, to remove the company from the Consortium and to report on any listing or report of compliance with applicable regulations or, in the case where PTC is listing only the company in compliance to omit such defaulting company. Such action by PTC shall not relieve the company of its obligation to pay any annual, administration, or other fees provided under this agreement.
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </kendo-pdf-export>
              </div>
              <!-- fieldsets -->
              <fieldset *ngIf="step == 1">
                <div class="form-card">
                  <h2 class="fs-title">Company Information</h2>

                  <div class="row">
                    <div class="col-lg-12 col-md-12 form-group">
                      <label id="lbl_company_name" class="col-md-2 label-right pl-0"><strong class="required-fileds">*
                        </strong>Company Name:</label>
                      <kendo-textbox [tabindex]="1" [(ngModel)]="objCompanyInfo.CompanyName" [maxlength]="100"
                        name="CompanyName" formControlName="fcCompanyName" type="text" id="CompanyName"
                        placeholder="Company Name" class="p-0 col-xl-8 col-lg-10 col-md-10"
                        (change)="changeInputTrim($event,'CompanyName')" [ngClass]="{
                          'is-invalid': submitted && cf['fcCompanyName'] ? cf['fcCompanyName'].errors : ''
                        }">
                      </kendo-textbox>

                      <!-- <input
                        [(ngModel)]="objCompanyInfo.CompanyName"
                        readonly
                        name="CompanyName"
                        formControlName="fcCompanyName"
                        type="text"
                        id="CompanyName"
                        #Companyname
                        placeholder="Company Name"
                        class="form-control col-md-8"
                        [ngClass]="{
                          'is-invalid': submitted && cf['fcCompanyName'].errors
                        }"
                      /> -->
                      <div *ngIf="submitted && cf['fcCompanyName'] ? cf['fcCompanyName'].errors : ''" class="invalid-feedback">
                        <div class="col-xl-8 offset-xl-2 pl-0" *ngIf="cf['fcCompanyName'] ? cf['fcCompanyName'].errors : false">
                          Company Name is required
                        </div>
                      </div>
                    </div>
                    <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 form-group">
                      <label id="lbl_country" class="col-md-5 label-right pl-0"><strong class="required-fileds">*
                        </strong>Country:</label>
                      <kendo-dropdownlist [tabindex]="2" [data]="CountryItems" formControlName="fcCountry"
                        (selectionChange)="changeCountry($event)"
                        class="col-xl-7 col-lg-8 col-md-8 p-0 seleted_dropdown" [(ngModel)]="objCompanyInfo.Country"
                        id="txt_state" placeholder="Country" [ngClass]="{
                      'is-invalid': submitted && cf['fcCountry'].errors
                    }"> </kendo-dropdownlist>

                      <div *ngIf="submitted && cf['fcCountry'].errors" class="invalid-feedback">
                        <div class="col-xl-7 offset-xl-5 pl-0" *ngIf="cf['fcCountry'].errors">
                          Country is required
                        </div>
                      </div>
                    </div>
                    <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 form-group">
                    </div>
                    <!-- </div>
                    <h3 class="fs-subtitle mb-2">Mailing Address</h3>
                    <div class="row"> -->
                    <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 form-group">
                      <label class="col-lg-5 label-right pl-0"><strong class="required-fileds">* </strong>Mailing
                        Address:</label>
                      <kendo-textbox [tabindex]="3" [(ngModel)]="objCompanyInfo.MailingAddress" name="MailingAddress"
                        formControlName="fcMailingAddress" type="text" [maxlength]="40" placeholder="Mailing Address"
                        class="p-0 col-xl-7 col-lg-8 col-md-8" (change)="changeInputTrim($event,'MailingAddress')"
                        [ngClass]="{
                          'is-invalid':
                            submitted && cf['fcMailingAddress'].errors
                        }" (keyup)="changeMailingAddress($event)">
                      </kendo-textbox>
                      <!-- <input
                        [(ngModel)]="objCompanyInfo.MailingAddress"
                        name="MailingAddress"
                        formControlName="fcMailingAddress"
                        type="text"
                        placeholder="Mailing Address"
                        class="form-control col-md-8"
                        [ngClass]="{
                          'is-invalid':
                            submitted && cf['fcMailingAddress'].errors
                        }"
                        (keyup)="changeMailingAddress($event)"
                      /> -->
                      <div *ngIf="submitted && cf['fcMailingAddress'].errors" class="invalid-feedback">
                        <div class="col-xl-7 offset-xl-5 pl-0" *ngIf="cf['fcMailingAddress'].errors['required']">
                          Mailing Address is required
                        </div>
                      </div>
                    </div>
                    <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 form-group">
                      <label id="lbl_city" class="col-md-5 label-right pl-0"><strong class="required-fileds">*
                        </strong>City:</label>
                      <kendo-textbox [tabindex]="3" [(ngModel)]="objCompanyInfo.City" name="City" [maxlength]="50"
                        formControlName="fcCity" [ngClass]="{
                          'is-invalid': submitted && cf['fcCity'].errors
                        }" type="text" placeholder="City" class="p-0 col-xl-7 col-lg-8 col-md-8"
                        (keyup)="changeCity($event)" (change)="changeInputTrim($event,'MailingCity')">
                      </kendo-textbox>

                      <!-- <input
                        [(ngModel)]="objCompanyInfo.City"
                        name="City"
                        formControlName="fcCity"
                        [ngClass]="{
                          'is-invalid': submitted && cf['fcCity'].errors
                        }"
                        type="text"
                        placeholder="City"
                        class="form-control col-md-8"
                        (keyup)="changeCity($event)"
                      /> -->
                      <div *ngIf="submitted && cf['fcCity'].errors" class="invalid-feedback">
                        <div class="col-xl-7 offset-xl-5 pl-0" *ngIf="cf['fcCity'].errors['required']">
                          City is required
                        </div>
                      </div>

                    </div>

                    <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 form-group">
                      <label id="lbl_state" class="col-md-5 label-right pl-0"><strong class="required-fileds">*
                        </strong>{{objCompanyInfo.Country === 'Canada'?'Province':'State' }}:</label>
                      <kendo-dropdownlist [tabindex]="4" [data]="ListStates" formControlName="fcState"
                        (selectionChange)="changeState($event)" class="col-xl-7 col-lg-8 col-md-8 p-0 seleted_dropdown"
                        [(ngModel)]="objCompanyInfo.State" id="txt_state" [ngClass]="{
                      'is-invalid': submitted && cf['fcState'].errors
                    }"> </kendo-dropdownlist>

                      <div *ngIf="submitted && cf['fcState'].errors" class="invalid-feedback">
                        <div class="col-xl-7 offset-xl-5 pl-0" *ngIf="cf['fcState'].errors">
                          {{objCompanyInfo.Country === 'Canada'?'Province':'State' }} is required
                        </div>
                      </div>
                    </div>


                    <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 form-group">
                      <label id="lbl_zip" class="col-md-5 label-right pl-0"><strong class="required-fileds">*
                        </strong>{{objCompanyInfo.Country === 'USA'?'Zip':'Postal Code' }}:</label>
                      <!-- maxlength="5" -->
                      <kendo-maskedtextbox [tabindex]="5" [(ngModel)]="objCompanyInfo.Zip" name="Zip"
                        formControlName="fcZip" [ngClass]="{
                                'is-invalid': submitted && cf['fcZip'].errors
                              }" type="text" id="txt_zip" [mask]="Der_Zip_no_mask"
                        class="p-0 col-xl-4 col-lg-5 col-md-5" (keyup)="changeMailingZip($event)">
                      </kendo-maskedtextbox>
                      <!-- <kendo-textbox [tabindex]="5" [(ngModel)]="objCompanyInfo.Zip" name="Zip"
                        formControlName="fcZip" placeholder="{{objCompanyInfo.Country === 'USA'?'00000':'ANA NAN' }}" [ngClass]="{
                                'is-invalid': submitted && cf['fcZip'].errors
                              }" type="text"  id="txt_zip" 
                        class="p-0 col-xl-4 col-lg-5 col-md-5" (keypress)="ZipKeyPress($event)" (keyup)="changePhysicalZip($event)" >
                      </kendo-textbox> -->
                      <!-- <div *ngIf="!objZipValid.IsValidMailingZip" class="invalid-feedback" style="display:block;">
                        <div class="col-xl-7 offset-xl-5 px-0 text-nowrap">
                          {{objCompanyInfo.Country === 'USA'? 'Zip format required (00000)':'Postal Code required (e.g. K1A 0T6)' }}
                        </div>
                      </div> -->
                      <div *ngIf="submitted && cf['fcZip'].errors" class="invalid-feedback">
                        <div class="col-xl-7 offset-xl-5 pl-0" *ngIf="cf['fcZip'].errors">
                          {{objCompanyInfo.Country === 'USA'? 'Zip is required':'Postal Code is required'}}
                        </div>
                      </div>
                    </div>



                    <div class="pl-3 col-md-10 offset-xl-2 form-group">

                      <!-- <div class=" wraping_div" style="margin-right: -6px">
                          &nbsp;
                        </div> -->
                      <div class="custom_checkbox">
                        <input type="checkbox" class="form-check-input" [tabindex]="6" kendoCheckBox
                          [(ngModel)]="objCompanyInfo.SameAsMailingAddress" name="SameAsMailingAddress"
                          formControlName="fcSameAsMailingAddress" id="html"
                          (change)="SameAsMailingCheckBoxChanged($event)" />
                        <label for="html">Same as Mailing</label>
                      </div>
                    </div>

                    <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 form-group">
                      <label class="col-md-5 label-right pl-0"><strong class="required-fileds">* </strong>Physical
                        Address:</label>
                      <kendo-textbox [tabindex]="7" [(ngModel)]="objCompanyInfo.PhysicalAddress" name="PhysicalAddress"
                        formControlName="fcPhysicalAddress" type="text" placeholder="Address" [maxlength]="40"
                        class="p-0 col-xl-7 col-lg-8 col-md-8" (change)="changeInputTrim($event,'PhysicalAddress')"
                        [ngClass]="{
                          'is-invalid':
                            submitted && cf['fcPhysicalAddress'].errors
                        }">
                      </kendo-textbox>
                      <div *ngIf="submitted && cf['fcPhysicalAddress'].errors" class="invalid-feedback">
                        <div class="col-xl-7 offset-xl-5 pl-0" *ngIf="cf['fcPhysicalAddress'].errors['required']">
                          Physical Address is required
                        </div>
                      </div>
                    </div>


                    <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 form-group">
                      <label id="lbl_city" class="col-md-5 label-right pl-0"><strong class="required-fileds">*
                        </strong>City:</label>
                      <kendo-textbox [tabindex]="8" [(ngModel)]="objCompanyInfo.PhysicalAddressCity" [maxlength]="50"
                        name="PhysicalAddressCity" formControlName="fcPhysicalAddressCity"
                        (change)="changeInputTrim($event,'PhysicalCity')" [ngClass]="{
                          'is-invalid':
                            submitted && cf['fcPhysicalAddressCity'].errors
                        }" type="text" placeholder="City" class="p-0 col-xl-7 col-lg-8 col-md-8">
                      </kendo-textbox>
                      <div *ngIf="submitted && cf['fcPhysicalAddressCity'].errors" class="invalid-feedback">
                        <div class="col-xl-7 offset-xl-5 pl-0" *ngIf="cf['fcPhysicalAddressCity'].errors['required']">
                          Physical Address City is required
                        </div>
                      </div>

                    </div>

                    <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 form-group">
                      <label id="lbl_state" class="col-md-5 label-right pl-0"><strong class="required-fileds">*
                        </strong>{{objCompanyInfo.Country === 'Canada'?'Province':'State' }}:</label>
                      <kendo-dropdownlist [tabindex]="9" [data]="ListStates" formControlName="fcPhysicalAddressState"
                        class="col-xl-7 col-lg-8 col-md-8 p-0 seleted_dropdown" id="txt_state" placeholder="State"
                        [(ngModel)]="objCompanyInfo.PhysicalAddressState" name="PhysicalAddressState" [ngClass]="{
                      'is-invalid': submitted && cf['fcState'].errors
                    }"> </kendo-dropdownlist>
                      <div *ngIf="submitted && cf['fcPhysicalAddressState'].errors" class="invalid-feedback">
                        <div class="col-xl-7 offset-xl-5 pl-0" *ngIf="
                          cf['fcPhysicalAddressState'].errors
                        ">
                          Physical Address {{objCompanyInfo.Country === 'Canada'?'Province':'State' }} is required
                        </div>
                      </div>
                    </div>

                    <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 form-group">

                      <label id="lbl_zip" class="col-md-5 label-right pl-0"><strong class="required-fileds">*
                        </strong>{{objCompanyInfo.Country === 'USA'?'Zip':'Postal Code' }}:</label>
                      <kendo-maskedtextbox [tabindex]="10" [(ngModel)]="objCompanyInfo.PhysicalAddressZip"
                        name="PhysicalAddressZip" formControlName="fcPhysicalAddressZip" [mask]="Der_Zip_no_mask"
                        [ngClass]="{
                        'is-invalid':
                          submitted && cf['fcPhysicalAddressZip'].errors
                      }" type="text" id="txt_zip" placeholder="Zip" class="p-0 col-xl-4 col-lg-5 col-md-5">
                      </kendo-maskedtextbox>
                      <!-- <div *ngIf="!objZipValid.IsValidPhysicalZip" class="invalid-feedback" style="display:block;">
                        <div class="col-xl-7 offset-xl-5 pl-0 px-0 text-nowrap">
                          {{objCompanyInfo.Country === 'USA'? 'Zip format required (00000)':'Postal Code required (e.g. K1A 0T6)' }}
                        </div>
                      </div> -->
                      <!-- <div *ngIf="!objZipValid.IsValidLengthPhysicalZip" class="invalid-feedback" style="display:block;">
                        <div class="col-xl-7 offset-xl-5 pl-0"> Valid length is required
                        </div>
                      </div> -->
                      <div *ngIf="submitted && cf['fcPhysicalAddressZip'].errors" class="invalid-feedback">
                        <div class="col-xl-7 offset-xl-5 pl-0" *ngIf="cf['fcPhysicalAddressZip'].errors">
                          {{objCompanyInfo.Country === 'USA'? 'Physical Address Zip is required':'Physical Address Postal Code is required'}}
                        </div>
                      </div>

                    </div>


                    <div class="col-md-12 form-group p_xl_20">
                      <label id="lbl_company_name" class="col-md-2 label-right pl-0 align-middle">Affiliate Company
                        Name:</label>

                      <kendo-textbox [tabindex]="11" [readonly]="true" [(ngModel)]="objCompanyInfo.SisterCompanyName"
                        name="SisterCompanyName" formControlName="fcSisterCompanyName" type="text" id="CompanyName"
                        #SisterCompanyname placeholder="Affiliate Company Name"
                        class="p-0 col-xl-8 col-lg-10 col-md-10">
                      </kendo-textbox>
                    </div>
                    <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 form-group">
                      <label id="lbl_ISNetworld_Account_No" class="col-md-5 label-right pl-0">ISNetworld Account
                        No:</label>
                      <kendo-maskedtextbox [tabindex]="12" [(ngModel)]="objCompanyInfo.ISNetworldAccountNo"
                        name="ISNetworldAccountNo" inputMask="000-000000" formControlName="fcISNetworldAccountNo"
                        type="text" placeholder="ISNetworld Account No" class="p-0 col-xl-4 col-lg-5 col-md-5"
                        [maxlength]="10" [mask]="ISN_Number">
                      </kendo-maskedtextbox>

                      <!-- <input
                        [(ngModel)]="objCompanyInfo.ISNetworldAccountNo"
                        name="ISNetworldAccountNo"
                        formControlName="fcISNetworldAccountNo"
                        type="text"
                        placeholder="ISNetworld Account No"
                        class="form-control col-md-8"
                      /> -->
                      <div class="col-xl-7 offset-xl-5 pl-0" style="font-weight:normal; font-size: 12px;">(If
                        applicable)</div>
                    </div>


                    <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 form-group">
                      <label id="lbl_ITS_Account_No" class="col-md-5 label-right pl-0">ITS Account No:</label>
                      <kendo-textbox [tabindex]="13" [(ngModel)]="objCompanyInfo.ITSAccountNo" name="ITSAccountNo"
                        formControlName="fcITSAccountNo" placeholder="ITS Account No"
                        class="p-0 col-xl-7 col-lg-8 col-md-8" (keypress)="ITSNoKeyPress($event)"
                        (keyup)="changeItsNo($event)" (change)="changeInputTrim($event,'ITSAccountNo')">
                      </kendo-textbox>
                      <div class="col-xl-7 offset-xl-5 pl-0" style="font-weight:normal; font-size: 12px;">(If
                        applicable)</div>
                      <div *ngIf="!IsValidITSAccountNo" class="invalid-feedback" style="display:block;">
                        <div class="col-xl-7 offset-xl-5 pl-0">
                          Minimum 2 digits required
                        </div>
                      </div>
                      <div *ngIf="!IsValidNumberITSAccountNo" class="invalid-feedback" style="display:block;">
                        <div class="col-xl-7 offset-xl-5 pl-0">
                          Valid No is required
                        </div>
                      </div>




                      <!-- <input
                        type="text"
                        [(ngModel)]="objCompanyInfo.ITSAccountNo"
                        name="ITSAccountNo"
                        formControlName="fcITSAccountNo"
                        placeholder="ITS Account No"
                        class="form-control col-md-8"
                        (keyup)="changeItsNo($event)"
                      /> -->
                    </div>


                    <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 form-group">
                      <label class="col-md-5 label-right pl-0">Type of Work:</label>
                      <kendo-textbox [tabindex]="14" [(ngModel)]="objCompanyInfo.TypeOfWork" [maxlength]="50"
                        name="TypeOfWork" formControlName="fcTypeOfWork" type="text" placeholder="Type of Work"
                        class="p-0 col-xl-7 col-lg-8 col-md-8" (change)="changeInputTrim($event,'TypeOfWork')">
                      </kendo-textbox>
                      <!-- <input
                        [(ngModel)]="objCompanyInfo.TypeOfWork"
                        name="TypeOfWork"
                        formControlName="fcTypeOfWork"
                        type="text"
                        placeholder="Type of Work"
                        class="form-control col-md-8"
                      /> -->
                    </div>


                    <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 form-group">
                      <label id="lbl_Federal_Tax_ID " class="col-md-5 label-right pl-0"><strong
                          class="required-fileds">* </strong>Federal Tax
                        ID :</label>

                      <kendo-maskedtextbox [tabindex]="15" [(ngModel)]="objCompanyInfo.FederalTaxId" name="FederalTaxId"
                        formControlName="fcFederalTaxId" inputMask="00-0000000" [ngClass]="{
                          'is-invalid': submitted && cf['fcFederalTaxId'].errors
                        }" type="text" placeholder="Federal Tax ID " class="p-0 col-xl-4 col-lg-5 col-md-5"
                        (keyup)="changeTaxIdNo($event)" [maxlength]="50" [mask]="Der_tax_no_mask">
                      </kendo-maskedtextbox>

                      <!-- <input
                        [(ngModel)]="objCompanyInfo.FederalTaxId"
                        name="FederalTaxId"
                        formControlName="fcFederalTaxId"
                        [ngClass]="{
                          'is-invalid': submitted && cf['fcFederalTaxId'].errors
                        }"
                        type="text"
                        placeholder="Federal Tax ID "
                        class="form-control col-md-8"
                        (keyup)="changeTaxIdNo($event)"
                      /> -->
                      <div *ngIf="submitted && cf['fcFederalTaxId'].errors" class="invalid-feedback">
                        <div class="col-xl-7 offset-xl-5 pl-0" *ngIf="cf['fcFederalTaxId'].errors['required']">
                          Federal Tax ID is required
                        </div>
                      </div>
                    </div>

                    <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 form-group">
                      <label id="lbl_pipeline_operators" class="col-md-5 label-right pl-0 align-middle"><strong
                          class="required-fileds">* </strong> Are you an
                        Oil & Gas Operator:</label>
                      <!-- <input type="checkbox" [(ngModel)]="objCompanyInfo.IsOilAndGasOperator" name="IsOilAndGasOperator" formControlName="fcIsOilAndGasOperator" class="form-control col-md-8 w-auto" /> -->
                      <kendo-dropdownlist [tabindex]="16" [data]="YesNoItems1"
                        [(ngModel)]="objCompanyInfo.IsOilAndGasOperator" name="IsOilAndGasOperator"
                        formControlName="fcIsOilAndGasOperator" class="col-xl-4 col-lg-5 col-md-5 p-0 seleted_dropdown"
                        [ngClass]="{
                        'is-invalid': submitted && cf['fcIsOilAndGasOperator'].errors
                      }"> </kendo-dropdownlist>
                      <!-- <select [(ngModel)]="objCompanyInfo.IsOilAndGasOperator" name="IsOilAndGasOperator"
                        formControlName="fcIsOilAndGasOperator" type="text" placeholder="Select"
                        class="form-control col-md-8 seleted_dropdown" [ngClass]="{
                          'is-invalid':
                            submitted && cf['fcIsOilAndGasOperator'].errors
                        }">
                        <option>YES</option>
                        <option>NO</option>
                      </select> -->
                      <div *ngIf="submitted && cf['fcIsOilAndGasOperator'].errors" class="invalid-feedback">
                        <div class="col-xl-7 offset-xl-5 pl-0" *ngIf="cf['fcIsOilAndGasOperator'].errors">
                          Oil And Gas Operator is required
                        </div>
                      </div>
                    </div>


                    <!--<div class="col-md-6">
                         <label class="col-md-4 label-right"><strong class="required-fileds">* </strong>Phone No. & Ext.:</label>
                        <input [(ngModel)]="objCompanyInfo.PhysicalPhoneNo" name="PhysicalPhoneNo" formControlName="fcPhysicalPhoneNo" [ngClass]="{ 'is-invalid': submitted && cf['fcPhysicalPhoneNo'].errors }" minlength="14" maxlength="23" inputMask="(000) 000-0000 Ext. 000" type="text"  placeholder="(555) 555-5555 Ext. 555" class="form-control phone col-md-8" (keyup)="changePhoneNo($event)" />
                        <div *ngIf="submitted && cf['fcPhysicalPhoneNo'].errors" class="invalid-feedback">
                          <div class="ms-33" *ngIf="cf['fcPhysicalPhoneNo'].errors['required']">PhoneNo is required</div>  
                          <div class="ms-33" *ngIf="cf['fcPhysicalPhoneNo'].errors['minlength']">Phone No Not Valid</div>
                        </div>
                      </div>
                      <div class="col-md-6">
                         <label class="col-md-4 label-right"><strong class="required-fileds">* </strong>Fax No:</label>
                        <input [(ngModel)]="objCompanyInfo.PhysicalFaxNo" name="PhysicalFaxNo" inputMask="00000000000000" formControlName="fcPhysicalFaxNo" [ngClass]="{ 'is-invalid': submitted && cf['fcPhysicalFaxNo'].errors }" type="text" id="txt_fax_no" placeholder="Fax No." class="form-control col-md-4" />
                        <div *ngIf="submitted && cf['fcPhysicalFaxNo'].errors" class="invalid-feedback">
                          <div class="ms-33" *ngIf="cf['fcPhysicalFaxNo'].errors['required']">Fax No. is required</div>
                        </div> 
                      </div> -->

                    <div class="col-md-10 col-lg-10 col-xl-9 offset-xl-1 form-group">
                      <label class="col-xl-9 form-label pl-0">List the Oil & Gas Operators you work for <span
                          style="font-size: 12px; font-weight: normal;"> (If applicable)</span>: </label>
                      <kendo-textarea resizable="none" [rows]="6" type="text" name="OilAndGasOperatorCompanyNames"
                        formControlName="fcOilAndGasOperatorCompanyNames" placeholder="List of Pipeline Operators"
                        class=" px-0" [(ngModel)]="objCompanyInfo.OilAndGasOperatorCompanyNames"
                        (change)="changeInputTrim($event,'OilAndGasOperatorCompanyNames')">
                      </kendo-textarea>

                      <!-- <textarea
                        [(ngModel)]="
                          objCompanyInfo.OilAndGasOperatorCompanyNames
                        "
                        name="OilAndGasOperatorCompanyNames"
                        formControlName="fcOilAndGasOperatorCompanyNames"
                        placeholder="List of Pipeline Operators"
                        class="form-control mt-1"
                      >
                      </textarea> -->
                    </div>

                    <div class="col-md-10 col-lg-10 col-xl-9 offset-xl-1 form-group">
                      <label class="form-label pl-0">Will you be using SUB-CONTRACTORS when working for the
                        above operators? If yes, please list the company
                        names of potential sub-contractors <span style="font-size: 12px; font-weight: normal;"> (If
                          applicable)</span>:</label>
                      <kendo-textarea resizable="none" [rows]="7" type="text"
                        [(ngModel)]="objCompanyInfo.SubContractorCompanyNames" name="SubContractorCompanyNames"
                        formControlName="fcSubContractorCompanyNames"
                        (change)="changeInputTrim($event,'SubContractorCompanyNames')"
                        placeholder="List of Sub-Contractors" class=" px-0">
                      </kendo-textarea>

                      <!-- <textarea
                        [(ngModel)]="objCompanyInfo.SubContractorCompanyNames"
                        name="SubContractorCompanyNames"
                        formControlName="fcSubContractorCompanyNames"
                        placeholder="List of Pipeline Operators"
                        class="form-control mt-1"
                      >
                      </textarea> -->
                    </div>
                    <!--<div class="col-md-12">
                        <label class="col-md-2 label-right align-top">List the Oil & Gas Operators you work for:</label>
                        <textarea placeholder="List of Pipeline Operators" class="form-control col-md-10"> </textarea>
                      </div>
                                        <div class="col-md-12">
                                          <label class="col-md-6 label-right align-top">Will you be using SUB-CONTRACTORS when working for the above operators? If yes, please list list the company names of potential sub-contracotrs:</label>
                                          <textarea placeholder="List of Pipeline Operators" class="form-control col-md-6"> </textarea>
                                        </div>-->

                    <!-- <div class="col-md-10 col-lg-10 col-xl-9 offset-xl-1 form-group">
                      <label class="form-label pl-0">Please list the auditing agencies your company information should
                        go to (i.e. NCMS, Veriforce, etc.)</label>

                        <kendo-textarea resizable="none" [rows]="7" type="text"
                        [(ngModel)]="objCompanyInfo.ListOfAgencies" name="ListOfAgencies"
                        formControlName="fcListOfAgencies" placeholder="List of Auditing Agencies"
                        class=" px-0">
                      </kendo-textarea>

                       
                    </div> -->

                    <div class="col-md-10 col-lg-10 col-xl-9 offset-xl-1 form-group">
                      <div class="row">
                        <div class="col-xl-5 label-right wraping_div pr-0" style="max-width: 240px; margin-top: .4rem;">
                          <label><strong class="required-fileds">* </strong>How did you hear about PTC? </label>
                        </div>
                        <div class="col-xl-9">
                          <div class="d-inline-table custom_checkbox me-2">
                            <input type="checkbox" kendoCheckBox type="checkbox" name="test" id="NCMS" [checked]="
                                HearAboutPtcCurrentlyChecked === check_box_type.NCMS
                              " (click)="
                                HearAboutPtcCheckBoxChanged(check_box_type.NCMS)
                              " class="form-check-input" />
                            <label for="NCMS">NCMS</label>
                          </div>
                          <div class="d-inline-table custom_checkbox me-2">
                            <input type="checkbox" kendoCheckBox name="test" id="AnotherPtcMember" [checked]="
                                HearAboutPtcCurrentlyChecked ===
                                check_box_type.AnotherPtcMember
                              " (click)="
                                HearAboutPtcCheckBoxChanged(
                                  check_box_type.AnotherPtcMember
                                )
                              " class="form-check-input" />
                            <label for="AnotherPtcMember">Another PTC Member</label>
                          </div>
                          <div class="d-inline-table custom_checkbox me-2">
                            <input type="checkbox" kendoCheckBox name="test" id="OwnerOperator" [checked]="
                                HearAboutPtcCurrentlyChecked ===
                                check_box_type.OwnerOperator
                              " (click)="
                                HearAboutPtcCheckBoxChanged(
                                  check_box_type.OwnerOperator
                                )
                              " class="form-check-input" />
                            <label for="OwnerOperator">Owner/Operator</label>
                          </div>
                          <div class="d-inline-table custom_checkbox me-2">
                            <input type="checkbox" kendoCheckBox name="test" id="InternetSearch" [checked]="
                                HearAboutPtcCurrentlyChecked ===
                                check_box_type.InternetSearch
                              " (click)="
                                HearAboutPtcCheckBoxChanged(
                                  check_box_type.InternetSearch
                                )
                              " class="form-check-input" />
                            <label for="InternetSearch">Internet Search</label>
                          </div>
                          <div class="d-inline-table custom_checkbox me-2">
                            <input type="checkbox" kendoCheckBox name="test" id="OnlineAd" [checked]="
                                HearAboutPtcCurrentlyChecked ===
                                check_box_type.OnlineAd
                              " (click)="
                                HearAboutPtcCheckBoxChanged(
                                  check_box_type.OnlineAd
                                )
                              " class="form-check-input" />
                            <label for="OnlineAd">Online Ad</label>
                          </div>
                          <div class="d-inline-table custom_checkbox me-2">
                            <input type="checkbox" kendoCheckBox name="test" id="Other" [checked]="
                                HearAboutPtcCurrentlyChecked ===
                                check_box_type.Other
                              " (click)="
                                HearAboutPtcCheckBoxChanged(check_box_type.Other)
                              " name="test" class="form-check-input" />
                            <label for="Other">Other</label>

                            <!-- <textarea 
                            *ngIf="currDiv == 'HearAboutPtcOther'"
                            id="HearAboutPtcOther" 
                            class="form-control col-md-3 ms-3 form-check-input m-1">
                          </textarea> -->
                          </div>

                          <div *ngIf="objCompanyInfo.HearAboutPTC === 8" class="d-inline">
                            <kendo-textbox type="text" placeholder="Other" [maxlength]="50"
                              [(ngModel)]="objCompanyInfo.HearAboutPTCOther"
                              (change)="changeInputTrim($event,'HearAboutPTCOther')" name="HearAboutPTCOther"
                              formControlName="fcHearAboutPTCOther" class="p-0 mt-2 col-xl-12 col-lg-8 col-md-10">
                            </kendo-textbox>

                            <!-- <input
                              style="margin-left: -15px"
                              type="text"
                              placeholder="Other"
                              [(ngModel)]="objCompanyInfo.HearAboutPTCOther"
                              name="HearAboutPTCOther"
                              formControlName="fcHearAboutPTCOther"
                              class="form-control col-xl-4 col-lg-10 col-md-12"
                            /> -->
                          </div>

                          <!-- <div class="form-check form-check-inline ms-2">
                              <input type="checkbox"  name="test"
                              [checked]="HearAboutPtcCurrentlyChecked === check_box_type.AnotherPtcMember"
                              (click)="HearAboutPtcCheckBoxChanged(check_box_type.AnotherPtcMember)" class="form-check-input" />
                              <label class="form-check-label">Another PTC Member?</label>
                            </div>
                            <div class="form-check form-check-inline ms-4">
                              <input type="checkbox" name="test"
                              [checked]="HearAboutPtcCurrentlyChecked === check_box_type.InternetSearch"
                              (click)="HearAboutPtcCheckBoxChanged(check_box_type.InternetSearch)" class="form-check-input" />
                              <label class="form-check-label">Internet Search?</label>
                            </div>
                            <div class="form-check form-check-inline ms-4">
                              <input type="checkbox" name="test"
                              [checked]="HearAboutPtcCurrentlyChecked === check_box_type.NCMS"
                              (click)="HearAboutPtcCheckBoxChanged(check_box_type.NCMS)" class="form-check-input" />
                              <label class="form-check-label">NCMS?</label>
                            </div>
                            <div class="form-check form-check-inline ms-4">
                              <input type="checkbox"  name="test"
                              [checked]="HearAboutPtcCurrentlyChecked === check_box_type.Other"
                              (click)="HearAboutPtcCheckBoxChanged(check_box_type.Other)" name="test"
                              class="form-check-input" />
                              <label class="form-check-label">Other</label>
                              <input class="form-control ms-2 mt-2" type="text" placeholder="Other" />
                            </div> -->
                        </div>
                      </div>
                      <div class="invalid-feedback d-block" *ngIf="hearAboutPTCError === 'show'">
                        Please choose at least one checkbox for How did you hear about PTC
                      </div>
                      <div class="invalid-feedback d-block" *ngIf="hearAboutPTCOtherError">
                        Please enter how you heard about PTC
                      </div>
                    </div>
                  </div>
                  <h3 class="fs-subtitle">
                    Designated Employee Representative (DER)
                    <ng-template #htmlContent>
                      <p id="tooltip-innerp"><u><b>Designated employer representative (DER).</b></u> An employee
                        authorized by the employer to take immediate action(s) to remove employees from safety-sensitive
                        duties, or cause employees to be removed from these covered duties, and to make required
                        decisions in the testing and evaluation processes. The DER also receives test results and other
                        communications for the employer, consistent with the requirements of this part.
                      </p>
                    </ng-template>
                    <button class="tooltip_btn" [ngbTooltip]="htmlContent" tooltipClass="custom-class" placement="right"
                      data-html="true">
                      <i class="tooltip_icon">i</i>
                    </button>


                  </h3>
                  <div class="row">
                    <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 form-group">
                      <label class="col-md-5 label-right pl-0">
                        <strong class="required-fileds">* </strong>DER Name:</label>
                      <kendo-textbox type="text" placeholder="DER Name" [(ngModel)]="objCompanyInfo.objDer.Name"
                        [maxlength]="50" name="DerName" formControlName="fcDerName"
                        (change)="changeInputTrim($event,'DerName')" class="p-0 col-xl-7 col-lg-8 col-md-8" [ngClass]="{
                          'is-invalid': submitted && cf['fcDerName'].errors
                        }">
                      </kendo-textbox>

                      <!-- <input
                        type="text"
                        placeholder="DER Name"
                        [(ngModel)]="objCompanyInfo.objDer.Name"
                        name="DerName"
                        formControlName="fcDerName"
                        class="form-control col-md-8"
                        [ngClass]="{
                          'is-invalid': submitted && cf['fcDerName'].errors
                        }"
                      /> -->
                      <div *ngIf="submitted && cf['fcDerName'].errors" class="invalid-feedback">
                        <div class="col-xl-7 offset-xl-5 pl-0" *ngIf="cf['fcDerName'].errors['required']">
                          DER Name is required
                        </div>
                      </div>
                    </div>
                    <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 form-group">
                      <label class="col-md-5 label-right pl-0"><strong class="required-fileds">* </strong>DER
                        Title:</label>
                      <kendo-textbox type="text" placeholder="DER Title" [(ngModel)]="objCompanyInfo.objDer.Title"
                        [maxlength]="50" name="Title" formControlName="fcDerTitle"
                        class="p-0 col-xl-7 col-lg-8 col-md-8" (change)="changeInputTrim($event,'DerTitle')" [ngClass]="{
                          'is-invalid': submitted && cf['fcDerTitle'].errors
                        }">
                      </kendo-textbox>

                      <!-- <input
                        type="text"
                        placeholder="DER Title"
                        [(ngModel)]="objCompanyInfo.objDer.Title"
                        name="Title"
                        formControlName="fcDerTitle"
                        class="form-control col-md-8"
                        [ngClass]="{
                          'is-invalid': submitted && cf['fcDerTitle'].errors
                        }"
                      /> -->
                      <div *ngIf="submitted && cf['fcDerTitle'].errors" class="invalid-feedback">
                        <div class="col-xl-7 offset-xl-5 pl-0" *ngIf="cf['fcDerTitle'].errors['required']">
                          DER Title is required
                        </div>
                      </div>
                    </div>



                    <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6">
                      <div class="row">
                        <div class="col-xl-9 col-lg-5 col-md-5 col-sm-8 px-sm-0 padding-ext form-group">
                          <label class="col-xl-7 col-lg-6 col-md-6 label-right-ext pl-0"><strong
                              class="required-fileds">*
                            </strong>DER Phone No:</label>
                          <!-- minlength="12" -->
                          <kendo-maskedtextbox [(ngModel)]="objCompanyInfo.objDer.PhoneNo" name="PhoneNo"
                            formControlName="fcDerPhoneNo" inputMask="000-000-0000" type="text" id="der_phone_no"
                            placeholder="555-555-5555" class="p-0 margin-rev-left phone col-xl-5 col-lg-12 col-md-12"
                            [ngClass]="{
          'is-invalid':
            submitted && cf['fcDerPhoneNo'].errors
        }" [mask]="Der_Phone_no_mask"></kendo-maskedtextbox>

                          <!-- <input
        [(ngModel)]="objCompanyInfo.objDer.PhoneNo"
        name="PhoneNo"
        minlength="12"
        formControlName="fcDerPhoneNo"
        inputMask="000-000-0000"
        type="text"
        id="der_phone_no"
        placeholder="555-555-5555"
        class="form-control phone col-xl-6 col-lg-9 col-md-6"
        [ngClass]="{
          'is-invalid':
            submitted && cf['fcDerPhoneNo'].errors
        }"
      /> -->

                          <!-- UnCommond Validation -->
                          <div *ngIf="submitted && cf['fcDerPhoneNo'].errors"
                            class="invalid-feedback col-xl-8 offset-xl-6 pl-0 valition_ext_pl">
                            <div class="" *ngIf="cf['fcDerPhoneNo'].errors['required']">
                              DER Phone No is required
                            </div>
                            <!-- <div
          class=""
          *ngIf="cf['fcDerPhoneNo'].errors['minlength']"
        >
          Der Phone No Not Valid
        </div> -->
                          </div>

                        </div>

                        <div class="col-lg-3 col-md-3 col-sm-4 form-group pl-sm-1 p_md_lg_right">
                          <label class="col-md-4 pl-0 label-right text-nowrap">Ext:</label>
                          <kendo-textbox [(ngModel)]="objCompanyInfo.objDer.ExtensionNo"
                            formControlName="fcDerExtensionNo" placeholder="Ext."
                            class="p-0 col-xl-8 col-lg-12 col-md-12" (keypress)="ExtensionNoKeyPress($event)"
                            (change)="changeInputTrim($event,'DerExtension')"
                            (keyup)="changeExtensionNo($event,'DerExtension')">
                          </kendo-textbox>
                          <div *ngIf="!objExtenions.IsValidDerExtensions" class="invalid-feedback"
                            style="display:block;">
                            <div class="col-xl-7 offset-xl-4 px-0">
                              Minimum 3 digits required
                            </div>
                          </div>
                          <div *ngIf="!objExtenions.IsValidNumberDerExtensions" class="invalid-feedback"
                            style="display:block;">
                            <div class="col-xl-7 offset-xl-4 px-0">
                              Invalid Ext. No
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>



                    <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 form-group">
                      <label class="col-md-5 label-right pl-0"><strong class="required-fileds">* </strong>DER Cell
                        No:</label>
                      <kendo-maskedtextbox [(ngModel)]="objCompanyInfo.objDer.CellNo" name="PhoneCellNo"
                        formControlName="fcDerCellNo" inputMask="000-000-0000" type="text" placeholder="555-555-5555"
                        class="p-0 col-xl-4 col-lg-5 col-md-5" [ngClass]="{
                          'is-invalid': submitted && cf['fcDerCellNo'].errors
                        }" [mask]="Der_Phone_no_mask"></kendo-maskedtextbox>

                      <!-- <input
                        minlength="12"
                        [(ngModel)]="objCompanyInfo.objDer.CellNo"
                        name="PhoneCellNo"
                        formControlName="fcDerCellNo"
                        inputMask="000-000-0000"
                        type="text"
                        placeholder="555-555-5555"
                        class="form-control col-md-8"
                        [ngClass]="{
                          'is-invalid': submitted && cf['fcDerCellNo'].errors
                        }"
                      /> -->
                      <div *ngIf="submitted && cf['fcDerCellNo'].errors" class="invalid-feedback">
                        <div class="col-xl-7 offset-xl-5 pl-0" *ngIf="cf['fcDerCellNo'].errors['required']">
                          DER Cell No is required
                        </div>
                        <!-- <div
                          class="ms-33"
                          *ngIf="cf['fcDerCellNo'].errors['minlength']"
                        >
                          Der Cell No Not Valid
                        </div> -->
                      </div>
                    </div>
                    <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 form-group">
                      <label class="col-md-5 label-right pl-0"><strong class="required-fileds">* </strong>DER
                        Email:</label>
                      <kendo-textbox type="text" [(ngModel)]="objCompanyInfo.objDer.Email" name="Email" [maxlength]="50"
                        formControlName="fcDerEmail" placeholder="DER Email" class="p-0 col-xl-7 col-lg-8 col-md-8"
                        (change)="changeInputTrim($event,'DerEmail')" [ngClass]="{
                          'is-invalid': submitted && cf['fcDerEmail'].errors
                        }">
                      </kendo-textbox>

                      <!-- <input
                        type="text"
                        [(ngModel)]="objCompanyInfo.objDer.Email"
                        name="Email"
                        formControlName="fcDerEmail"
                        placeholder="DER Email"
                        class="form-control col-md-8"
                        [ngClass]="{
                          'is-invalid': submitted && cf['fcDerEmail'].errors
                        }"
                      /> -->
                      <div *ngIf="submitted && cf['fcDerEmail'].errors" class="invalid-feedback">
                        <div class="col-xl-7 offset-xl-5 pl-0" *ngIf="cf['fcDerEmail'].errors['required']">
                          DER Email is required
                        </div>
                      </div>
                    </div>
                    <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 form-group">
                      <label class="col-md-5 label-right pl-0">DER Fax:</label>
                      <kendo-maskedtextbox type="text" [(ngModel)]="objCompanyInfo.objDer.FaxNo" placeholder="DER Fax"
                        formControlName="fcDerFaxNo" class="p-0 col-xl-4 col-lg-5 col-md-5" [ngClass]="{
                          'is-invalid': submitted && cf['fcDerFaxNo'].errors
                        }" inputMask="000-000-0000" placeholder="555-555-5555" [mask]="Der_Phone_no_mask">
                      </kendo-maskedtextbox>

                      <!-- <input
                        type="text"
                        [(ngModel)]="objCompanyInfo.objDer.FaxNo"
                        placeholder="DER Fax"
                        formControlName="fcDerFaxNo"
                        class="form-control col-md-8"
                        [ngClass]="{
                          'is-invalid': submitted && cf['fcDerFaxNo'].errors
                        }"
                      /> -->
                      <div *ngIf="submitted && cf['fcDerFaxNo'].errors" class="invalid-feedback">
                        <div class="col-xl-7 offset-xl-5 pl-0" *ngIf="cf['fcDerFaxNo'].errors['required']">
                          DER Fax No is required
                        </div>
                      </div>
                    </div>
                    <!-- </div> -->
                    <!-- <div *ngIf="isShownbtnAddDerInfo">
                      <button clas="ms-auto mb-4" type="button"
                              class="btn btn-primary"
                              name="btnAddDerInfo"
                              id="btnShowDer" (click)="toggleDerSection()">
  
                        Add Another Alternate DER
                      </button>
                    </div> -->
                    <!-- <div *ngIf="isShownDerSection" class="row der-section mt-2"> -->
                    <!-- <div class="row der-section mt-2"> Replace this line wih above in case revert back -->
                    <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 form-group">
                      <label class="col-md-5 label-right pl-0"><strong class="required-fileds">* </strong>Alt. DER
                        Name:</label>
                      <kendo-textbox type="text" [(ngModel)]="objCompanyInfo.objDer.AlternateName" name="AlternateName"
                        [maxlength]="50" formControlName="fcDerAlternateName"
                        (change)="changeInputTrim($event,'DerAlternateName')" placeholder="Alternate DER Name"
                        class="p-0 col-xl-7 col-lg-8 col-md-8" [ngClass]="{
                          'is-invalid':
                            submitted && cf['fcDerAlternateName'].errors
                        }">
                      </kendo-textbox>
                      <!-- <input
                        type="text"
                        [(ngModel)]="objCompanyInfo.objDer.AlternateName"
                        name="AlternateName"
                        formControlName="fcDerAlternateName"
                        placeholder="Alternate DER Name"
                        class="form-control col-md-8"
                        [ngClass]="{
                          'is-invalid':
                            submitted && cf['fcDerAlternateName'].errors
                        }"
                      /> -->
                      <div *ngIf="submitted && cf['fcDerAlternateName'].errors" class="invalid-feedback">
                        <div class="col-xl-7 offset-xl-5 pl-0" *ngIf="cf['fcDerAlternateName'].errors['required']">
                          Alt. DER Name is required
                        </div>
                      </div>
                      <!-- <div *ngIf="submitted && cf['fcFederalTaxId'].errors" class="invalid-feedback">
                          <div class="ms-33" *ngIf="cf['fcFederalTaxId'].errors['required']">FederalTaxId. is required</div>
                        </div> -->
                    </div>





                    <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6">
                      <div class="row">

                        <div class="col-xl-9 col-lg-5 col-md-5 col-sm-8 px-sm-0 padding-ext form-group">
                          <label class="col-xl-7 col-lg-6 col-md-6 label-right-ext pl-0 text-nowrap"><strong
                              class="required-fileds">*
                            </strong>Alt. DER Phone No:</label>
                          <!-- minlength="12" -->
                          <kendo-maskedtextbox [(ngModel)]="objCompanyInfo.objDer.AlternatePhoneNo"
                            name="AlternatePhoneNo" formControlName="fcDerAlternatePhoneNo" inputMask="000-000-0000"
                            placeholder="555-555-5555" type="text"
                            class="p-0 margin-rev-left phone col-xl-5 col-lg-12 col-md-12" [ngClass]="{
          'is-invalid':
            submitted && cf['fcDerAlternatePhoneNo'].errors
        }" [mask]="Der_Phone_no_mask"></kendo-maskedtextbox>
                          <!-- <input
        [(ngModel)]="objCompanyInfo.objDer.AlternatePhoneNo"
        name="AlternatePhoneNo"
        minlength="12"
        formControlName="fcDerAlternatePhoneNo"
        inputMask="000-000-0000"
        placeholder="555-555-5555"
        type="text"
        class="form-control phone col-xl-6 col-lg-9 col-md-6"
        [ngClass]="{
          'is-invalid':
            submitted && cf['fcDerAlternatePhoneNo'].errors
        }"
      /> -->
                          <div *ngIf="
          submitted && cf['fcDerAlternatePhoneNo'].errors
        " class="invalid-feedback col-xl-8 offset-xl-6 pl-0 valition_ext_pl">
                            <div class="" *ngIf="
            cf['fcDerAlternatePhoneNo'].errors['required']
          ">
                              Alt. DER Phone No is required
                            </div>
                            <!-- <div
          class=""
          *ngIf="
            cf['fcDerAlternatePhoneNo'].errors['minlength']
          "
        >
          Alt Phone No Not Valid
        </div> -->
                          </div>
                        </div>

                        <div class="col-lg-3 col-md-3 col-sm-4 form-group pl-sm-1 p_md_lg_right">
                          <label class="col-md-4 pl-0 label-right text-nowrap">Ext:</label>

                          <kendo-textbox [(ngModel)]="
          objCompanyInfo.objDer.AlternateExtensionNo" placeholder="Ext." name="AlternateExtensionNo"
                            formControlName="fcDerAlternateExtensionNo" class="p-0 col-xl-8 col-lg-12 col-md-12"
                            (change)="changeInputTrim($event,'AlternateDerExtension')"
                            (keypress)="ExtensionNoKeyPress($event)"
                            (keyup)="changeExtensionNo($event,'AlternateDerExtension')">
                          </kendo-textbox>
                          <div *ngIf="!objExtenions.IsValidAlternateDerExtensions" class="invalid-feedback"
                            style="display:block;">
                            <div class="col-xl-7 offset-xl-4 px-0">
                              Minimum 3 digits required
                            </div>
                          </div>
                          <div *ngIf="!objExtenions.IsValidNumberAlternateDerExtensions" class="invalid-feedback"
                            style="display:block;">
                            <div class="col-xl-7 offset-xl-4 px-0">
                              Invalid Ext. No
                            </div>
                          </div>
                          <!-- <input
        type="number"
        inputMask="000"
        maxlength="3"
        [(ngModel)]="
          objCompanyInfo.objDer.AlternateExtensionNo
        "
        name="AlternateExtensionNo"
        formControlName="fcDerAlternateExtensionNo"
        placeholder="555"
        class="form-control col-xl-4 col-lg-5 col-md-6"
      /> -->
                          <div *ngIf="
          submitted && cf['fcDerAlternatePhoneNo'].errors
        " class="invalid-feedback">
                            <div class="col-xl-7 offset-xl-5 pl-0" *ngIf="
            cf['fcDerAlternatePhoneNo'].errors['required']
          ">
                              Alt. DER Phone No is required
                            </div>
                          </div>
                        </div>


                      </div>
                    </div>


                    <!--<div class="col-md-6">
                       
                      </div>-->
                    <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 form-group">
                      <label class="col-md-5 label-right pl-0"><strong class="required-fileds">* </strong>Alt. DER Cell
                        No:</label>
                      <!-- minlength="12" -->
                      <kendo-maskedtextbox [(ngModel)]="objCompanyInfo.objDer.AlternateCellNo"
                        name="PhoneAlternateCellNo" formControlName="fcDerAlternateCellNo" inputMask="000-000-0000"
                        type="text" placeholder="555-555-5555" class="p-0 col-xl-4 col-lg-5 col-md-5" [ngClass]="{
                          'is-invalid':
                            submitted && cf['fcDerAlternateCellNo'].errors
                        }" [mask]="Der_Phone_no_mask"></kendo-maskedtextbox>
                      <!-- <input
                        maxlength="17"
                        minlength="12"
                        [(ngModel)]="objCompanyInfo.objDer.AlternateCellNo"
                        name="PhoneAlternateCellNo"
                        formControlName="fcDerAlternateCellNo"
                        inputMask="000-000-0000"
                        type="text"
                        placeholder="555-555-5555"
                        class="form-control col-md-8"
                        [ngClass]="{
                          'is-invalid':
                            submitted && cf['fcDerAlternateCellNo'].errors
                        }"
                      /> -->
                      <div *ngIf="submitted && cf['fcDerAlternateCellNo'].errors" class="invalid-feedback">
                        <div class="col-xl-7 offset-xl-5 pl-0" *ngIf="cf['fcDerAlternateCellNo'].errors['required']">
                          Alt. DER Cell No is required
                        </div>
                        <!-- <div
                          class="ms-33"
                          *ngIf="cf['fcDerAlternateCellNo'].errors['minlength']"
                        >
                          Alternate Der Cell No is not required
                        </div> -->
                      </div>
                    </div>
                    <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 form-group">
                      <label class="col-md-5 label-right pl-0"><strong class="required-fileds">* </strong>Alt. DER
                        Email:</label>
                      <kendo-textbox type="text" [(ngModel)]="objCompanyInfo.objDer.AlternateEmail" [maxlength]="50"
                        name="AlternateEmail" formControlName="fcDerAlternateEmail" placeholder="Alternate DER Email"
                        (change)="changeInputTrim($event,'AlternateDerEmail')" class="p-0 col-xl-7 col-lg-8 col-md-8"
                        [ngClass]="{
                          'is-invalid':
                            submitted && cf['fcDerAlternateEmail'].errors
                        }">
                      </kendo-textbox>
                      <!-- <input
                        type="text"
                        [(ngModel)]="objCompanyInfo.objDer.AlternateEmail"
                        name="AlternateEmail"
                        formControlName="fcDerAlternateEmail"
                        placeholder="Alternate DER Email"
                        class="form-control col-md-8"
                        [ngClass]="{
                          'is-invalid':
                            submitted && cf['fcDerAlternateEmail'].errors
                        }"
                      /> -->
                      <div *ngIf="submitted && cf['fcDerAlternateEmail'].errors" class="invalid-feedback">
                        <div class="col-xl-7 offset-xl-5 pl-0" *ngIf="cf['fcDerAlternateEmail'].errors['required']">
                          Alt. DER Email is required
                        </div>
                      </div>
                    </div>
                    <!-- <div class="col-md-6 mt-2">
                        <label class="col-md-4"></label>
  
                        <button type="button"
                                class="col-md-2 btn btn-primary"
                                name="btnAddDerInfo"
                                id="btnAddDerInfo" (click)="AddDer()">
                          Save
                        </button>
                        <label class="col-md-2"></label>
  
                        <button type="button"
                                class="col-md-2 btn btn-warning"
                                name="btnClearDerInfo"
                                id="btnClearDerInfo" (click)="ClearDer()">
                          Cancel
                        </button>
                        <label class="col-md-2"></label>
                      </div> -->
                  </div>
                  <!-- <div class="row">
  
                      <div class="col-md-12 mt-2">
                        <table class="lstTable">
                          <tr>
                            <th>DER Name</th>
                            <th>DER Phone No.</th>
                            <th>DER Cell No</th>
                            <th>DER Email</th>
                            <th>Edit</th>
                          </tr>
                          <tr *ngFor="let der of lstDer">
                            <td>{{der.AlternateName}}</td>
                            <td>{{der.AlternatePhoneNo}}</td>
                            <td>{{der.AlternateCellNo}}</td>
                            <td>{{der.AlternateEmail}}</td>
                            <td>
                              <button type="button"
                                      class="btn btn-info"
                                      (click)="EditDerInfo(der.Id)">
                                Edit
                              </button>
                            </td>
                          </tr>
                        </table>
                      </div>
  
  
                    </div> -->
                  <h3 class="fs-subtitle mt-3">Billing Contact</h3>
                  <div class="row">
                    <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 form-group">
                      <label class="col-md-5 label-right pl-0"><strong class="required-fileds">*
                        </strong>Country:</label>
                      <kendo-dropdownlist [data]="CountryItems" formControlName="fcBillingCountry"
                        (selectionChange)="changeBillingCountry($event)"
                        class="col-xl-7 col-lg-8 col-md-8 p-0 seleted_dropdown"
                        [(ngModel)]="objCompanyInfo.BillingContact.BillingCountry" id="txt_state" placeholder="Country"
                        [ngClass]="{
                      'is-invalid': submitted && cf['fcBillingCountry'].errors
                    }"> </kendo-dropdownlist>

                    </div>
                    <div *ngIf="submitted && cf['fcBillingCountry'].errors" class="invalid-feedback">
                      <div class="col-xl-7 offset-xl-5 pl-0" *ngIf="cf['fcBillingCountry'].errors">
                        Country is required
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 form-group">
                      <label class="col-md-5 label-right pl-0"><strong class="required-fileds">* </strong>Contact
                        Name:</label>
                      <kendo-textbox type="text" [(ngModel)]="objCompanyInfo.BillingContact.BillingContactName"
                        [maxlength]="50" name="BillingContactName" formControlName="fcBillingContactName"
                        placeholder="Contact Name" (change)="changeInputTrim($event,'BillingContactName')"
                        class="p-0 col-xl-7 col-lg-8 col-md-8" (keyup)="changeBillingContactName($event)" [ngClass]="{
                          'is-invalid':
                            submitted && cf['fcBillingContactName'].errors
                        }">
                      </kendo-textbox>
                      <!-- <input
                        type="text"
                        [(ngModel)]="
                          objCompanyInfo.BillingContact.BillingContactName
                        "
                        name="BillingContactName"
                        formControlName="fcBillingContactName"
                        placeholder="Contact Name"
                        class="form-control col-md-8"
                        (keyup)="changeBillingContactName($event)"
                        [ngClass]="{
                          'is-invalid':
                            submitted && cf['fcBillingContactName'].errors
                        }"
                      /> -->
                      <div *ngIf="submitted && cf['fcBillingContactName'].errors" class="invalid-feedback">
                        <div class="col-xl-7 offset-xl-5 pl-0" *ngIf="cf['fcBillingContactName'].errors['required']">
                          Billing Contact Name is required
                        </div>
                      </div>
                    </div>
                    <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 form-group">
                      <label class="col-md-5 label-right pl-0"><strong class="required-fileds">* </strong>Contact
                        Email:</label>
                      <kendo-textbox type="text" [maxlength]="50" [(ngModel)]="
                          objCompanyInfo.BillingContact.BillingContactEmail
                        " name="BillingContactEmail" formControlName="fcBillingContactEmail"
                        placeholder="Contact Email" class="p-0 col-xl-7 col-lg-8 col-md-8"
                        (keyup)="changeBillingContactEmail($event)"
                        (change)="changeInputTrim($event,'BillingContactEmail')" [ngClass]="{
                          'is-invalid':
                            submitted && cf['fcBillingContactEmail'].errors
                        }">
                      </kendo-textbox>
                      <!-- <input
                        type="text"
                        [(ngModel)]="
                          objCompanyInfo.BillingContact.BillingContactEmail
                        "
                        name="BillingContactEmail"
                        formControlName="fcBillingContactEmail"
                        placeholder="Contact Email"
                        class="form-control col-md-8"
                        (keyup)="changeBillingContactEmail($event)"
                        [ngClass]="{
                          'is-invalid':
                            submitted && cf['fcBillingContactEmail'].errors
                        }"
                      /> -->
                      <div *ngIf="submitted && cf['fcBillingContactEmail'].errors" class="invalid-feedback">
                        <div class="col-xl-7 offset-xl-5 pl-0" *ngIf="cf['fcBillingContactEmail'].errors['required']">
                          Billing Contact Email is required
                        </div>
                      </div>
                    </div>
                    <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 form-group">
                      <label class="col-md-5 label-right pl-0"><strong class="required-fileds">* </strong>Billing
                        Address:</label>
                      <kendo-textbox type="text" [maxlength]="40" [(ngModel)]="
                          objCompanyInfo.BillingContact.BillingAddress
                        " name="BillingAddress" (change)="changeInputTrim($event,'BillingAddress')"
                        formControlName="fcBillingAddress" placeholder="Billing Address"
                        class="p-0 col-xl-7 col-lg-8 col-md-8" (keyup)="changeBillingAddess($event)" [ngClass]="{
                          'is-invalid':
                            submitted && cf['fcBillingAddress'].errors
                        }">
                      </kendo-textbox>

                      <!-- <input
                        type="text"
                        [(ngModel)]="
                          objCompanyInfo.BillingContact.BillingAddress
                        " 
                        name="BillingAddress"
                        formControlName="fcBillingAddress"
                        placeholder="Billing Address"
                        class="form-control col-md-8"
                        (keyup)="changeBillingAddess($event)"
                        [ngClass]="{
                          'is-invalid':
                            submitted && cf['fcBillingAddress'].errors
                        }"
                      /> -->
                      <div *ngIf="submitted && cf['fcBillingAddress'].errors" class="invalid-feedback">
                        <div class="col-xl-7 offset-xl-5 pl-0" *ngIf="cf['fcBillingAddress'].errors['required']">
                          Billing Address is required
                        </div>
                      </div>
                    </div>


                    <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 form-group">
                      <label class="col-md-5 label-right pl-0"><strong class="required-fileds">* </strong>City:</label>
                      <kendo-textbox type="text" [maxlength]="50"
                        [(ngModel)]="objCompanyInfo.BillingContact.BillingCity" name="BillingCity"
                        formControlName="fcBillingCity" placeholder="City" class="p-0 col-xl-7 col-lg-8 col-md-8"
                        (keyup)="changeBillingCity($event)" (change)="changeInputTrim($event,'BillingCity')" [ngClass]="{
                          'is-invalid': submitted && cf['fcBillingCity'].errors
                        }">
                      </kendo-textbox>

                      <!-- <input
                        type="text"
                        [(ngModel)]="objCompanyInfo.BillingContact.BillingCity"
                        name="BillingCity"
                        formControlName="fcBillingCity"
                        placeholder="City"
                        class="form-control col-md-8"
                        (keyup)="changeBillingCity($event)"
                        [ngClass]="{
                          'is-invalid': submitted && cf['fcBillingCity'].errors
                        }"
                      /> -->
                      <div *ngIf="submitted && cf['fcBillingCity'].errors" class="invalid-feedback">
                        <div class="col-xl-7 offset-xl-5 pl-0" *ngIf="cf['fcBillingCity'].errors['required']">
                          Billing City is required
                        </div>
                      </div>
                    </div>
                    <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 form-group">
                      <label class="col-md-5 label-right pl-0"><strong class="required-fileds">*
                        </strong>{{objCompanyInfo.BillingContact.BillingCountry === 'Canada'?'Province':'State'
                        }}:</label>
                      <kendo-dropdownlist [data]="BillingListStates" formControlName="fcBillingState"
                        class="col-xl-7 col-lg-8 col-md-8 px-0 seleted_dropdown" id="txt_state" placeholder="State"
                        [(ngModel)]="objCompanyInfo.BillingContact.BillingState" name="BillingState"
                        (selectionChange)="changeBillingState($event)" [ngClass]="{
                        'is-invalid': submitted && cf['fcBillingState'].errors
                      }"> </kendo-dropdownlist>

                      <div *ngIf="submitted && cf['fcBillingState'].errors" class="invalid-feedback">
                        <div class="col-xl-7 offset-xl-5 pl-0" *ngIf="cf['fcBillingState'].errors">
                          Billing {{objCompanyInfo.BillingContact.BillingCountry === 'Canada'?'Province':'State' }} is
                          required
                        </div>
                      </div>
                    </div>
                    <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 form-group">
                      <label class="col-md-5 label-right pl-0"><strong class="required-fileds">*
                        </strong>{{objCompanyInfo.BillingContact.BillingCountry === 'USA'?'Zip':'Postal Code'
                        }}:</label>
                      <kendo-maskedtextbox type="text" [maxlength]="10"
                        [(ngModel)]="objCompanyInfo.BillingContact.BillingZip" name="BillingZip"
                        formControlName="fcBillingZip" [mask]="BillingZipMask" class="p-0 col-xl-4 col-lg-5 col-md-5"
                        [ngClass]="{
                          'is-invalid': submitted && cf['fcBillingZip'].errors
                        }">
                      </kendo-maskedtextbox>
                      <div *ngIf="submitted && cf['fcBillingZip'].errors" class="invalid-feedback">
                        <div class="col-xl-7 offset-xl-5 pl-0" *ngIf="cf['fcBillingZip'].errors['required']">
                          {{objCompanyInfo.BillingContact.BillingCountry === 'USA'? 'Billing Zip is required':'Billing Postal Code is required'}}
                        </div>
                      </div>
                    </div>

                    <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 form-group">
                      <label class="col-md-5 label-right pl-0"><strong class="required-fileds">* </strong>Billing
                        Phone No:</label>
                      <kendo-maskedtextbox [(ngModel)]="
                          objCompanyInfo.BillingContact.BillingPhoneNo
                        " name="BillingPhoneNo" formControlName="fcBillingPhoneNo" [ngClass]="{
                          'is-invalid':
                            submitted && cf['fcBillingPhoneNo'].errors
                        }" inputMask="000-000-0000" type="text" id="txt_phone_no" placeholder="555-555-5555"
                        class="p-0 phone col-xl-4 col-lg-5 col-md-5" (keyup)="changeBillingPhoneNo($event)"
                        [mask]="Der_Phone_no_mask">
                      </kendo-maskedtextbox>

                      <!-- <input
                        [(ngModel)]="
                          objCompanyInfo.BillingContact.BillingPhoneNo
                        "
                        name="BillingPhoneNo"
                        formControlName="fcBillingPhoneNo"
                        [ngClass]="{
                          'is-invalid':
                            submitted && cf['fcBillingPhoneNo'].errors
                        }"
                        minlength="12"
                        maxlength="23"
                        inputMask="000-000-0000"
                        type="text"
                        id="txt_phone_no"
                        placeholder="555-555-5555"
                        class="form-control phone col-md-8"
                        (keyup)="changeBillingPhoneNo($event)"
                      /> -->
                      <div *ngIf="submitted && cf['fcBillingPhoneNo'].errors" class="invalid-feedback">
                        <div class="col-xl-7 offset-xl-5 pl-0" *ngIf="cf['fcBillingPhoneNo'].errors['required']">
                          Billing Phone No is required
                        </div>
                        <!-- <div
                          class="ms-33"
                          *ngIf="cf['fcBillingPhoneNo'].errors['minlength']"
                        >
                          Billing Phone No Not Valid
                        </div> -->
                      </div>
                    </div>

                    <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 form-group">
                      <label class="col-md-5 label-right pl-0">Billing Fax
                        No:</label>
                      <kendo-maskedtextbox type="text" [(ngModel)]="objCompanyInfo.BillingContact.BillingFaxNo"
                        name="BillingFaxNo" formControlName="fcBillingFaxNo" placeholder="Billing Fax No."
                        class="p-0 col-xl-4 col-lg-5 col-md-5" (keyup)="changeBillingFaxNo($event)" [ngClass]="{
                          'is-invalid': submitted && cf['fcBillingFaxNo'].errors
                        }" inputMask="000-000-0000" placeholder="555-555-5555" [mask]="Der_Phone_no_mask">
                      </kendo-maskedtextbox>
                      <!-- <input
                        type="text"
                        [(ngModel)]="objCompanyInfo.BillingContact.BillingFaxNo"
                        name="BillingFaxNo"
                        formControlName="fcBillingFaxNo"
                        placeholder="Billing Fax No."
                        class="form-control col-md-8"
                        (keyup)="changeBillingFaxNo($event)"
                        [ngClass]="{
                          'is-invalid': submitted && cf['fcBillingFaxNo'].errors
                        }"
                      /> -->
                      <div *ngIf="submitted && cf['fcBillingFaxNo'].errors" class="invalid-feedback">
                        <div class="col-xl-7 offset-xl-5 pl-0" *ngIf="cf['fcBillingFaxNo'].errors['required']">
                          Billing Fax No is required
                        </div>
                      </div>
                    </div>
                    <!-- </div> -->
                    <!-- <div class="row">
                      <div class="col-md-12">
  
                        <button clas="col-md-12" type="button"
                                class="btn btn-primary"
                                (click)="toggleBillingContactInfoSection()">
                          Add Another Billing Contact
                        </button>
                      </div>
                    </div> -->
                    <!-- <div *ngIf="isShownBillingContactInfoSection" class="row der-section mt-2"> -->

                    <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 form-group">
                      <label class="col-md-5 label-right pl-0">Alt. Contact Name:</label>
                      <kendo-textbox type="text" [maxlength]="50" [ngClass]="{
                          'is-invalid':
                            submitted && cf['fcOtherBillingContactName'].errors
                        }" [(ngModel)]="objBillingInfo.OtherBillingContactName" name="OtherBillingContactName"
                        formControlName="fcOtherBillingContactName"
                        (change)="changeInputTrim($event,'OtherBillingContactName')"
                        placeholder="Other Billing Contact Name" class="p-0 col-xl-7 col-lg-8 col-md-8">
                      </kendo-textbox>
                      <!-- <input
                        type="text"
                        [ngClass]="{
                          'is-invalid':
                            submitted && cf['fcOtherBillingContactName'].errors
                        }"
                        [(ngModel)]="objBillingInfo.OtherBillingContactName"
                        name="OtherBillingContactName"
                        formControlName="fcOtherBillingContactName"
                        placeholder="Other Billing Contact Name"
                        class="form-control col-md-8"
                      /> -->
                      <div *ngIf="
                          submitted && cf['fcOtherBillingContactName'].errors
                        " class="invalid-feedback">
                        <div class="col-xl-7 offset-xl-5 pl-0" *ngIf="
                            cf['fcOtherBillingContactName'].errors['required']
                          ">
                          Other Billing Contact Name is required
                        </div>
                      </div>
                    </div>

                    <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 form-group">
                      <label class="col-md-5 label-right pl-0">Email:</label>
                      <kendo-textbox [maxlength]="50" [(ngModel)]="objBillingInfo.OtherBillingContactEmail"
                        name="OtherBillingContactEmail" formControlName="fcOtherBillingContactEmail" placeholder="Email"
                        (change)="changeInputTrim($event,'OtherBillingContactEmail')" type="text"
                        class="p-0 phone col-xl-7 col-lg-8 col-md-8">
                      </kendo-textbox>
                      <!-- <input
                        [(ngModel)]="objBillingInfo.OtherBillingContactEmail"
                        name="OtherBillingContactEmail"
                        formControlName="fcOtherBillingContactEmail"
                        placeholder="Email"
                        type="text"
                        class="form-control phone col-md-8"
                      /> -->
                    </div>
                    <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 form-group">
                      <label class="col-md-5 label-right pl-0">Phone No:</label>
                      <!-- minlength="12" -->
                      <kendo-maskedtextbox [(ngModel)]="objBillingInfo.OtherBillingContactPhone"
                        name="OtherBillingContactPhone" formControlName="fcOtherBillingContactPhone"
                        inputMask="000-000-0000" type="text" placeholder="555-555-5555"
                        class="p-0 col-xl-4 col-lg-5 col-md-5" [ngClass]="{
                          'is-invalid':
                            submitted && cf['fcOtherBillingContactPhone'].errors
                        }" [mask]="Der_Phone_no_mask"></kendo-maskedtextbox>

                      <!-- <input
                        [(ngModel)]="objBillingInfo.OtherBillingContactPhone"
                        minlength="12"
                        name="OtherBillingContactPhone"
                        formControlName="fcOtherBillingContactPhone"
                        inputMask="000-000-0000"
                        type="text"
                        placeholder="555-555-5555"
                        class="form-control col-md-8"
                        [ngClass]="{
                          'is-invalid':
                            submitted && cf['fcOtherBillingContactPhone'].errors
                        }"
                      /> -->
                      <div *ngIf="
                          submitted && cf['fcOtherBillingContactPhone'].errors
                        " class="invalid-feedback">
                        <!-- <div
                          class="ms-33"
                          *ngIf="
                            cf['fcOtherBillingContactPhone'].errors['minlength']
                          "
                        >
                          Other Billing Phone No Not Valid
                        </div> -->
                      </div>
                    </div>

                    <!-- <div class="col-md-6 mt-2">
                        <label class="col-md-4"></label>
  
                        <button type="button"
                                class="col-md-2 btn btn-primary"
                                (click)="AddContactInfo()">
                          Save
                        </button>
                        <label class="col-md-2"></label>
  
                        <button type="button"
                                class="col-md-2 btn btn-warning"
                                name="btnClearDerInfo"
                                id="btnClearDerInfo" (click)="ClearBillingContact()">
                          Cancel
                        </button>
                        <label class="col-md-2"></label>
                      </div> -->
                  </div>
                  <div style="text-align:center" class="mt-2"><b>*Please Note: PTC uses paperless delivery for all
                      invoicing to the billing contact emails indicated above.</b></div>
                  <!-- <div class="row">
  
                      <div class="col-md-12 mt-2">
                        <table class="lstTable">
                          <tr>
                            <th>Serial</th>
                            <th>Contact Name</th>
                            <th>Email</th>
                            <th>Phone No</th>
                            <th>Edit</th>
                          </tr>
                          <tr *ngFor="let billInfo of lstBillingInfo; let i=index;">
                            <td>{{i + 1}}</td>
                            <td>{{billInfo.OtherBillingContactName}}</td>
                            <td>{{billInfo.OtherBillingContactEmail}}</td>
                            <td>{{billInfo.OtherBillingContactPhone}}</td>
                            <td>
                              <button type="button"
                                      class="btn btn-info"
                                      (click)="EditContactSection(billInfo.Id)">
                                Edit
                              </button>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div> -->
                </div>
                <input type="button" name="next" class="next action-button" value="Next Step" (click)="next()" />
              </fieldset>
            </form>
            <form id="msform" [formGroup]="employeeForm">
              <fieldset *ngIf="step == 2">
                <div class="form-card">
                  <h2 class="fs-title">Program Information</h2>
                  <div class="row ">
                    <!--<div class="label-right col-md-6">
                        <span>Does your company need a Department of Transportation (DOT) Program? </span>
                      </div>
                      <div class="col-md-6">
                        <input style="width:2% !important" type="checkbox" class="me-2" id="dot_program_yes" value="yes" /><span class="me-2">Yes</span><input class="me-2" id="dot_program_no" style="width:2% !important" type="checkbox" value="no" /><span>No</span>
                      </div>-->
                    <label class="col-lg-4 col-md-12 label-right" style="margin-top:5px">Select which program(s) you
                      need:</label>
                    <div class="col-lg-8 col-md-12">
                      <div class="d-inline-table custom_checkbox me-2">
                        <input formControlName="fcDotFederal" kendoCheckBox [(ngModel)]="
                        objProgramInfo.ProgramSelection.DotFederal 
                        " name="DotFederal" class="form-check-input" id="DotF" tabindex="1" type="checkbox"
                          (change)="ProgramSelectionChanged($event,'DotFederal')" />
                        <label for="DotF">DOT (Federal)</label>
                      </div>
                      <div class="d-inline-table custom_checkbox me-2">
                        <input formControlName="fcNonDotCompnay" kendoCheckBox [(ngModel)]="
                            objProgramInfo.ProgramSelection.NonDotCompnay
                          " name="NonDotCompnay" class="form-check-input" id="NDot" tabindex="2" type="checkbox"
                          (change)="ProgramSelectionChanged($event,'NonDotCompany')" />
                        <label for="NDot">Non-DOT (Company)</label>
                      </div>
                      <div class="d-inline-table custom_checkbox me-2">
                        <input formControlName="fcClientRequired" kendoCheckBox [(ngModel)]="
                            objProgramInfo.ProgramSelection.ClientRequired
                          " name="ClientRequired" class="form-check-input" id="ClientR" tabindex="3" type="checkbox"
                          (change)="ProgramSelectionChanged($event,'ClientRequired')" />
                        <label for="ClientR">Client-Required</label>
                      </div>
                    </div>
                  </div>

                  <div ngbAccordion>
                    <div class="card" [collapsed]="false" *ngIf="objProgramInfo.ProgramSelection.DotFederal" ngbAccordionItem id="toggle-1">
                      <h2 ngbAccordionHeader>
                        <button class="collapse-title" ngbAccordionButton>
                          DOT (Federal) Drug Program
                          <span class="collapse-title-expand-indicator">
                            <i class="fa fa-sort-down collapse-icon"></i>
                          </span>
                        </button>
                      </h2>
                      <div ngbAccordionCollapse class="card-body">
                        <div class="row">
                          <div class="col-md-12 form-group">
                            <label class="me-2"><strong class="required-fileds">* </strong>Select
                              the DOT mode(s) you are subject
                              to:</label>
  
                            <div class="program-types">
                              <div *ngFor="
                                let data of lstCheckBoxFederalProgramTypes
                              " class="d-inline-table custom_checkbox me-2">
                                <input class="form-check-input" kendoCheckBox type="checkbox" name="program-types"
                                  tabindex="4" (change)="
                                  onChangeFederalProgramTypes(data, $event)
                                " checked="{{ data.isSelected ? 'checked' : '' }}" />
                                <label class="">{{ data.item
                                  }}</label>
                              </div>
                            </div>
  
                            <div *ngIf="!IsFederalProgramsSelected" class="invalid-feedback d-block">
                              Please select mode(s) for your company, minimum 1 mode is required
                            </div>
                            <!-- <input class="me-2 form-control" style="width:2% !important" type="checkbox" /><span class="me-2">PHMSA</span>
                            <input class="me-2 form-control" style="width:2% !important" type="checkbox" /><span class="me-2">FMCSA</span>
                            <input class="me-2 form-control" style="width:2% !important" type="checkbox" /><span class="me-2">FRA</span>
                            <input class="me-2 form-control" style="width:2% !important" type="checkbox" /><span class="me-2">FAA</span>
                            <input class="me-2 form-control" style="width:2% !important" type="checkbox" /><span class="me-2">USCG</span> -->
                          </div>
                          <div class="col-md-12 form-group" [hidden]="!showListofAuditors">
                            <label class="me-2 mt-1">What auditing agencies do you submit your program's information to?
                              (e.g. NCMS, Veriforce, TPS Alert, etc.)</label>
  
  
                            <kendo-textarea resizable="none" [rows]="5" type="text" name="AuditorsNames"
                              placeholder="List of Auditors" (change)="changeInputTrim($event,'LisOfAuditors')"
                              [(ngModel)]="objProgramInfo.LisOfAuditors" class="mt-1" formControlName="fcListOfAuditors"
                              [tabIndex]="4">
                            </kendo-textarea>
  
                          </div>
                          <!-- <div class="col-md-12 form-group">
                            <label class="me-2 mt-1"><strong class="required-fileds">* </strong># of employees subject to these
                              requirements:</label>
                            <kendo-numerictextbox
                              class="p-0 phone fix-field-width seleted_dropdown k-dropdownlist k-picker"
                              name="DotNumberOfEmployees" formControlName="fcDotNumberOfEmployees" [tabIndex]="5"
                              [min]="0" [changeValueOnScroll]="false" [decimals]="0" format="0" [maxlength]="3"
                              [autoCorrect]="true" placeholder="# Emp"
                              [(ngModel)]="objProgramInfo.FederalProgram.NumberOfEmployees"
                              (valueChange)="checkAllNumberOfEmployess('DotFederal')">
                            </kendo-numerictextbox>
                            <div class="invalid-feedback d-block" style="margin-top:-2px" *ngIf="!IsValidNoOfEmployeesDotFederal">
                              Please select No. of Employee(s)
                            </div>
                          </div> -->
  
                          <div class="col-md-12 form-group">
                            <label class="me-2 mt-1">
                              Does any current job position require the use of a
                              Commercial Driver's License (CDL)?</label>
                            <kendo-dropdownlist [data]="YesNoItems" textField="text" valueField="value" [tabIndex]="6"
                              [(ngModel)]="selectedItem" name="CdlUseRequire" formControlName="fcCdlUseRequire"
                              class="px-0 mt-0 fix-field-width seleted_dropdown k-dropdownlist k-picker">
                            </kendo-dropdownlist>
                            <!-- <select [(ngModel)]="objProgramInfo.CdlUseRequire" name="CdlUseRequire"
                              formControlName="fcCdlUseRequire" type="text" tabindex="0" placeholder="Select"
                              class="form-control col-lg-2 col-md-2 mt-0 seleted_dropdown">
                              <option [ngValue]="true">YES</option>
                              <option [ngValue]="false">NO</option>
                            </select> -->
  
                          </div>
  
                          <div class="col-lg-12 d-flex justify-content-between">
                            <label class="pt-2 mb-0"><strong class="required-fileds">* </strong>Job
                              Position/Title:</label>
                            <div class="ms-auto">
                              <button [tabIndex]="7" kendoButton class="btn-orange mt-0" (click)="btnAddDotEmployees()">
                                Add Position
                              </button>
                            </div>
                          </div>
                          <div class="col-lg-12">
                            <h5 style="display: inline">
                              Please enter the job positions/titles for the
                              employees working under these programs.
                            </h5>
                            <span style="font-weight: normal">(These will be referenced in your drug plan.)</span>
                          </div>
                          <div class="invalid-feedback d-block" style="margin-left:15px"
                            *ngIf="!IsValidJobTitleDotFederal">
                            Please select Job Position/Title
                          </div>
                        </div>
  
                        <div *ngIf="isShownDotEmpSection" class="row der-section mt-2 pt-4 pb-3 mx-0"
                          style="border: 1px solid #ccc; border-radius:4px">
                          <div class="col-md-6 form-group">
                            <label class="col-md-4 label-right pl-0"><strong class="required-fileds">* </strong>Job
                              Position/Title:</label>
                            <!-- <input required [class.is-invalid]="
                                employeeForm.get('fcJobPosition')?.invalid &&
                                empsubmitted
                              " type="text" [(ngModel)]="objDotEmploye.Title" name="JobPosition/Title"
                              formControlName="fcJobPosition"  placeholder="Job Position or Title"
                              class="form-control col-md-8" required />
                               -->
                            <kendo-textbox [(ngModel)]="objDotEmploye.Title" name="JobPosition/Title"
                              formControlName="fcJobPosition" [tabIndex]="8" type="text" [maxlength]="50"
                              placeholder="Job Position or Title" (change)="changeInputTrim($event,'DotEmployeeTitle')"
                              class="p-0 col-xl-8 col-lg-12" required
                              [ngClass]="{ 'is-invalid': empsubmitted && employeeFormGet['fcJobPosition'] ? employeeFormGet['fcJobPosition'].invalid  : '' }">
                            </kendo-textbox>
                            <div *ngIf="
                               employeeFormGet['fcJobPosition'] ? employeeFormGet['fcJobPosition'].invalid : false &&
                                empsubmitted
                              ">
                              <div class="ms-3" [class.required-fileds]="
                                employeeFormGet['fcJobPosition'] ? employeeFormGet['fcJobPosition'].invalid : false
                                ">
                                Job Position is Required
                              </div>
                            </div>
                            <!-- <div *ngIf="jobPosition.errors?.required"> 
                              Job Position required. 
                          </div> -->
                          </div>
                          <div class="col-lg-4 offset-lg-1 cdl-checkbox-pl mb-2">
                            <div class="d-inline custom_checkbox">
                              <input formControlName="fcSupervisor" kendoCheckBox id="IsSupervisor"
                                [(ngModel)]="objDotEmploye.IsSupervisor" [tabIndex]="9" name="IsSupervisor"
                                class="form-check-input" type="checkbox" />
                              <label for="IsSupervisor">Supervisor</label>
                            </div>
                            <div class="d-inline custom_checkbox ms-4">
                              <input formControlName="fcCDL" kendoCheckBox id="CDL" [(ngModel)]="objDotEmploye.CDL"
                                name="CDL" [tabIndex]="10" class="form-check-input" type="checkbox"
                                (click)="changeCDLFromGrid()" />
                              <label for="CDL">CDL</label>
                            </div>
                          </div>
                          <!-- <div class="col-md-6">
                                <label class="col-md-4 label-right" id="Supervisor">Supervisor</label> <input formControlName="fcSupervisor"
                                  [(ngModel)]="objDotEmploye.Supervisor" name="Supervisor" class="form-control me-2 col-md-2"
                                  style="width:2% !important" type="checkbox" for="Supervisor" />
                                <label class="col-md-4 label-right">CDL</label> <input formControlName="fcCDL"
                                  [(ngModel)]="objDotEmploye.CDL" name="CDL" class="form-control me-2 col-md-2"
                                  style="width:2% !important" type="checkbox" />
                              </div> -->
                          <div class="col-md-12 label-right">
                            <button type="button" kendoButton class="btn btn-primary me-3 mt-2" name="btnAddDerInfo"
                              id="btnAddDotEmployees" [tabIndex]="11" (click)="btnSaveDotEmployees()">
                              Save Job Position
                            </button>
                            <button type="button" [tabIndex]="12" kendoButton class="btn btn-gray me-3 mt-2"
                              (click)="ClearDotEmp()">
                              Cancel
                            </button>
                          </div>
                        </div>
                        <div class="row mt-2">
                          <div class="col-md-12">
                            <div class="table-responsive">
                              <kendo-grid [kendoGridBinding]="lstDotEmployees" [groupable]="false" [reorderable]="false"
                                [resizable]="true" [filterable]="false" class="detail_table">
                                <kendo-grid-column field="Title" title="Job Position/Title"
                                  [headerStyle]="{'padding-top': '12px', 'padding-bottom': '12px', 'background-color': 'var(--green)','text-align': 'left', 'color': 'white', 'border': '1px solid #ddd' }">
  
                                </kendo-grid-column>
                                <kendo-grid-column title="Supervisor Position" [style]="{ width: '250px'}"
                                  [headerStyle]="{ width: '250px', 'padding-top': '12px', 'padding-bottom': '12px', 'background-color': 'var(--green)','text-align': 'left', 'color': 'white', 'border': '1px solid #ddd' }">
                                  <ng-template kendoGridCellTemplate let-dataItem>
                                    <input class="k-checkbox k-checkbox-lg k-rounded-md" type="checkbox"
                                      [checked]="dataItem.IsSupervisor" onclick="return false;" />
                                  </ng-template>
                                </kendo-grid-column>
                                <kendo-grid-column title="CDL" [style]="{ width: '200px'}"
                                  [headerStyle]="{ width: '200px', 'padding-top': '12px', 'padding-bottom': '12px', 'background-color': 'var(--green)','text-align': 'left', 'color': 'white', 'border': '1px solid #ddd' }">
                                  <ng-template kendoGridCellTemplate let-dataItem>
                                    <input class="k-checkbox k-checkbox-lg k-rounded-md" type="checkbox"
                                      [checked]="dataItem.CDL" onclick="return false;" />
                                  </ng-template>
                                </kendo-grid-column>
                                <kendo-grid-command-column [style]="{ width: '150px'}" title="Edit / Delete"
                                  [headerStyle]="{  width: '150px', 'padding-top': '12px', 'padding-bottom': '12px', 'background-color': 'var(--green)','text-align': 'left', 'color': 'white', 'border': '1px solid #ddd' }">
                                  <ng-template kendoGridCellTemplate let-dataItem>
                                    <button type="button" kendoButton class="btn btn-gray me-3"
                                      (click)="EditDotEmp( dataItem.Id)">
                                      Edit
                                    </button>
                                    <button type="button" kendoButton class="btn btn-red"
                                      (click)="DeleteDotEmp( dataItem.Id)">
                                      Delete
                                    </button>
                                  </ng-template>
                                </kendo-grid-command-column>
                              </kendo-grid>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
    
                    <div ngbAccordionItem [collapsed]="false" class="card" id="toggle-2" *ngIf="objProgramInfo.ProgramSelection.NonDotCompnay">
                      <h2 ngbAccordionHeader>
                        <button class="collapse-title" ngbAccordionButton>
                          Company (Non-DOT) Program
                          <span class="collapse-title-expand-indicator">
                            <i class="fa fa-sort-down collapse-icon"></i>
                          </span>
                        </button>
                      </h2>
                      <div ngbAccordionCollapse>
                        <div class="row">
                          <div class="col-md-12 form-group">
                            Includes: Pre-employment, Post-Accident,
                            Reasonable-Cause, Return-to-duty, and Follow-up
                          </div>
  
                          <div class="col-xl-6 col-lg-6 col-md-6 form-group">
                            <label class="me-2">
                              <span>Do you want to conduct random testing?</span>
                              <br />
                              <span class="span-ptc-utilize">PTC utilizes a 50% annual testing rate by
                                default</span>
                            </label>
                            <kendo-dropdownlist [data]="YesNoItems" textField="text" valueField="value"
                              [(ngModel)]="selectedItemIsRandomTesting" name="IsRandomTesting"
                              formControlName="fcIsRandomTesting"
                              class="fix-field-width seleted_dropdown k-dropdownlist k-picker px-0 mt-0 align-top ">
                            </kendo-dropdownlist>
                            <!-- <select type="text" placeholder="Select" [required]="true" name="IsRandomTesting"
                              formControlName="fcIsRandomTesting"
                              class="seleted_dropdown col-lg-2 col-md-3 mt-0 align-top form-control" [(ngModel)]="
                                objProgramInfo.CompanyProgram.IsRandomTesting
                              ">
                               <option>Select</option>
                              <option [ngValue]="true">YES</option>
                              <option [ngValue]="false">NO</option>
                            </select> -->
                          </div>
  
                          <div class="col-xl-6 col-lg-6 col-md-6 form-group">
                            <label class="col-md-5 col-lg-4 label-mob-right pl-0 mt-1">Please select:</label>
                            <kendo-dropdownlist [data]="RandomDrugAndAlcoholTestingItems" textField="text"
                              valueField="value" [(ngModel)]="selectedItemDrugAndAlcohol"
                              name="IsRandomDrugAndAlcoholTesting" formControlName="fcIsRandomDrugAndAlcoholTesting"
                              class="seleted_dropdown k-dropdownlist k-picker px-0 mt-0 align-top  col-xl-4 col-lg-5 col-md-5">
                            </kendo-dropdownlist>
  
                            <!-- <select type="text" placeholder="Select"
                              class="seleted_dropdown form-control mt-0 align-top col-lg-4 col-md-5" [required]="true"
                              name="IsRandomDrugAndAlcoholTesting" formControlName="fcIsRandomDrugAndAlcoholTesting"
                              [(ngModel)]="
                                objProgramInfo.CompanyProgram
                                  .IsRandomDrugAndAlcoholTesting
                              ">
                               <option>Select</option>
                              <option [ngValue]="false">Drug Only</option>
                              <option [ngValue]="true">Drug & Alcohal</option>
                            </select> -->
                          </div>
                          <div class="col-md-12 form-group">
                            <label class="me-2">Choose the Drug test panel you wish to
                              utilize:</label>
                            <kendo-dropdownlist [data]="DrugTestPanelItems" textField="text" valueField="value"
                              [(ngModel)]="selectedDrugTestPanelItems" formControlName="fcDrugTestPanel"
                              placeholder="Select"
                              class="seleted_dropdown seleted_dropdown k-dropdownlist k-picker px-0 col-md-5 col-lg-4"
                              [required]="true"> </kendo-dropdownlist>
                            <!-- 
                            <select type="text" placeholder="Select" formControlName="fcDrugTestPanel"
                              class="seleted_dropdown form-control col-md-5 col-lg-4" [required]="true" [(ngModel)]="
                                objProgramInfo.CompanyProgram.DrugTestPanel
                              ">
                              <option>Select</option>
                              <option [ngValue]="0">DOT Look-a-like Panel</option>
                              <option [ngValue]="1">9-Panel (most common)</option>
                              <option [ngValue]="2">
                                Other Panel (please contact PTC for specifics)
                              </option>
                            </select> -->
                          </div>
  
                          <!-- <div class="col-md-12 form-group">
                            <label class="me-2"><strong class="required-fileds">* </strong># of employees subject to these
                              requirements:</label>                         
                            <kendo-numerictextbox
                              class="p-0 phone fix-field-width seleted_dropdown k-dropdownlist k-picker"
                              name="DotNumberOfEmployees" formControlName="fcNotDotNumberOfEmployees" placeholder="# Emp"
                              [min]="0" [changeValueOnScroll]="false" [decimals]="0" format="0" [maxlength]="3"
                              [autoCorrect]="true" [(ngModel)]="objProgramInfo.CompanyProgram.NumberOfEmployees"
                              (valueChange)="checkAllNumberOfEmployess('NonDotCompany')">
                            </kendo-numerictextbox>
                            <div class="invalid-feedback d-block" style="margin-top:-2px" *ngIf="!IsValidNoOfEmployeesNonDotFederal">
                              Please select No. of Employee(s)
                            </div>
                          </div> -->
  
                          <div class="col-lg-12 d-flex">
                            <label class="pt-2 mb-0"><strong _ngcontent-ifq-c478="" class="required-fileds">* </strong>Job
                              Position/Title:</label>
                            <div class="ms-auto">
                              <button class="btn-orange mt-0" kendoButton (click)="btnAddNonDotEmployees()">
                                Add Position
                              </button>
                            </div>
                          </div>
                          <div class="col-lg-12">
                            <h5 style="display: inline">
                              Please enter the job positions/titles for the
                              employees working under these programs.
                            </h5>
                            <span style="font-weight: normal">(These will be referenced in your drug plan.)</span>
                          </div>
                          <div class="invalid-feedback d-block" style="margin-left:15px"
                            *ngIf="!IsValidJobTitleNonDotFederal">
                            Please select Job Position/Title
                          </div>
  
                        </div>
                        <div *ngIf="isShownNonDotEmpSection" class="row mt-2 pt-4 pb-3 mx-0"
                          style="border: 1px solid #ccc; border-radius:4px">
                          <div class="col-md-6 form-group">
                            <label class="col-md-4 label-right pl-0"><strong class="required-fileds">* </strong>Job
                              Position/Title:</label>
                            <!-- <input type="text" formControlName="fcNonDotJobPostition" [class.is-invalid]="
                                employeeForm.get('fcNonDotJobPostition')?.invalid && nonEmpsubmitted
                              " [(ngModel)]=" ObjNonDotEmployee.Title" name="NonDotJobPostition"
                              placeholder="Job Position" class="form-control col-md-8" /> -->
  
                            <kendo-textbox [(ngModel)]=" ObjNonDotEmployee.Title" name="NonDotJobPostition"
                              formControlName="fcNonDotJobPostition" type="text" placeholder="Job Position"
                              [maxlength]="50" class="p-0 col-xl-8 col-lg-12"
                              (change)="changeInputTrim($event,'NonDotEmployeeTitle')" [ngClass]="{
                            'is-invalid': employeeFormGet['fcNonDotJobPostition'] ? employeeFormGet['fcNonDotJobPostition'].invalid : false && nonEmpsubmitted }">
                            </kendo-textbox>
                            <div *ngIf="
                              employeeFormGet['fcNonDotJobPostition'] ? employeeFormGet['fcNonDotJobPostition'].invalid : false && nonEmpsubmitted
                              ">
                              <div class="ms-33" [class.required-fileds]="
                                employeeFormGet['fcNonDotJobPostition'] ? employeeFormGet['fcNonDotJobPostition'].invalid : false
                                ">
                                Job Position is Required
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-4 offset-lg-1 cdl-checkbox-pl mb-2">
                            <div class="d-inline custom_checkbox">
                              <input formControlName="fcNonDotSupervisor" kendoCheckBox id="NonDotSupervisor"
                                [(ngModel)]=" ObjNonDotEmployee.IsSupervisor" name="IsSupervisor"
                                class="form-check-input" type="checkbox" />
                              <label for="NonDotSupervisor">Supervisor</label>
                            </div>
                          </div>
                          <div class="col-md-12 label-right">
                            <button type="button" kendoButton class="btn btn-primary mt-2 me-3"
                              (click)="btnSaveNonDotEmployees()">
                              Save Job Position
                            </button>
                            <button type="button" kendoButton class="btn btn-gray mt-2 me-3" (click)="ClearNonDotEmp()">
                              Cancel
                            </button>
                          </div>
                        </div>
                        <div class="row mt-2">
                          <div class="col-md-12">
                            <div class="table-responsive">
                              <kendo-grid [kendoGridBinding]="lstNonDotEmployees" [groupable]="false"
                                [reorderable]="false" [resizable]="true" [filterable]="false" class="detail_table">
                                <kendo-grid-column field="Title" title="Job Position/Title"
                                  [headerStyle]="{'padding-top': '12px', 'padding-bottom': '12px', 'background-color': 'var(--green)','text-align': 'left', 'color': 'white', 'border': '1px solid #ddd' }">
                                </kendo-grid-column>
                                <kendo-grid-column title="Supervisor Position" [width]="250"
                                  [headerStyle]="{width:'250','padding-top': '12px', 'padding-bottom': '12px', 'background-color': 'var(--green)','text-align': 'left', 'color': 'white', 'border': '1px solid #ddd' }">
                                  <ng-template kendoGridCellTemplate let-dataItem>
                                    <input class="k-checkbox k-checkbox-lg k-rounded-md" type="checkbox"
                                      [checked]="dataItem.IsSupervisor" onclick="return false;" />
                                  </ng-template>
                                </kendo-grid-column>
                                <kendo-grid-command-column [width]="150" title="Edit / Delete"
                                  [headerStyle]="{width:'150','padding-top': '12px', 'padding-bottom': '12px', 'background-color': 'var(--green)','text-align': 'left', 'color': 'white', 'border': '1px solid #ddd' }">
                                  <ng-template kendoGridCellTemplate let-dataItem>
                                    <button type="button" kendoButton class="btn btn-gray me-3"
                                      (click)="EditNonDotEmp( dataItem.Id)">
                                      Edit
                                    </button>
                                    <button type="button" kendoButton class="btn btn-red"
                                      (click)="DeleteNonDotEmp( dataItem.Id)">
                                      Delete
                                    </button>
                                  </ng-template>
                                </kendo-grid-command-column>
                              </kendo-grid>
                              <!-- <table class="lstTable">
                                <tr>
                                  <th>Job Position/Title</th>
                                  <th>Supervisor Position?</th>
                                  <th>Edit</th>
                                </tr>
  
                                <tr *ngFor="
                                    let nonDotEmp of lstNonDotEmployees;
                                    let i = index
                                  ">
                                  <td>{{ nonDotEmp.Title }}</td>
                                  <td>
                                    <div class="custom_checkbox">
                                      <input id="Supervisor11" kendoCheckBox type="checkbox" checked="{{
                                          nonDotEmp.Supervisor ? 'checked' : ''
                                        }}" />
                                      <label class="form-check-label" for="Supervisor11"></label>
                                    </div>
                                  </td>
                                  <td>
                                    <button type="button" kendoButton class="btn btn-gray me-3"
                                      (click)="EditNonDotEmp(nonDotEmp.Id)">
                                      Edit
                                    </button>
                                    <button type="button" kendoButton class="btn btn-red"
                                      (click)="DeleteNonDotEmp(nonDotEmp.Id)">
                                      Delete
                                    </button>
                                  </td>
                                </tr>
                              </table> -->
                            </div>
                          </div>
                        </div>
                      </div>
    
                    </div>
                    <div ngbAccordionItem [collapsed]="false" class="card" id="toggle-3" *ngIf="objProgramInfo.ProgramSelection.ClientRequired">
                      <h2 ngbAccordionHeader>
                        <button class="collapse-title" ngbAccordionButton>
                          Client Required Program
                          <span class="collapse-title-expand-indicator">
                            <i class="fa fa-sort-down collapse-icon"></i>
                          </span>
                        </button>
                      </h2>
                      <div ngbAccordionCollapse class="card-body">
                        <div class="row">
                          <label class="col-md-12 form-group">Which Client requirements are you subject to? (select
                            all that apply): </label>
  
                          <div class="col-md-12 mx-auto form-group">
                            <div *ngFor="let data of lstCheckBoxClientRequiremets"
                              class="d-inline-table custom_checkbox me-2">
                              <input class="form-check-input" kendoCheckBox type="checkbox" name="OtherProgramTypes"
                                (change)="onChangeOtherProgramTypes(data, $event)"
                                checked="{{ data.isSelected ? 'checked' : '' }}" />
                              <label>{{ data.item }}</label>
                            </div>
                            <span *ngIf="!IsCRProgramsSelected" class="invalid-feedback" style="display:block;">Please
                              select CR Program(s) for the company, minimum 1 CR Program is required</span>
                          </div>
  
                          <div class="col-md-12 mt-2 form-group">
                            <label class="pl-0 pr-2">Other:</label>
                            <!-- <input class="form-control col-md-4 input_filed_color--" type="text" placeholder="Other"
                              name="OtherName" formControlName="fcOtherName"
                              [(ngModel)]="objProgramInfo.OtherProgram.OtherName" /> -->
                            <kendo-textbox [(ngModel)]="objProgramInfo.OtherProgram.OtherName" name="OtherName"
                              [maxlength]="50" formControlName="fcOtherName"
                              (change)="changeInputTrim($event,'OtherProgramOtherName')" style="color: var(--black);"
                              type="text" placeholder="Other"
                              class="p-0 col-xl-4 col-lg-5 col-md-7 col-sm-8 seleted_dropdown k-dropdownlist k-picker">
                            </kendo-textbox>
                          </div>
  
                          <!-- <div class="col-md-12 form-group">
                            <label class="me-2"><strong class="required-fileds">* </strong># of employees subject to these
                              requirements:</label>
                          
                            <kendo-numerictextbox
                              class="p-0 phone fix-field-width seleted_dropdown k-dropdownlist k-picker"
                              name="ClientNumberOfEmployees" formControlName="fcClientNumberOfEmployees" [min]="0"
                              format="0" [changeValueOnScroll]="false" [decimals]="0" [maxlength]="3" [autoCorrect]="true"
                              placeholder="# Emp" [(ngModel)]="objProgramInfo.OtherProgram.NumberOfEmployees"
                              (valueChange)="checkAllNumberOfEmployess('ClientRequired')">
                            </kendo-numerictextbox>
                            <div class="invalid-feedback d-block" style="margin-top:-2px" *ngIf="!IsValidNoOfEmployeesClientRequired">
                              Please select No. of Employee(s)
                            </div>
                          </div> -->
                        </div>
                      </div>
    
                    </div>

                    <div ngbAccordionItem id="toggle-4" class="card" [collapsed]="false">
                      <h2 ngbAccordionHeader>
                        <button class="collapse-title" ngbAccordionButton>
                          Total Number of Employees
                          <span class="collapse-title-expand-indicator">
                            <i class="fa fa-sort-down collapse-icon"></i>
                          </span>
                        </button>
                      </h2>
                      <div ngbAccordionCollapse class="card-body">
                        <div class="row">
                          <div class="col-md-12">
                            <label class="me-2"><strong class="required-fileds">* </strong>Please indicate the total
                              number of employees subject to these programs (if applicable): </label>
                            <kendo-numerictextbox
                              class="p-0 phone fix-field-width seleted_dropdown k-dropdownlist k-picker"
                              name="NumberOfEmployees" formControlName="fcNumberOfEmployees" [min]="0" format="0"
                              [changeValueOnScroll]="false" [decimals]="0" [maxlength]="3" [autoCorrect]="true"
                              placeholder="# Emp" [(ngModel)]="objProgramInfo.NumberOfEmployees"
                              (valueChange)="checkAllNumberOfEmployess('')">
                            </kendo-numerictextbox>
                            <p class="span-ptc-utilize mb-0"
                              style="font-weight:normal; margin-top:-4px; font-style: italic;">Please count employees who
                              are subject to multiple program once.</p>
                            <div class="invalid-feedback d-block" *ngIf="!IsValidNoOfEmployeesProgramInfo">
                              Please select No. of Employee(s)
                            </div>
                          </div>
  
  
  
  
  
                        </div> 
                        
                      </div>
    
                    </div>
                  </div>

                  
                  <!-- <div class="form-group">
                   
                  </div> -->
                 
                </div>
                <button kendoButton (click)="previous()" class="previous action-button-previous">Previous</button>
                <span
                  *ngIf="!(IsValidNoOfEmployeesProgramInfo && IsValidJobTitleDotFederal && IsValidJobTitleNonDotFederal &&   IsFederalProgramsSelected && IsCRProgramsSelected && (objProgramInfo.ProgramSelection.DotFederal || objProgramInfo.ProgramSelection.NonDotCompnay || objProgramInfo.ProgramSelection.ClientRequired))"><button
                    kendoButton (click)="next()" class="next action-button-lightgray" [disabled]="true">Next
                    Step</button></span>
                <span
                  *ngIf="IsValidNoOfEmployeesProgramInfo  && IsValidJobTitleDotFederal && IsValidJobTitleNonDotFederal  &&  IsFederalProgramsSelected && IsCRProgramsSelected && (objProgramInfo.ProgramSelection.DotFederal || objProgramInfo.ProgramSelection.NonDotCompnay || objProgramInfo.ProgramSelection.ClientRequired)"><button
                    kendoButton (click)="next()" class="next action-button">Next Step</button></span>

              </fieldset>
            </form>
            <form id="msform" [formGroup]="AckAndAgreementForm">
              <fieldset *ngIf="step == 3">
                <div class="form-card">
                  <h2 class="fs-title">Acknowledgment /Agreement</h2>
                  <div id="print">
                    <div class="row mb-3">
                      <div class="col-md-12" style="font-size: 14px">
                        Please read and acknowledge each of the following PTC
                        processes and Policies
                      </div>
                    </div>
                    <div class="row">
                      <div class="custom_checkbox custom_checkbox2 col-md-12">
                        <input [(ngModel)]="AckAndAgreement.OutlineServicesCosts" name="OutlineServicesCosts"
                          formControlName="fcOutlineServicesCosts" kendoCheckBox type="checkbox"
                          id="OutlineServicesCosts" class="form-check-input" (click)="OutlineServicesCosts()" />
                        <label class="Agreement_check_text d-block" for="OutlineServicesCosts">Outline of Services and
                          Costs</label>
                      </div>
                      <div class="custom_checkbox custom_checkbox2 col-md-12">
                        <input [(ngModel)]="AckAndAgreement.ServiceAgreement" name="ServiceAgreement"
                          formControlName="fcServiceAgreement" kendoCheckBox type="checkbox"
                          id="ServiceAgreement" class="form-check-input" (click)="ServiceAgreement()" />
                        <label class="Agreement_check_text d-block" for="ServiceAgreement">Service Agreement</label>
                      </div>
                      <div class="custom_checkbox custom_checkbox2 col-md-12">
                        <input [(ngModel)]="AckAndAgreement.NoRefundCreditPolicy" name="NoRefundCreditPolicy"
                          formControlName="fcNoRefundCreditPolicy" kendoCheckBox type="checkbox" id="Acknowledge"
                          class="form-check-input" (click)="SpanPopupNoRefund()" />
                        <label class="Agreement_check_text d-block" for="Acknowledge">No Refund & Credit Policy</label>
                      </div>
                      <div class="custom_checkbox custom_checkbox2 col-md-12">
                        <input [(ngModel)]="
                            AckAndAgreement.ElectronicTransmissionAck
                          " name="ElectronicTransmissionAck" formControlName="fcElectronicTransmissionAck"
                          type="checkbox" kendoCheckBox id="ElectronicTransmission" class="form-check-input"
                          (click)="SpanPopupElectronicTransmission()" />
                        <label class="Agreement_check_text d-block" for="ElectronicTransmission">Electronic Transmission
                          Acknowledgment</label>
                      </div>
                      <div class="custom_checkbox custom_checkbox2 col-md-12 mb-4">
                        <input [(ngModel)]="AckAndAgreement.ConsumerReportAck" name="ConsumerReportAck"
                          formControlName="fcConsumerReportAck" kendoCheckBox type="checkbox" id="ConsumerReport"
                          class="form-check-input" (click)="SpanPopupConsumerReport()" />
                        <label class="Agreement_check_text d-block" for="ConsumerReport">Consumer Report Service
                          Agreement for
                          Employers
                          Subject to Substance Abuse Testing Verification
                          Requirements (PTC Assist)</label>
                      </div>
                      <div class="custom_checkbox custom_checkbox2 col-md-12">
                        <input [(ngModel)]="AckAndAgreement.ElectronicSignatureAck" name="ElectronicSignatureAck"
                          formControlName="fcElectronicSignatureAck" kendoCheckBox type="checkbox" id="AgreeBychecking"
                          class="form-check-input" (click)="AgreeByChecking()" />
                        <label class="Agreement_check_text d-block" for="AgreeBychecking">I Agree By checking the “I
                          Accept”
                          box, you are
                          signing these acknowledgments and policies
                          electronically. You agree your electronic signature is
                          the legal equivalent of your manual/handwritten
                          signature on these documents. By selecting “I Accept”
                          using any device, means, or action, you consent to the
                          legally binding terms and conditions of these
                          documents. You further agree that your electronic
                          signature on this document is as valid as if you
                          signed these documents in writing.</label>
                      </div>
                    </div>
                  </div>
                  <div class="row mx-0 mt-5 acknowled_date_mob">
                    <div class="mb-4 col-md-3">
                      <kendo-textbox [(ngModel)]="AckAndAgreement.CompanyName" [readonly]="true" name="CompanyName"
                        [maxlength]="100" formControlName="fcCompanyName" required="true" placeholder="Company Name"
                        class="p-0 col-md-12 custom_input_aa">
                      </kendo-textbox>

                      <!-- <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker> -->
                      <div>Company Name</div>
                    </div>
                    <div class="ms-auto mb-4 col-md-3">
                      <div>
                        <!-- <input type="text" [class.is-invalid]="
                            AckAndAgreementForm.get('fcCompanyRepresentativeName')?.invalid && submitted
                          " class="custom_input_aa" formControlName="fcCompanyRepresentativeName" required [(ngModel)]="
                            AckAndAgreement.CompanyRepresentativeName
                            
                          " /> -->
                        <kendo-textbox [(ngModel)]="AckAndAgreement.CompanyRepresentativeName" [maxlength]="50"
                          name="CompanyRepresentativeName"
                          (change)="changeInputTrim($event,'CompanyRepresentativeName')"
                          formControlName="fcCompanyRepresentativeName" required="true"
                          placeholder="Company Representative" class="p-0 col-md-12 custom_input_aa" [ngClass]="{
                          'is-invalid': AckAndAgreementFormGet['fcCompanyRepresentativeName'] ? AckAndAgreementFormGet['fcCompanyRepresentativeName'].invalid : false && submitted }"
                          [disabled]="!( AckAndAgreement.OutlineServicesCosts == true &&
                             AckAndAgreement.NoRefundCreditPolicy == true &&
                             AckAndAgreement.ServiceAgreement == true &&
                             AckAndAgreement.ElectronicTransmissionAck == true &&
                             AckAndAgreement.ElectronicSignatureAck == true &&
                             AckAndAgreement.ConsumerReportAck == true)">
                        </kendo-textbox>
                        <div>Name of Authorized Company Representative</div>
                      </div>
                    </div>


                    <div class="ms-auto col-md-2">
                      <div>
                        <kendo-textbox [(ngModel)]="AckAndAgreement.AckDate" [readonly]="true" name="Date"
                          formControlName="fcAckDate" required="true" placeholder="Date"
                          class="p-0 col-md-12 custom_input_aa">
                        </kendo-textbox>

                        <!-- <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker> -->
                        <div>Date</div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <input (click)="previous()" type="button" name="previous" class="previous action-button-previous"
                  value="Previous" /> -->
                <button kendoButton (click)="previous()" class="previous action-button-previous">Previous</button>
                <!-- <input (click)="next()" *ngIf="
                   AckAndAgreement.OutlineServicesCosts == true &&
                     AckAndAgreement.NoRefundCreditPolicy == true &&
                     AckAndAgreement.ElectronicTransmissionAck == true &&
                     AckAndAgreement.ElectronicSignatureAck == true &&
                     AckAndAgreement.ConsumerReportAck == true &&
                    AckAndAgreementForm.get('fcCompanyRepresentativeName')
                      ?.valid &&
                    AckAndAgreementForm.get('fcAckDate')?.valid &&
                    AckAndAgreementForm.get('fcAckDate')?.touched
                  " type="button" name="next" class="next action-button" value="Next Step" /> -->
                <button kendoButton (click)="next()" *ngIf="
                     AckAndAgreement.OutlineServicesCosts == true &&
                     AckAndAgreement.ServiceAgreement == true &&
                     AckAndAgreement.NoRefundCreditPolicy == true &&
                     AckAndAgreement.ElectronicTransmissionAck == true &&
                     AckAndAgreement.ElectronicSignatureAck == true &&
                     AckAndAgreement.ConsumerReportAck == true &&
                   AckAndAgreementFormGet['fcCompanyRepresentativeName'] ? AckAndAgreementFormGet['fcCompanyRepresentativeName'].valid : false &&
                    AckAndAgreementFormGet['fcCompanyName'] ? AckAndAgreementFormGet['fcCompanyName'].valid : false
                  " class="next action-button">Next Step</button>
                <button kendoButton *ngIf="
                 AckAndAgreement.OutlineServicesCosts == true &&
                 AckAndAgreement.ServiceAgreement == true &&
                 AckAndAgreement.NoRefundCreditPolicy == true &&
                 AckAndAgreement.ElectronicTransmissionAck == true &&
                 AckAndAgreement.ElectronicSignatureAck == true &&
                 AckAndAgreement.ConsumerReportAck == true &&
                 AckAndAgreementFormGet['fcCompanyRepresentativeName'] ? AckAndAgreementFormGet['fcCompanyRepresentativeName'].valid : false &&
                 AckAndAgreementFormGet['fcCompanyName'] ? AckAndAgreementFormGet['fcCompanyName'].valid : false" (click)="openModal(content)" class="action-button-print px-3">View Agreement</button>
                <!-- <button class="btn btn-outline-primary mb-2 me-2" (click)="openSm(content)">Small modal</button> -->
                <ng-template #content let-modal>

                  <h2 ngbAutofocus class="swal2-title">Acknowledgement and Agreement Policies</h2>
                  <div class="modal-body px-3">
                    <div class="companyInfo mt-2">
                      <div class="col-md-12 col-sm-12">
                        <h2 class="company-info-heading mb-0 pt-0">Outline of Services and Costs</h2>
                        <p class="mt-4">The following services will be performed by our company:</p>

                        <ul>
                          <li>
                            <h2 class="company-info-heading mt-4 mb-2">Policy & Procedure Manual</h2>
                            <p>Implementation of your individualized Alcohol and Drug Testing Plans (written policy
                              & procedure manual). Applicant and employee acknowledgment forms are included.</p>
                          </li>
                          <li>
                            <h2 class="company-info-heading mt-4 mb-2">Certified Laboratory Services</h2>
                            <p>Drug testing laboratory services for the program is a Substance Abuse and Mental
                              Health Services Administration (SAMHSA), certified laboratory. The lab for our program
                              is: Clinical Reference Laboratory, 8433 Quivira, Lenexa, Kansas 66215.</p>
                          </li>
                          <li>
                            <h2 class="company-info-heading mt-4 mb-2">Medical Review Officer (MRO) Services</h2>
                            <p>The MRO oversees the drug testing results to ensure validity of the results and to
                              make sure that the employee's rights are preserved. The MRO for our program is: Dr.
                              David W. Paine, American Medical Review Officers, LLC, 9 Compound Drive, Hutchinson,
                              Kansas 67502.</p>

                          </li>
                          <li>
                            <h2 class="company-info-heading mt-4 mb-2">Collection Kit</h2>
                            <p>Testing supplies and kits are provided at no charge with clients only paying for shipping and handling.</p>

                          </li>
                          <li>
                            <h2 class="company-info-heading mt-4 mb-2">Collection Sites</h2>
                            <p>Included with drug testing is a specimen collection site (your local clinic, hospital or doctors office). 
                              Approved collection sites are identified on our website (www.pipelinetesting.com). All collection sites 
                              utilized must be listed in the PTC Collection Site Network. Additional charges may apply for collection 
                              sites used outside the approved network, for after-hour services, on-site(mobile) testing, and other situations. 
                            </p>

                          </li>
                          <li>
                            <h2 class="company-info-heading mt-4 mb-2">Breath Alcohol Technician (BAT) Services</h2>
                            <p>Trained BATs and collection facilities are provided by either mobile service or
                              walk-in facilities.</p>

                          </li>
                          <li>
                            <h2 class="company-info-heading mt-4 mb-2">Testing Schedule</h2>
                            
                              <p>All employees working in a "covered" position are subject to unannounced testing based on random
                    selection. All random selections are computer generated. The current annualized random drug testing
                    rate is published on <a class="a-link d-inline py-0" href="https://www.transportation.gov/odapc/random-testing-rates" target="_blank">Random Testing Rates</a> 
                    for employees subject to the PHMSA regulations.</p>

                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="companyInfo">
                      <div class="col-md-12 col-sm-12">
                        <ul>
                          <li>
                            <h2 class="company-info-heading mt-4 mb-2">Employee Assistance Program (EAP) &
                              Supervisor Training</h2>
                            <p>The employee assistance program (EAP) includes informational material for each
                              employee, hot- line number posters, and an online training module covering drug and
                              alcohol recognition, testing and understanding for supervisors and managers.</p>

                          </li>
                          <li>
                            <h2 class="company-info-heading mt-4 mb-2">Substance Abuse Professional (SAP) Services
                            </h2>
                            <p>The Substance Abuse Professional (SAP) provides an evaluation of an employee who
                              tests positive for alcohol and/or drugs. PTC will coordinate the follow-up program
                              established by the Substance Abuse Professional.</p>

                          </li>
                          <li>
                            <h2 class="company-info-heading mt-4 mb-2">Drug/Alcohol History Checks</h2>
                            <p>Employers hiring any applicant for a DOT position must obtain information about any
                              DOT alcohol and/or drug misuse from the applicant's previous employers for the
                              previous two years (three years if applicant is a CDL driver.) PTC Assist, LLC
                              provides this verification service for PTC. This service is done in accordance with 49
                              CFR Part 40.25 requirements.</p>

                          </li>
                          <li>
                            <h2 class="company-info-heading mt-4 mb-2">Recordkeeping</h2>
                            <p>Maintenance and recordkeeping functions are provided. The records are kept
                              electronically via a secure digital file source and can be retrieved quickly for
                              submission. PTC also maintains BAT and QAP records.</p>

                          </li>
                          <li>
                            <h2 class="company-info-heading mt-4 mb-2">PTC Online Access</h2>
                            <p>Allows employers to access their pool information 24/7. Employers can view employee
                              test result history, current random pool lists, history check information and much
                              more.</p>

                          </li>
                          <li>
                            <h2 class="company-info-heading mt-4 mb-2">ePay<sup>TM</sup></h2>
                            <p>View and pay invoices online. Members are given unique login criteria to view their
                              specific account details quickly and securely. View payment history and pending
                              statements.</p>

                          </li>

                          <li>
                            <h2 class="company-info-heading mt-4 mb-2">Statistical Data Reporting</h2>
                            <p>Quarterly statistical data reports are provided to the pipeline contractor and to the
                              pipeline operators that each contractor works for.</p>
                          </li>
                          <li>
                            <h2 class="company-info-heading mt-4 mb-2">Compliance Audits and/or Updates</h2>
                            <p>All operator audit requests are handled by Pipeline Testing Consortium, Inc. When a
                              pipeline contractor is solicited by the operator, all requested information is to be
                              sent to PTC for response directly to the operator.</p>
                            <p>All new and existing regulations are monitored to maintain complete compliance of the
                              DOT regulations.</p>
                          </li>
                        </ul>
                        <!-- <h2 class="company-info-heading mb-3">Employee Assistance Program (EAP) & Supervisor Training</h2>
                      <p>The employee assistance program (EAP) includes informational material for each employee, hot- line number posters, and an online training module covering drug and alcohol recognition, testing and understanding for supervisors and managers.</p>
                      <h2 class="company-info-heading mt-3 mb-3">Substance Abuse Professional (SAP) Services</h2>
                      <p>The Substance Abuse Professional (SAP) provides an evaluation of an employee who tests positive for alcohol and/or drugs. PTC will coordinate the follow-up program established by the Substance Abuse Professional.</p>
                      <h2 class="company-info-heading mt-3 mb-3">Drug/Alcohol History Checks</h2>
                      <p>Employers hiring any applicant for a DOT position must obtain information about any DOT alcohol and/or drug misuse from the applicant's previous employers for the previous two years (three years if applicant is a CDL driver.) PTC Assist, LLC provides this verification service for PTC. This service is done in accordance with 49 CFR Part 40.25 requirements.</p>
                      <h2 class="company-info-heading mt-3 mb-3">Recordkeeping</h2>
                      <p>Maintenance and recordkeeping functions are provided. The records are kept electronically via a secure digital file source and can be retrieved quickly for submission. PTC also maintains BAT and QAP records.</p>
                      <h2 class="company-info-heading mt-3 mb-3">PTC Online Access</h2>
                      <p>Allows employers to access their pool information 24/7. Employers can view employee test result history, current random pool lists, history check information and much more.</p>
                      <h2 class="company-info-heading mt-3 mb-3">ePay<sup>TM</sup></h2>
                      <p>View and pay invoices online. Members are given unique login criteria to view their specific account details quickly and securely. View payment history and pending statements.</p>
                      <h2 class="company-info-heading mt-3 mb-3">Statistical Data Reporting</h2>
                      <p>Quarterly statistical data reports are provided to the pipeline contractor and to the pipeline operators that each contractor works for.</p>
                      <h2 class="company-info-heading mt-3 mb-3">Compliance Audits and/or Updates</h2>
                      <p>All operator audit requests are handled by Pipeline Testing Consortium, Inc. When a pipeline contractor is solicited by the operator, all requested information is to be sent to PTC for response directly to the operator.</p>
                      <p>All new and existing regulations are monitored to maintain complete compliance of the DOT regulations.</p> -->
                      </div>
                    </div>
                    <div class="companyInfo">
                      <div class="col-md-12 col-sm-12">
                        <h2 class="company-info-heading mb-3 mt-4">FEES FOR ALL SERVICES AS OUTLINED</h2>
                        <div class="table-responsive">
                          <table class="table-border-none-padding col-xl-11 mx-auto">
                            <tr>
                              <td style="width:90px" class="text-right pr-3 align-top">$250.00</td>
                              <td><b>Account Setup Fee</b><br />
                                <span style="font-size:13px; line-height:13px">(one time set-up charge)</span>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-right pr-3 align-top">$550.00</td>
                              <td><b>Annual Subscription Fee / Renewal</b><br />
                                <span style="font-size:13px; line-height:13px">(This fee covers statistical data reporting, assistance with compliance audits, record keeping and etc.)</span>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-right pr-3 align-top">$30.00</td>
                              <td><b>Annual Employee Fee</b><br />
                                <span style="font-size:13px; line-height:13px"> <i>(This fee covers the supervisor
                                  training module, EAP informational materials, posters, testing schedules, and
                                    related program resources. The annual employee fee is calculated based on the
                                    average number of employees during the previous 12 months at a rate of $30.00 per
                                    employee, with a maximum annual employee fee of $6,000.00.)</i></span>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-right pr-3 align-top">$85.00</td>
                              <td><b>Each Drug Test</b><br />
                                <span style="font-size:13px; line-height:13px">(This fee covers the specimen
                                  collection, laboratory and MRO fees.)*</span>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-right pr-3 align-top">$85.00</td>
                              <td><b>Each Alcohol Test</b><br />
                                <span style="font-size:13px; line-height:13px">(This fee covers the initial and
                                  confirmation alcohol testing fee.)*</span>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-right pr-3 align-top">$18.00</td>
                              <td><b>Each Drug/Alcohol History Check</b><br />
                                <span style="font-size:13px; line-height:13px">Required by 49 CFR Part 40.25.<br />
                                  <i>$25 history check fee applies if legacy paper authorization method utilized.
                                    (Checks performed through PTC Assist, LLC.)</i></span>
                              </td>
                            </tr>
                          </table>
                        </div>
                        <div style="border:2px solid #ccc" class="px-5 py-3 my-4">
                          <h2 class="text-center mb-1">"Example Estimate Based on Five (5) Employees"</h2>
                          <p class="text-center">(Adjust the estimate for the number of "covered" employees for your
                            company.)</p>
                          <div class="table-responsive mt-3">
                            <table class="table-border-none col-xl-11 mx-auto" cellpadding="0">
                              <tr>
                                <td><strong>Account Setup Fee (1x fee)</strong></td>
                                <td class="text-right">$250.00</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td><strong>Annual Subscription Fee / Renewal</strong></td>
                                <td class="text-right">$550.00</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td><strong>Annual Employee Fee</strong></td>
                                <td class="text-right"></td>
                                <td></td>
                              </tr>
                              <tr>
                                <td><strong>(5 Employees X $30.00)</strong></td>
                                <td class="text-right"><span style="text-decoration:underline">$150.00</span>
                                </td>
                                <td><span style="font-size:13px">(Maximum Employee Fee $6,000)</span></td>
                              </tr>
                              <tr>
                                <td><strong>Total</strong></td>
                                <td class="text-right">$950.00</td>
                                <td></td>
                              </tr>
                            </table>
                          </div>
                          <p style="font-size:13px;font-weight:bold; padding-top:20px">**NOTE** All drug and/or
                            alcohol tests will be invoiced after completion at $85.00 per test if and when any
                            testing is completed. The DOT required history checks will also be invoiced after
                            completion.</p>
                          <p style="font-size:13px">If previous drug testing had been conducted with a SAMHSA certified
                            lab and all tests were DOT 5-panel tests and your company has been conducting random testing
                            at the proper annualized rate. The drug testing records may be transferred with employee
                            release.
                            Contact us with further questions regarding the potential for you to transfer your past DOT
                            records.</p>
                        </div>
                        <p>*PTC consolidates all fees associated with alcohol and drug
                          testing. PTC will pay up to a pre-determined, maximum collection fee per test. Other
                          charges may apply for after-hour, on-site, out-of-network, or non-standard rate testing.
                        </p>
                      </div>
                    </div>
                    <div class="companyInfo">
                      <div class="col-md-12 col-sm-12">

                        <h2 class="company-info-heading mb-3 mt-4">No Refund & Credit Policy</h2>
                        <p>Due to the nature of our services, we have, without exception, a NO REFUND policy. For this reason, we strongly recommend that before payment, you make certain that you understand the nature and cost of the services we provide. Invoices sent by PTC under this agreement are due upon receipt. The company shall owe a finance charge on any balance not paid within 30 days of the date of the invoice at the rate of 1.5% per month or 18% annually and the account may be subject to hold. In the event the company fails to make payments of amounts due under this agreement, PTC is authorized to suspend performance of its obligations to the company until full payment of the amount which the company is in default is received. PTC is not obligated to keep accounts open once an invoice balance has reached 60 days. By way of illustration and not limitation, PTC is expressly allowed, during such period of default, to remove the company from the Consortium and to report on any listing or report of compliance with applicable regulations or, in the case where PTC is listing only the company in compliance to omit such defaulting company. Such action by PTC shall not relieve the company of its obligation to pay any annual, administration, or other fees provided under this agreement.</p>

                        <h2 class="company-info-heading mt-4 mb-3">Electronic Transmission Acknowledgment</h2>
                        <p>This is to confirm your company's permission to use web or e-mail as a means of receiving
                          test results, as opposed to calling the test results out by phone. As the contracted agent,
                          Pipeline Testing Consortium, Inc. maintains all original records on behalf of your company.
                          The
                          guidelines will be as follows: </p>
                        <p>• Individual expectations of privacy and confidentiality must be carefully maintained.
                          Any transmission is confidential and is intended only for the use of the individual or entity
                          identified. If the reader of the communication is not the intended recipient, they are hereby
                          notified that dissemination or distribution of the data contained therein is prohibited under
                          federal and state laws. </p>
                        <p> Please acknowledge that you have read the above requirements/ restrictions for giving /
                          receiving
                          tests results via web or e-mail. </p>

                        <h2 class="company-info-heading mt-4 mb-3">Consumer Report Service Agreement for Employers
                          Subject to Substance Abuse Testing Verification Requirements</h2>
                        <p>(hereinafter "{{objCompanyInfo.CompanyName}}") and PTC Assist, LLC have entered into a
                          Consumer Report
                          Service Agreement (hereinafter "Agreement") through which {{objCompanyInfo.CompanyName}} will
                          utilize PTC Assist to obtain consumer reports for employment purposes.
                          {{objCompanyInfo.CompanyName}} and PTC Assist mutually desire to add the authorization
                          provisions set forth below to the scope of that Agreement. {{objCompanyInfo.CompanyName}} is
                          subject to drug and alcohol testing requirements under federal, state, or local laws,
                          including those enforced by the U.S. Department of Transportation.
                          </p>
                         </div>
                         </div>
                        <div class="companyInfo">
                      <div class="col-md-12 col-sm-12">
                          <p>
                          {{objCompanyInfo.CompanyName}} understands that compliance with these requirements includes
                          verifying the drug and alcohol testing record of certain of its employees or prospective
                          employees. In addition, {{objCompanyInfo.CompanyName}} understands that these requirements
                          impose an obligation on {{objCompanyInfo.CompanyName}} to disclose information regarding the
                          testing history of its current or former employees in response to verification requests from
                          other employers also subject to these requirements. {{objCompanyInfo.CompanyName}} has
                          determined to utilize a consortium / third party administrator(hereinafter "TPA"), to act as
                          {{objCompanyInfo.CompanyName}}'s agent in complying with its alcohol and drug testing
                          requirements.
                          {{objCompanyInfo.CompanyName}}'s TPA is as follows:
                        </p>
                        <p>Third Party Administrator: Pipeline Testing Consortium, Inc.<br />Contact Address: 9 Compound
                          Drive, Hutchinson, KS 67502<br />Contact Phone: 620 - 669 - 8800</p>
                      </div>
                    </div>
                    <div style="padding:0 16px">

                      <p>For the mutual benefit of {{objCompanyInfo.CompanyName}} and PTC Assist,
                        {{objCompanyInfo.CompanyName}} provides the following additional authorizations:</p>
                      <p>Whether in response to a request from {{objCompanyInfo.CompanyName}} or from another employer
                        also subject
                        to the drug and alcohol testing requirements, {{objCompanyInfo.CompanyName}} authorizes PTC
                        Assist to communicate directly with TPA to obtain information regarding the alcohol or drug
                        testing record of any of {{objCompanyInfo.CompanyName}}'s current or former employees.
                      </p>
                      <p>{{objCompanyInfo.CompanyName}} authorizes TPA to release to PTC Assist any information that
                        {{objCompanyInfo.CompanyName}}
                        would be required to release
                        in response to a drug and alcohol testing record verification request regarding any current or
                        former
                        employee of {{objCompanyInfo.CompanyName}}'s. {{objCompanyInfo.CompanyName}} further authorizes
                        PTC Assist to share a copy
                        of this Addendum with TPA, on
                        request, to confirm {{objCompanyInfo.CompanyName}}'s authorization.</p>
                      <p>So that TPA may maintain accurate records for {{objCompanyInfo.CompanyName}},
                        {{objCompanyInfo.CompanyName}} authorizes PTC
                        Assist to share the results
                        of its testing verifications directly with TPA.</p>
                      <p>The authorizations set forth above shall remain in effect until the termination of the
                        Agreement.</p>

                        <app-service-agreement [CompanyName]="objCompanyInfo.CompanyName" [isHighlighted]="false"></app-service-agreement>


                      <!-- //let signedDate = new Date( AckAndAgreement.AckDate); //use your date here
                  //let currentDate = datePipe.transform(signedDate, 'MM/dd/yyyy'); -->

                      <p style='font-size:13px;font-weight:bold; margin-top:28px'>I Agree By checking the "I Accept"
                        box, you are signing these acknowledgments and policies electronically. You agree your
                        electronic signature is the legal equivalent of your manual/handwritten signature on these
                        documents. By selecting "I Accept" using any
                        device, means, or action, you consent to the legally binding terms and conditions of these
                        documents.
                        You further agree that your electronic signature on this document is as valid as if you signed
                        these documents in writing.</p>

                      <div class="row mx-0">
                        <div class="companyname-width">
                          <div class="signature-wrap-height-print" style="padding-bottom:5px">
                            {{objCompanyInfo.CompanyName}}</div>
                          <div style="border-top:1px solid #000;padding-top:5px">
                            <b>Company Name</b>
                          </div>
                        </div>

                        <div class="ms-auto auth authorized-width">
                          <div class="signature-wrap-height-print" style="padding-bottom:5px">
                            {{AckAndAgreement.CompanyRepresentativeName?AckAndAgreement.CompanyRepresentativeName:''}}
                          </div>
                          <div style="border-top:1px solid #000;padding-top:5px; line-height: 16px;">
                            <b>Name of Authorized Company Representative</b>
                          </div>
                        </div>

                        <div class="ms-auto date-width">
                          <div class="signature-wrap-height-print" style="padding-bottom:5px">
                            {{AckAndAgreement.AckDate}}</div>
                          <div style="border-top:1px solid #000; padding-top:5px">
                            <b>Date</b>
                          </div>
                        </div>
                      </div>
                      <!-- <div style="float:left; width:250px; margin-right:30px"><div  style="padding-bottom:5px"></div>
                  <div style="border-top:1px solid #000;padding-top:5px"><b>Company Name</b></div></div> 
                  <div style="float:left; width:250px; margin-right:30px;"> <div style="padding-bottom:5px"></div>
      
                  <div style="border-top:1px solid #000;padding-top:5px"><b>Name of Authorized Company Representative</b></div></div>
                  <div style="float:right; width:160px;"><div style="padding-bottom:5px"></div>
                  <div style="border-top:1px solid #000; padding-top:5px"><b>Date</b></div>
                  </div> -->

                    </div>


                    <div style="position: absolute; left: -1000px; top: -10000px">
                      <kendo-pdf-export #pdfAckExport class="pdf-ack-export" paperSize="A4" margin="1cm" [scale]=0.7
                        keepTogether="h2, tr, .companyInfo li, .row.mx-0">
                        <h2 class="section-2-heading">Acknowledgement and Agreement Policies</h2>
                        <mat-divider class="mat-divider"></mat-divider>
                        <div class="companyInfo mt-4">
                          <div class="col-md-12 col-sm-12 row">
                            <div>
                              <h2 class="company-info-heading-pdf mb-0 pt-0">Outline of Services and Costs</h2>
                              <p class="mt-4">The following services will be performed by our company:</p>
                            </div>
                            <ul style="list-style-type: none;">
                              <li>
                                <h2 class="company-info-heading-pdf mt-2 mb-2">Policy & Procedure Manual</h2>
                                <p>Implementation of your individualized Alcohol and Drug Testing Plans (written policy
                                  & procedure manual). Applicant and employee acknowledgment forms are included.</p>
                              </li>
                              <li>
                                <h2 class="company-info-heading-pdf mt-4 mb-2">Certified Laboratory Services</h2>
                                <p>Drug testing laboratory services for the program is a Substance Abuse and Mental
                                  Health Services Administration (SAMHSA), certified laboratory. The lab for our program
                                  is: Clinical Reference Laboratory, 8433 Quivira, Lenexa, Kansas 66215.</p>
                              </li>
                              <li>
                                <h2 class="company-info-heading-pdf mt-4 mb-2">Medical Review Officer (MRO) Services
                                </h2>
                                <p>The MRO oversees the drug testing results to ensure validity of the results and to
                                  make sure that the employee's rights are preserved. The MRO for our program is: Dr.
                                  David W. Paine, American Medical Review Officers, LLC, 9 Compound Drive, Hutchinson,
                                  Kansas 67502.</p>

                              </li>
                              <li>
                                <h2 class="company-info-heading-pdf mt-4 mb-2">Collection Kit</h2>
                                <p>Testing supplies and kits are provided at no charge with clients only paying for shipping and handling.</p>

                              </li>
                              <li>
                                <h2 class="company-info-heading-pdf mt-4 mb-2">Collection Sites</h2>
                                <p>Included with drug testing is a specimen collection site (your local clinic, hospital or doctors office). 
                                  Approved collection sites are identified on our website (www.pipelinetesting.com). All collection sites 
                                  utilized must be listed in the PTC Collection Site Network. Additional charges may apply for collection 
                                  sites used outside the approved network, for after-hour services, on-site(mobile) testing, and other situations.
                                </p>

                              </li>
                              <li>
                                <h2 class="company-info-heading-pdf mt-4 mb-2">Breath Alcohol Technician (BAT) Services
                                </h2>
                                <p>Trained BATs and collection facilities are provided by either mobile service or
                                  walk-in facilities.</p>

                              </li>
                              <li>
                                <h2 class="company-info-heading-pdf mt-4 mb-2">Testing Schedule</h2>
                                
                                  <div><span style="margin-right: -16px;">All employees working in a "covered" position are subject to unannounced testing based on
                        random selection. All random selections are computer generated. The current annualized random
                        drug testing rate is published on</span> <a style="margin-right: -7px;" class="a-link d-inline py-0" href="https://www.transportation.gov/odapc/random-testing-rates" target="_blank">Random Testing Rates</a> 
                        <span>for employees subject to the PHMSA regulations.</span>
                      </div>

                              </li>
                            </ul>
                          </div>
                        </div>


                        <div class="page-break acknowled">
                          <div class="companyInfo">
                            <div class="col-md-12 col-sm-12 row">
                              <ul style="list-style-type: none;">
                                <li>
                                  <h2 class="company-info-heading-pdf mt-4 mb-2">Employee Assistance Program (EAP) &
                                    Supervisor Training</h2>
                                  <p>The employee assistance program (EAP) includes informational material for each
                                    employee, hot- line number posters, and an online training module covering drug and
                                    alcohol recognition, testing and understanding for supervisors and managers.</p>

                                </li>
                                <li>
                                  <h2 class="company-info-heading-pdf mt-4 mb-2">Substance Abuse Professional (SAP)
                                    Services
                                  </h2>
                                  <p>The Substance Abuse Professional (SAP) provides an evaluation of an employee who
                                    tests positive for alcohol and/or drugs. PTC will coordinate the follow-up program
                                    established by the Substance Abuse Professional.</p>

                                </li>
                                <li>
                                  <h2 class="company-info-heading-pdf mt-4 mb-2">Drug/Alcohol History Checks</h2>
                                  <p>Employers hiring any applicant for a DOT position must obtain information about any
                                    DOT alcohol and/or drug misuse from the applicant's previous employers for the
                                    previous two years (three years if applicant is a CDL driver.) PTC Assist, LLC
                                    provides this verification service for PTC. This service is done in accordance with
                                    49
                                    CFR Part 40.25 requirements.</p>

                                </li>
                                <li>
                                  <h2 class="company-info-heading-pdf mt-4 mb-2">Recordkeeping</h2>
                                  <p>Maintenance and recordkeeping functions are provided. The records are kept
                                    electronically via a secure digital file source and can be retrieved quickly for
                                    submission. PTC also maintains BAT and QAP records.</p>

                                </li>
                                <li>
                                  <h2 class="company-info-heading-pdf mt-4 mb-2">PTC Online Access</h2>
                                  <p>Allows employers to access their pool information 24/7. Employers can view employee
                                    test result history, current random pool lists, history check information and much
                                    more.</p>

                                </li>
                                <li>
                                  <h2 class="company-info-heading-pdf mt-4 mb-2">ePay<sup>TM</sup></h2>
                                  <p>View and pay invoices online. Members are given unique login criteria to view their
                                    specific account details quickly and securely. View payment history and pending
                                    statements.</p>

                                </li>

                                <li>
                                  <h2 class="company-info-heading-pdf mt-4 mb-2">Statistical Data Reporting</h2>
                                  <p>Quarterly statistical data reports are provided to the pipeline contractor and to
                                    the
                                    pipeline operators that each contractor works for.</p>
                                </li>
                                <li>
                                  <h2 class="company-info-heading-pdf mt-4 mb-2">Compliance Audits and/or Updates</h2>
                                  <p>All operator audit requests are handled by Pipeline Testing Consortium, Inc. When a
                                    pipeline contractor is solicited by the operator, all requested information is to be
                                    sent to PTC for response directly to the operator.</p>
                                  <p>All new and existing regulations are monitored to maintain complete compliance of
                                    the
                                    DOT regulations.</p>
                                </li>
                              </ul>
                              <!-- <h2 class="company-info-heading mb-3">Employee Assistance Program (EAP) & Supervisor Training</h2>
        <p>The employee assistance program (EAP) includes informational material for each employee, hot- line number posters, and an online training module covering drug and alcohol recognition, testing and understanding for supervisors and managers.</p>
        <h2 class="company-info-heading mt-3 mb-3">Substance Abuse Professional (SAP) Services</h2>
        <p>The Substance Abuse Professional (SAP) provides an evaluation of an employee who tests positive for alcohol and/or drugs. PTC will coordinate the follow-up program established by the Substance Abuse Professional.</p>
        <h2 class="company-info-heading mt-3 mb-3">Drug/Alcohol History Checks</h2>
        <p>Employers hiring any applicant for a DOT position must obtain information about any DOT alcohol and/or drug misuse from the applicant's previous employers for the previous two years (three years if applicant is a CDL driver.) PTC Assist, LLC provides this verification service for PTC. This service is done in accordance with 49 CFR Part 40.25 requirements.</p>
        <h2 class="company-info-heading mt-3 mb-3">Recordkeeping</h2>
        <p>Maintenance and recordkeeping functions are provided. The records are kept electronically via a secure digital file source and can be retrieved quickly for submission. PTC also maintains BAT and QAP records.</p>
        <h2 class="company-info-heading mt-3 mb-3">PTC Online Access</h2>
        <p>Allows employers to access their pool information 24/7. Employers can view employee test result history, current random pool lists, history check information and much more.</p>
        <h2 class="company-info-heading mt-3 mb-3">ePay<sup>TM</sup></h2>
        <p>View and pay invoices online. Members are given unique login criteria to view their specific account details quickly and securely. View payment history and pending statements.</p>
        <h2 class="company-info-heading mt-3 mb-3">Statistical Data Reporting</h2>
        <p>Quarterly statistical data reports are provided to the pipeline contractor and to the pipeline operators that each contractor works for.</p>
        <h2 class="company-info-heading mt-3 mb-3">Compliance Audits and/or Updates</h2>
        <p>All operator audit requests are handled by Pipeline Testing Consortium, Inc. When a pipeline contractor is solicited by the operator, all requested information is to be sent to PTC for response directly to the operator.</p>
        <p>All new and existing regulations are monitored to maintain complete compliance of the DOT regulations.</p> -->
                            </div>
                          </div>
                        </div>

                        <div class="page-break acknowled">
                          <div class="companyInfo">
                            <div class="col-md-12 col-sm-12">
                              <h2 class="company-info-heading-pdf mb-3 mt-4">FEES FOR ALL SERVICES AS OUTLINED</h2>
                              <div class="table-responsive">
                                <table class="table-border-none-padding col-xl-11 mx-auto">
                                  <tr>
                                    <td style="width:90px" class="text-right pr-3 align-top">$250.00</td>
                                    <td><b>Account Setup Fee</b><br />
                                      <span style="font-size:13px; line-height:13px">(one time set-up charge)</span>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style="width:90px" class="text-right pr-3 align-top">$550.00</td>
                                    <td><b>Annual Subscription Fee / Renewal</b><br />
                                      <span style="font-size:13px; line-height:13px">(This fee covers statistical data reporting, assistance with compliance audits, record keeping and etc.)</span>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style="width:90px" class="text-right pr-3 align-top">$30.00</td>
                                    <td><b>Annual Employee Fee</b><br />
                                      <span style="font-size:13px; line-height:13px"> <i>(This fee covers the supervisor
                                        training module, EAP informational materials, posters, testing schedules, and
                                        related program resources. The annual employee fee is calculated based on the
                                          average number of employees during the previous 12 months at a rate of $30.00
                                          per employee, with a maximum annual employee fee of $6,000.00.)</i></span>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style="width:90px" class="text-right pr-3 align-top">$85.00</td>
                                    <td><b>Each Drug Test</b><br />
                                      <span style="font-size:13px; line-height:13px">(This fee covers the specimen
                                        collection, laboratory and MRO fees.)*</span>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style="width:90px" class="text-right pr-3 align-top">$85.00</td>
                                    <td><b>Each Alcohol Test</b><br />
                                      <span style="font-size:13px; line-height:13px">(This fee covers the initial and
                                        confirmation alcohol testing fee.)*</span>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style="width:90px" class="text-right pr-3 align-top">$18.00</td>
                                    <td><b>Each Drug/Alcohol History Check</b><br />
                                      <span style="font-size:13px; line-height:13px">Required by 49 CFR Part
                                        40.25.<br />
                                        <i>$25 history check fee applies if legacy paper authorization method utilized.
                                          (Checks performed through PTC Assist, LLC.)</i></span>
                                    </td>
                                  </tr>
                                </table>
                              </div>
                              <div style="border:2px solid #ccc" class="px-5 py-3 my-4">
                                <h2 class="text-center mb-1">"Example Estimate Based on Five (5) Employees"</h2>
                                <p class="text-center">(Adjust the estimate for the number of "covered" employees for
                                  your
                                  company.)</p>
                                <div class="table-responsive mt-3">
                                  <table class="table-border-none col-xl-11 mx-auto" cellpadding="0">
                                    <tr>
                                      <td><strong>Account Setup Fee (1x fee)</strong></td>
                                      <td class="text-right">$250.00</td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td><strong>Annual Subscription Fee / Renewal</strong></td>
                                      <td class="text-right">$550.00</td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td><strong>Annual Employee Fee</strong></td>
                                      <td class="text-right"></td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td><strong>(5 Employees X $30.00)</strong></td>
                                      <td class="text-right"><span style="text-decoration:underline">$150.00</span>
                                      </td>
                                      <td><span style="font-size:13px">(Maximum Employee Fee $6,000)</span></td>
                                    </tr>
                                    <tr>
                                      <td><strong>Total</strong></td>
                                      <td class="text-right">$950.00</td>
                                      <td></td>
                                    </tr>
                                  </table>
                                </div>
                                <p style="font-size:13px;font-weight:bold; padding-top:20px">**NOTE** All drug and/or
                                  alcohol tests will be invoiced after completion at $85.00 per test if and when any
                                  testing is completed. The DOT required history checks will also be invoiced after
                                  completion.</p>
                                <p style="font-size:13px">If previous drug testing had been conducted with a SAMHSA
                                  certified lab and all tests were DOT 5-panel tests and your company has been
                                  conducting random testing at the proper annualized rate. The drug testing records may
                                  be transferred with employee release.
                                  Contact us with further questions regarding the potential for you to transfer your
                                  past DOT records.</p>
                              </div>
                              <p>*PTC consolidates all fees associated with alcohol and drug
                                testing. PTC will pay up to a pre-determined, maximum collection fee per test. Other
                                charges may apply for after-hour, on-site, out-of-network, or non-standard rate testing.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="page-break acknowled">
                          <div class="companyInfo">
                            <div class="col-md-12 col-sm-12">

                              <h2 class="company-info-heading-pdf mb-3 mt-4">No Refund & Credit Policy</h2>
                              <p>Due to the nature of our services, we have, without exception, a NO REFUND policy. For this reason, we strongly recommend that before payment, you make certain that you understand the nature and cost of the services we provide. Invoices sent by PTC under this agreement are due upon receipt. The company shall owe a finance charge on any balance not paid within 30 days of the date of the invoice at the rate of 1.5% per month or 18% annually and the account may be subject to hold. In the event the company fails to make payments of amounts due under this agreement, PTC is authorized to suspend performance of its obligations to the company until full payment of the amount which the company is in default is received. PTC is not obligated to keep accounts open once an invoice balance has reached 60 days. By way of illustration and not limitation, PTC is expressly allowed, during such period of default, to remove the company from the Consortium and to report on any listing or report of compliance with applicable regulations or, in the case where PTC is listing only the company in compliance to omit such defaulting company. Such action by PTC shall not relieve the company of its obligation to pay any annual, administration, or other fees provided under this agreement.</p>

                              <h2 class="company-info-heading-pdf mt-4 mb-3">Electronic Transmission Acknowledgment</h2>
                              <p>This is to confirm your company's permission to use web or e-mail as a means of
                                receiving
                                test results, as opposed to calling the test results out by phone. As the contracted
                                agent,
                                Pipeline Testing Consortium, Inc. maintains all original records on behalf of your
                                company. The
                                guidelines will be as follows: </p>
                              <p>• Individual expectations of privacy and confidentiality must be carefully maintained.
                                Any transmission is confidential and is intended only for the use of the individual or
                                entity
                                identified. If the reader of the communication is not the intended recipient, they are
                                hereby
                                notified that dissemination or distribution of the data contained therein is prohibited
                                under
                                federal and state laws. </p>
                              <p> Please acknowledge that you have read the above requirements/ restrictions for giving
                                / receiving
                                tests results via web or e-mail. </p>

                              <h2 class="company-info-heading-pdf mt-4 mb-3">Consumer Report Service Agreement for
                                Employers Subject to Substance Abuse Testing Verification Requirements</h2>
                              <p>(hereinafter "{{objCompanyInfo.CompanyName}}") and PTC Assist, LLC have entered into a
                                Consumer Report
                                Service Agreement (hereinafter "Agreement") through which {{objCompanyInfo.CompanyName}}
                                will utilize PTC Assist to obtain consumer reports for employment purposes.
                                {{objCompanyInfo.CompanyName}} and PTC Assist mutually desire to add the authorization
                                provisions set forth below to the scope of that Agreement.
                              </p>
                           <p> {{objCompanyInfo.CompanyName}} is subject to drug and alcohol testing requirements under
                            federal, state, or local laws, including those enforced by the U.S. Department of
                            Transportation. {{objCompanyInfo.CompanyName}} understands that compliance with these
                            requirements includes verifying the drug and alcohol testing record of certain of its
                            employees or prospective employees. In addition, {{objCompanyInfo.CompanyName}} understands
                            that these requirements impose an obligation on {{objCompanyInfo.CompanyName}} to disclose
                            information regarding the testing history of its current or former employees in response to
                            verification requests from other employers also subject to these requirements.
                            {{objCompanyInfo.CompanyName}} has determined to utilize a consortium / third party
                            administrator(hereinafter "TPA"), to act as {{objCompanyInfo.CompanyName}}'s agent in
                            complying with its alcohol and drug testing requirements.
                            {{objCompanyInfo.CompanyName}}'s TPA is as follows:</p>
                            </div>
                          </div>

                        
                          
                            </div>
                        <div class="page-break acknowled">
                           
                          <p>Third Party Administrator: Pipeline Testing Consortium, Inc.<br />Contact Address: 9
                            Compound
                            Drive, Hutchinson, KS 67502<br />Contact Phone: 620 - 669 - 8800</p>
                          <p>For the mutual benefit of {{objCompanyInfo.CompanyName}} and PTC Assist,
                            {{objCompanyInfo.CompanyName}} provides the following additional authorizations:</p>
                          <p>Whether in response to a request from {{objCompanyInfo.CompanyName}} or from another
                            employer also subject
                            to the drug and alcohol testing requirements, {{objCompanyInfo.CompanyName}} authorizes PTC
                            Assist to communicate directly with TPA to obtain information regarding the alcohol or drug
                            testing record of any of {{objCompanyInfo.CompanyName}}'s current or former employees.
                          </p>
                          <p>{{objCompanyInfo.CompanyName}} authorizes TPA to release to PTC Assist any information that
                            {{objCompanyInfo.CompanyName}}
                            would be required to release
                            in response to a drug and alcohol testing record verification request regarding any current
                            or
                            former
                            employee of {{objCompanyInfo.CompanyName}}'s. {{objCompanyInfo.CompanyName}} further
                            authorizes PTC Assist to share a copy
                            of this Addendum with TPA, on
                            request, to confirm {{objCompanyInfo.CompanyName}}'s authorization.</p>
                          <p>So that TPA may maintain accurate records for {{objCompanyInfo.CompanyName}},
                            {{objCompanyInfo.CompanyName}} authorizes PTC
                            Assist to share the results
                            of its testing verifications directly with TPA.</p>
                          <p>The authorizations set forth above shall remain in effect until the termination of the
                            Agreement.</p>
                          </div>
                          <div class="page-break acknowled">
                          <app-service-agreement-pdf [CompanyName]="objCompanyInfo.CompanyName"></app-service-agreement-pdf>
                          
                           <ul style="padding-left:20px; margin:12px 0;">

                               <li style="margin-bottom:12px;">
                                 <span style="font-weight:bold;">TERM:</span> The Term of this Agreement will start on the 1st day of the Month in which this Agreement is electronically signed by the
                                 {{ objCompanyInfo.CompanyName }}
                                 and will continue until terminated in accordance with the terms and conditions of this Agreement.
                               </li>

                               <li style="margin-bottom:12px;">
                                 <span style="font-weight:bold;">SUBSCRIPTION FEES.</span> In exchange for the Services and Membership in the PTC Consortium, the
                                 {{ objCompanyInfo.CompanyName }}
                                 shall pay an Annual Subscription Fee and Annual Employee Fee as established by PTC from time to time (the “Fees”) which shall be paid in accordance with PTC’s No Refund and Credit Policy. PTC may terminate or suspend this Agreement, the Services under this Agreement, and remove
                                 {{ objCompanyInfo.CompanyName }}
                                 from the Consortium if {{ objCompanyInfo.CompanyName }} is in default of its obligations to pay the Fees or is in default under PTC’s No Refund and Credit Policy. This Agreement and Membership in the Consortium may be canceled in writing by
                                 {{ objCompanyInfo.CompanyName }} at any time, however, there is NO REFUND for any unused portion of the Fees.
                               </li>
                               </ul>
                        </div>
                          <div class="page-break acknowled">

                          <ul style="padding-left:20px; margin:12px 0;">
                              <li style="margin-bottom:12px;">
                                 <span style="font-weight:bold;">RECORDS RETENTION:</span> PTC shall retain records, including the {{ objCompanyInfo.CompanyName }}’s records, for the period of their immediate or current use, unless longer retention is necessary for historical reference or to comply with contractual or legal requirements. Thereafter, all records may be destroyed in accord with PTC’s then-current records retention policy.
                               </li>
                                 <li style="margin-bottom:12px;">
                                 <span style="font-weight:bold;">COOPERATION.</span>
                                 {{ objCompanyInfo.CompanyName }} will reasonably cooperate with PTC to facilitate PTC's responsibilities under this Agreement. Reasonable cooperation shall include, but not be limited to, making reasonable efforts to insure that those employees subject to DOT regulations and/or NON-DOT requirements adhere to the
                                 {{ objCompanyInfo.CompanyName }}’s
                                 Alcohol and Drug Program and PTC procedures; submit to drug and alcohol testing, conduct DOT background/history checks, education or training as appropriate and travel to PTC specimen collection sites when required by PTC and/or
                                 {{ objCompanyInfo.CompanyName }}.
                                 <br><br>
                                 The {{ objCompanyInfo.CompanyName }} shall designate PTC as its agent and hereby authorize PTC to receive all test results from the MRO. PTC shall promptly, upon receipt from the MRO, report all test results to
                                 {{ objCompanyInfo.CompanyName }}.
                                 {{ objCompanyInfo.CompanyName }} shall designate a
                                 {{ objCompanyInfo.CompanyName }} management official as the Designated Employer Representative (DER) to receive such confidential test results from PTC. PTC shall maintain all test results and records in strict confidence consistent with applicable DOT regulations and/or NON-DOT requirements.
                               </li>
                                   <li style="margin-bottom:12px;">
                                 <span style="font-weight:bold;">DEFAULT.</span> In the event
                                 {{ objCompanyInfo.CompanyName }}
                                 fails to make payments of amounts due under this contract within 30 days from the date of invoice, PTC is authorized to suspend performance of its obligations to
                                 {{ objCompanyInfo.CompanyName }}
                                 until full payment of the amount upon which
                                 {{ objCompanyInfo.CompanyName }}
                                 is in default. PTC is not obligated to keep accounts open once an invoice balance has reached 60 days. By way of illustration and not limitation, PTC is expressly allowed, during such period of default, to remove
                                 {{ objCompanyInfo.CompanyName }}
                                 from the Consortium and to report on any listing or report of compliance prepared or caused to be prepared by PTC that
                                 {{ objCompanyInfo.CompanyName }}
                                 is not in compliance with applicable regulations (or, in the case where PTC is listing only
                                 {{ objCompanyInfo.CompanyName }}’s
                                 in compliance, to omit such defaulting
                                 {{ objCompanyInfo.CompanyName }}). Such action by PTC shall not relieve
                                 {{ objCompanyInfo.CompanyName }}
                                 of its obligation to pay any annual, administration, or other fees provided herein.
                               </li>
                                  <li style="margin-bottom:12px;">
                                 <span style="font-weight:bold;">REIMBURSEMENT.</span>
                                 {{ objCompanyInfo.CompanyName }}
                                 agrees to be solely responsible for obtaining reimbursement for testing costs from
                                 {{ objCompanyInfo.CompanyName }}
                                 employees where desired by
                                 {{ objCompanyInfo.CompanyName }}
                                 and where permissible under applicable laws and employment contracts.
                               </li>
                                    
                                 <li style="margin-bottom:12px;">
                                 <span style="font-weight:bold;">ADDITIONAL COMPENSATION.</span> To the extent the issuance of new, amended or supplemental regulations by the Department of Transportation necessitates additional testing or other services not contemplated by the terms of this Agreement, the compensation to be paid to PTC as a result of the additional testing or other services shall be agreed upon by the parties to this Agreement, but shall in no event be less than the actual cost incurred by PTC in providing the additional testing or other services.
                               </li>
                                <li style="margin-bottom:12px;">
                                 <span style="font-weight:bold;">RESPONSIBILITY REGARDING TEST RESULTS, DETERMINATIONS, REFERRALS, AND REPORTING;</span> {{ objCompanyInfo.CompanyName }} shall be solely responsible for taking any action required by applicable DOT regulations or NON-DOT requirements based on an employee’s positive or refused drug or alcohol test. {{ objCompanyInfo.CompanyName }} shall also be solely responsible for any other post-testing action concerning the employment status of its employee, whether required by applicable regulations, {{ objCompanyInfo.CompanyName }} requirements, or {{ objCompanyInfo.CompanyName }}’s discretion. In addition, {{ objCompanyInfo.CompanyName }} is responsible for making any testing determinations required by applicable DOT regulations or NON-DOT requirements for post-accident, reasonable-cause, or refusal-to-test situations. {{ objCompanyInfo.CompanyName }} shall make any required referral to a qualified Substance Abuse Professional following a positive or refused drug or alcohol test. If applicable, {{ objCompanyInfo.CompanyName }} is responsible for any required reporting to the Federal Motor Carrier Safety Administration Clearinghouse, except those items required to be reported by the Medical Review Officer.
                               </li>
                               </ul>
                          </div>
                          <div class="page-break acknowled">
                             <ul style="padding-left:20px; margin:12px 0;">

                               <li style="margin-bottom:12px;">
                                 <span style="font-weight:bold;">INDEMNITY.</span> {{ objCompanyInfo.CompanyName }} agrees to hold PTC harmless and to indemnify and defend PTC from all claims, causes of action, or suits by employees or third parties except those that are a direct and proximate result of PTC’s willful wrongdoing, gross negligence, or fraud in the performance of functions administered by it under this Agreement.
                               </li>

                               <li style="margin-bottom:12px;">
                                 <span style="font-weight:bold;">JURISDICTION.</span> This Agreement shall be governed by and construed under the laws of the State of Kansas without regard to conflicts of laws principles. Any action or proceeding seeking to enforce any provision of, or based on any right arising out of, this Agreement shall be brought against either of the parties only in the courts of the State of Kansas, County of Reno, or, if it has or can acquire jurisdiction, in the United States District Court for the District of Kansas, and each of the parties consents to the exclusive jurisdiction of such courts (and of the appropriate appellate courts) in any such action or proceeding and waives any objection to venue laid therein. Process in any action or proceeding referred to in the preceding sentence may be served on either party anywhere in the world.
                               </li>

                               <li style="margin-bottom:12px;">
                                 <span style="font-weight:bold;">SEVERABILITY.</span> If any provision of this Agreement is held invalid or unenforceable by any court of competent jurisdiction, the other provisions of this Agreement will remain in full force and effect. Any provision of this Agreement held invalid or unenforceable only in part or degree will remain in full force and effect to the extent not held invalid or unenforceable.
                               </li>

                               <li style="margin-bottom:12px;">
                                 <span style="font-weight:bold;">BINDING EFFECT.</span> This Agreement shall be binding upon and inure to the benefit of the successors and assigns of the parties hereto.
                               </li>
                             
                              </ul>

                          <!-- //let signedDate = new Date( AckAndAgreement.AckDate); //use your date here
  //let currentDate = datePipe.transform(signedDate, 'MM/dd/yyyy'); -->

                          <p style='font-size:13px;font-weight:bold; margin-top:28px'>I Agree By checking the "I Accept"
                            box, you are signing these acknowledgments and policies electronically. You agree your
                            electronic signature is the legal equivalent of your manual/handwritten signature on these
                            documents. By selecting "I Accept" using any
                            device, means, or action, you consent to the legally binding terms and conditions of these
                            documents.
                            You further agree that your electronic signature on this document is as valid as if you
                            signed
                            these documents in writing.</p>

                          <div class="row mx-0">
                            <div class="companyname-width">
                              <div class="signature-wrap-height-print" style="padding-bottom:5px">
                                {{objCompanyInfo.CompanyName}}</div>
                              <div style="border-top:1px solid #000;padding-top:5px">
                                <b>Company Name</b>
                              </div>
                            </div>

                            <div class="ms-auto auth authorized-width">
                              <div class="signature-wrap-height-print" style="padding-bottom:5px">
                                {{AckAndAgreement.CompanyRepresentativeName?AckAndAgreement.CompanyRepresentativeName:''}}
                              </div>
                              <div style="border-top:1px solid #000;padding-top:5px; line-height: 16px;">
                                <b>Name of Authorized Company Representative</b>
                              </div>
                            </div>

                            <div class="ms-auto date-width">
                              <div class="signature-wrap-height-print" style="padding-bottom:5px">
                                {{AckAndAgreement.AckDate}}</div>
                              <div style="border-top:1px solid #000; padding-top:5px">
                                <b>Date</b>
                              </div>
                            </div>
                          </div>
                          </div>
                          <!-- <div style="float:left; width:250px; margin-right:30px"><div  style="padding-bottom:5px"></div>
  <div style="border-top:1px solid #000;padding-top:5px"><b>Company Name</b></div></div> 
  <div style="float:left; width:250px; margin-right:30px;"> <div style="padding-bottom:5px"></div>

  <div style="border-top:1px solid #000;padding-top:5px"><b>Name of Authorized Company Representative</b></div></div>
  <div style="float:right; width:160px;"><div style="padding-bottom:5px"></div>
  <div style="border-top:1px solid #000; padding-top:5px"><b>Date</b></div>
  </div> -->

                      </kendo-pdf-export>
                    </div>

                  </div>
                  <div class="modal-footer">
                    <button type="button" class="swal2-confirm swal2-styled"
                      (click)="modal.close('Ok click')">OK</button>
                    <button class="next action-button popup_print_btn" kendoButton
                      (click)="pdfAckExportDownload()">
                      Download
                    </button>

                  </div>
                </ng-template>

              </fieldset>
            </form>
            <form id="msform">
              <fieldset *ngIf="step == 4">
                <div class="form-card">
                  <div class="row">
                    <div class="col-md-12">
                      <h2 class="fs-title">Summary & Fees</h2>
                    </div>
                    <div class="col-xl-8 col-lg-7 col-md-12 font-weight-normal">
                      <h3><b>{{ objCompanyInfo.CompanyName }}</b></h3>
                      Programs Requested:&nbsp;<strong><span *ngIf="objProgramInfo.ProgramSelection.DotFederal">DOT
                          ({{DotCompanyFederalSeletedPrograms}}), </span><span
                          *ngIf=" objProgramInfo.ProgramSelection.NonDotCompnay">Non-DOT
                          (Company), </span><span *ngIf="objProgramInfo.ProgramSelection.ClientRequired">Client
                          Required</span></strong><br />
                      Affiliate&nbsp;Company&nbsp;Name:&nbsp;<strong>{{
                         objCompanyInfo.SisterCompanyName? objCompanyInfo.SisterCompanyName:'None'
                        }}</strong><br />
                      Reinstatement&nbsp;Account:&nbsp;<strong>{{
                         objCompanyInfo.ReinstatedAccountNumber?  objCompanyInfo.ReinstatedAccountNumber:'None'
                        }}</strong><br />
                      Address:&nbsp;<strong>{{
                         objCompanyInfo.MailingAddress +
                        ", " +
                         objCompanyInfo.City +
                        ", " +
                         objCompanyInfo.State +
                        ", " +
                        GetZipFormat( objCompanyInfo.Zip) +
                        ", " +
                         objCompanyInfo.Country
                        }}</strong><br />
                      DER:&nbsp;<strong>{{
                         objCompanyInfo.objDer.Name
                        }}</strong><br />
                      Phone No:&nbsp;<strong>{{
                        GetPhoneNoFormat( objCompanyInfo.objDer.PhoneNo)
                        }}</strong><br />
                      Email:&nbsp;<strong>{{
                         objCompanyInfo.objDer.Email
                        }}</strong><br />
                      Main Billing Contact:&nbsp;<strong>{{
                         objCompanyInfo.BillingContact.BillingContactName
                        }}</strong><br />
                      # of Employees in a Random Pool:&nbsp;<strong>{{
                        objProgramInfo.NumberOfEmployees
                        }}</strong><br />

                      <div class="mt-3 mb-4">
                        <table class="w-100">
                          <tr>
                            <td style="width: 330px">
                              <span style="font-weight: bold; font-size: 18px">Account Setup Fee:</span>
                            </td>
                            <td style="
                                width: 100px;
                                font-weight: bold;
                                font-size: 18px;
                                vertical-align: top;
                                text-align: right;
                              ">
                              ${{
                              NumberWithCommasWithTwoDecimal(CustomerInfo?.CustomerDetails.FeeDetails.SetupFee)
                              }}
                            </td>
                            <td></td>
                          </tr>
                          <tr>
                            <td style="font-weight: bold; font-size: 18px">
                              Annual Subscription:
                            </td>
                            <td style="
                                font-weight: bold;
                                font-size: 18px;
                                vertical-align: top;
                                text-align: right;
                              ">
                              ${{
                              NumberWithCommasWithTwoDecimal(CustomerInfo?.CustomerDetails.FeeDetails
                              .AnnualSubscription)
                              }}
                            </td>
                            <td></td>
                          </tr>
                          <tr>
                            <td>
                              <span style="font-weight: bold; font-size: 18px">+ Annual Employee Fee*:</span><br />
                              <!--({{
                              objProgramInfo.FederalProgram
                              .NumberOfEmployees +
                              objProgramInfo.CompanyProgram
                              .NumberOfEmployees +
                              objProgramInfo.OtherProgram.NumberOfEmployees
                              }}
                              employees in a random pool x $30)-->

                            </td>
                            <td style="
                                font-weight: bold;
                                font-size: 18px;
                                vertical-align: top;
                                /*display: inline-block;
                                 border-bottom: 1px solid var(--black); */
                                vertical-align: top;
                                min-width: 58px;
                                text-align: right;
                              ">
                              ${{ NumberWithCommasWithTwoDecimal(randomPool) }}
                            </td>
                            <td></td>
                          </tr>
                          <!-- <tr>
                           <td colspan="2" class="mt-4" style="font-weight: normal">
                              <h5>*This amount may change year to year. This fee is based on
                                how many employees are in your random testing pools on your
                                renewal dates.</h5>
                            </td>
                          </tr>-->
                          <tr>
                            <td style="
                                font-weight: bold;
                                font-size: 18px;
                              ">
                              Shipping & Handling:
                            </td>
                            <td style="
                                font-weight: bold;
                                font-size: 18px;
                                vertical-align: top;
                                text-align: right;
                              ">
                              ${{
                              NumberWithCommasWithTwoDecimal(CustomerInfo?.CustomerDetails.FeeDetails
                              .ExpeditedShippingFee)
                              }}
                            </td>
                            <td></td>
                          </tr>
                          <tr>
                            <td style="
                                font-weight: bold;
                                font-size: 18px;
                                
                              ">
                              Sales Tax ({{SalesTax>0?SalesTaxPercent:0}}%)**:
                            </td>
                            <td style="
                                font-weight: bold;
                                font-size: 18px;
                                vertical-align: top;
                                text-align: right;
                              ">
                              ${{
                              NumberWithCommasWithTwoDecimal(SalesTax)
                              }}
                            </td>
                            <td></td>
                          </tr>
                          <tr>
                            <td style="
                                font-weight: bold;
                                font-size: 24px;
                                padding-top: 15px;
                              ">
                              Enrollment Total:
                            </td>
                            <td style="
                                font-weight: bold;
                                font-size: 24px;
                                padding-top: 15px;
                                vertical-align: top;
                                text-align: right;
                              ">
                              ${{
                              NumberWithCommasWithTwoDecimal(
                              EnrollmentTotalFee)

                              }}
                            </td>
                            <td></td>
                          </tr>
                          <tr>

                            <td colspan="3">
                              <h5 class="mb-2 mt-2">*The annual employee fee is calculated based on the average
                                number of employees during the previous 12 months at a rate of $30.00 per employee,
                                with a maximum annual employee fee of $6,000.00</h5>

                              <h5 class="mb-0">**All South Dakota based accounts are subject to sales tax.
                                Completing and submitting this enrollment authorizes PTC to charge the applicable sales
                                tax rate based upon your jurisdiction at the time the credit card is processed or
                                invoice is issued.</h5>
                            </td>
                            <td></td>
                          </tr>
                          <!-- <tr>
                              <td
                                style="
                                  font-weight: bold;
                                  font-size: 24px;
                                  padding-top: 10px;
                                "
                              >
                                Enrollment Total:
                              </td>
                              <td
                                style="
                                  font-weight: bold;
                                  font-size: 24px;
                                  padding-top: 10px;
                                  vertical-align: top;
                                "
                              >
                                ${{
                                  NumberWithCommasWithTwoDecimal(
                                    CustomerInfo?.CustomerDetails.FeeDetails.SetupFee +
                                    CustomerInfo?.CustomerDetails.FeeDetails.AnnualSubscription +
                                    CustomerInfo?.CustomerDetails.FeeDetails.AnnualEmployeeFee +
                                    randomPool
                                  )
                                }}
                              </td>
                            </tr> -->
                          <tr>
                            <td style="
                                font-weight: bold;
                                font-size: 18px;
                                padding-top: 24px;
                              ">
                              Per Use Fees
                            </td>
                            <td style="
                            font-weight: bold;
                            font-size: 18px;
                            padding-top: 24px;
                            text-align: right;
                          "></td>
                            <td></td>
                          </tr>
                          <tr
                            *ngIf="objProgramInfo.ProgramSelection.DotFederal  == true || objProgramInfo.ProgramSelection.NonDotCompnay == true || objProgramInfo.ProgramSelection.ClientRequired === true">
                            <td style="font-size: 16px">Drug Test:</td>
                            <td style="font-size: 16px; vertical-align: top; text-align: right;">
                              ${{
                              NumberWithCommasWithTwoDecimal(CustomerInfo?.CustomerDetails.FeeDetails.DrugTest)
                              }}
                            </td>
                            <td></td>
                          </tr>
                          <tr *ngIf="IsExxonMobilDrugTest">
                            <td style="font-size: 16px">
                              ExxonMobil Drug Test:
                            </td>
                            <td style="font-size: 16px; vertical-align: top; text-align: right;">
                              ${{
                              NumberWithCommasWithTwoDecimal(CustomerInfo?.CustomerDetails.FeeDetails
                              .ExxonMobilDrugTest)
                              }}
                            </td>
                            <td></td>
                          </tr>

                          <tr
                            *ngIf="objProgramInfo.ProgramSelection.DotFederal  == true || objProgramInfo.ProgramSelection.NonDotCompnay == true || objProgramInfo.ProgramSelection.ClientRequired === true">
                            <td style="font-size: 16px">Alcohol Test:</td>
                            <td style="font-size: 16px; vertical-align: top; text-align: right;">
                              ${{
                              NumberWithCommasWithTwoDecimal(CustomerInfo?.CustomerDetails.FeeDetails
                              .AlcoholTest)
                              }}
                            </td>
                            <td></td>
                          </tr>
                          <tr
                            *ngIf="objProgramInfo.ProgramSelection.DotFederal  == true || objProgramInfo.ProgramSelection.NonDotCompnay == true || objProgramInfo.ProgramSelection.ClientRequired === true">
                            <td style="font-size: 16px">Electronic Drug/Alcohol History Check:</td>
                            <td style="font-size: 16px; vertical-align: top; text-align: right;">
                              ${{
                              NumberWithCommasWithTwoDecimal(CustomerInfo?.CustomerDetails.FeeDetails
                              .DOTHistoryCheck)
                              }}
                            </td>
                            <td></td>
                          </tr>

                          <tr>
                            <td style="font-size: 16px">
                              Paper Based Drug/Alcohol History Check:
                            </td>
                            <td style="font-size: 16px; vertical-align: top; text-align: right;">
                              ${{
                              NumberWithCommasWithTwoDecimal(CustomerInfo?.CustomerDetails.FeeDetails
                              .PaperBasedDrugAlcoholHistoryCheckFee)
                              }}
                            </td>
                            <td></td>
                          </tr>
                        </table>
                      </div>

                      <!-- <div class="col-md-12 mt-3">
                            <h2 class="fs-subtitle">Company Information</h2>
                          </div>
                          <div class="col-md-12 mt-2">
                            <table class="lstTable">
                              <tr>
                                <th>Heading</th>
                                <th>Value</th>
                              </tr>
                              <tr *ngFor="let objSummary of lstShowSummary; let i=index;">
                                <td>{{objSummary.key}}</td>
                                <td>{{objSummary.value}}</td>
                              </tr>
                            </table>
                          </div>
    
                          <div class="col-md-12 mt-3">
                            <h2 class="fs-subtitle">Billing Information</h2>
                          </div>
                          <div class="col-md-12 mt-2">
                            <table class="lstTable">
                              <tr>
                                <th>Heading</th>
                                <th>Value</th>
                              </tr>
                              <tr *ngFor="let objBillingInfo of lstShowSummaryBillingInfo; let i=index;">
                                <td>{{objBillingInfo.key}}</td>
                                <td>{{objBillingInfo.value}}</td>
                              </tr>
                            </table>
                          </div> -->
                    </div>
                    <!--<div class="col-md-6">
                          <div class="col-md-12">
                            <span style="padding-right:10px"><strong>Company Name: </strong></span> <span class="span-show-summary" innerText='{{ objCompanyInfo.CompanyName}}'></span>
                          </div>
                          <div class="col-md-12">
                            <span style="padding-right:10px"><strong>Mailing address:  </strong></span><span class="span-show-summary" innerText='{{ objCompanyInfo.MailingAddress}}'></span>
                          </div>
                          <div class="col-md-12">
                            <span style="padding-right:10px"><strong>Phone No.:  </strong></span><span class="span-show-summary" innerText='{{ objCompanyInfo.CompanyPhoneNo}}'></span>
                          </div>
                          <div class="col-md-12">
                            <span style="padding-right:10px"><strong>Tax Id No.:  </strong></span><span class="span-show-summary" innerText='{{ showTaxIdNo}}'></span>
                          </div>
                          <div class="col-md-12">
                            <span style="padding-right:10px"><strong>ISN No.:  </strong></span><span class="span-show-summary" innerText='{{ showIsnNo}}'></span>
                          </div>
                          <div class="col-md-12">
                            <span style="padding-right:10px"><strong>ITS No.:  </strong></span><span class="span-show-summary" innerText='{{ showItsNo}}'></span>
                          </div>
                          <div class="col-md-12">
                            <span style="padding-right:10px"><strong>DER Name:  </strong></span><span class="span-show-summary" innerText='{{ objDer.Name}}'></span>
                          </div>
                          <div class="col-md-12">
                            <span style="padding-right:10px"><strong>DER Email:  </strong></span><span class="span-show-summary" innerText='{{ objDer.Email}}'></span>
                          </div>
                          <div class="col-md-12">
                            <span style="padding-right:10px"><strong>Alternate DER Name:  </strong></span><span class="span-show-summary" innerText='{{ objDer.AlternateDERName}}'></span>
                          </div>
                          <div class="col-md-12">
                            <span style="padding-right:10px"><strong>Alternate DER Email:  </strong></span><span class="span-show-summary" innerText='{{ objDer.AlternateDEREmail}}'>  </span>
                          </div>
                          <div class="col-md-12 mt-3">
                            <h2 class="fs-subtitle">Billing Inforamtion</h2>
                          </div>
                          <div class="col-md-12">
                            <span style="padding-right:10px"><strong>Billing Contact Name:  </strong></span><span class="span-show-summary" innerText='{{ showBillingContactName}}'></span>
                          </div>
                          <div class="col-md-12">
                            <span style="padding-right:10px"><strong>Billing Conact Email:  </strong></span><span class="span-show-summary" innerText='{{ showBillingContactEmail}}'></span>
                          </div>
                          <div class="col-md-12">
                            <span style="padding-right:10px"><strong>Billing Address:  </strong></span><span class="span-show-summary" innerText='{{ showBillingAddess}}'></span>
                          </div>
                          <div class="col-md-12">
                            <span style="padding-right:10px"><strong>Billing City:  </strong></span><span class="span-show-summary" innerText='{{ showBillingCity}}'></span>
                          </div>
                          <div class="col-md-12">
                            <span style="padding-right:10px"><strong>Billing State:  </strong></span><span class="span-show-summary" innerText='{{ showBillingState}}'></span>
                          </div>
                          <div class="col-md-12">
                            <span style="padding-right:10px"><strong>Billing Phone No.:  </strong></span><span class="span-show-summary" innerText='{{ showBillingPhoneNo}}'></span>
                          </div>
                          <div class="col-md-12">
                            <span style="padding-right:10px"><strong>Billing Ext. No.:  </strong></span><span class="span-show-summary" innerText='{{ showBillingExntention}}'></span>
                          </div>
                          <div class="col-md-12">
                            <span style="padding-right:10px"><strong>Billing Fax No.:  </strong></span><span class="span-show-summary" innerText='{{ showBillingFaxNo}}'></span>
                          </div>
                        </div>-->
                    <div class="col-xl-4 col-lg-5 col-md-12 mt-2">
                      <div class="light_blue_container">
                        <h2>What's Included</h2>
                        <ul>
                          <li>Drug & Alcohol Plan (Policy)</li>
                          <li>Designated Account Executive</li>
                          <li>PTC Online account management portal</li>
                          <li>Online Billing Account Access</li>
                          <li>Nation-wide Collection Site Usage</li>
                          <li>Certified Laboratory Services</li>
                          <li>Medical Review Officer Services</li>
                          <li>Data Submission to Auditing Agencies</li>
                          <li>Random Testing Management</li>
                          <li>EAP Materials</li>
                          <li>Unlimited Supervisor Training</li>
                          <li>Substance Abuse Professional Services</li>
                          <li>Secure Record-Keeping</li>
                          <li>Quality Control Management</li>
                          <li>Compliance Education</li>
                          <li>eTEST &eTRAIN capabilities</li>
                        </ul>
                      </div>
                      <!-- <div>
                            <h6>List of your current job positions/titles for the employees working under Federal Program
                            </h6>
                            <div class="mt-2">
                              <table class="lstTable">
                                <tr>
                                  <th>Serial</th>
                                  <th>Job Position</th>
                                  <th>Title</th>
                                  <th>Supervisor</th>
                                  <th>CDL</th>
    
                                </tr>
    
    
                                <tr *ngFor="let dotEmp of lstDotEmployees; let i=index;">
                                  <td>{{i + 1}}</td>
                                  <td>{{dotEmp.JobPosition}}</td>
                                  <td>{{dotEmp.EmpTitle}}</td>
                                  <td> <input type='checkbox' checked="{{dotEmp.Supervisor? 'checked': ''}}" /> </td>
                                  <td> <input type="checkbox" checked="{{dotEmp.CDL? 'checked': ''}}" /></td>                             
                                </tr>
                              </table>
                            </div>
                            <div class="col-md-12 mt-2">
                              <h6>List of your current job positions/titles for the employees working under Company program</h6>
                              <table class="lstTable mt-2">
                                <tr>
                                  <th>Serial</th>
                                  <th>Job Position</th>
                                  <th>Title</th>
    
                                </tr>
    
                                <tr *ngFor="let nonDotEmp of lstNonDotEmployees; let i=index;">
                                  <td>{{i + 1}}</td>
                                  <td>{{nonDotEmp.NonDotJobPostition}}</td>
                                  <td>{{nonDotEmp.NonDotEmpTtile}}</td>
    
                                </tr>
                              </table>
                            </div> 
    
                          </div> -->
                    </div>
                  </div>

                </div>

                <!-- Export Table -->

                <div id="Summary" #Summary class="invoice-items px-3 mt-3">
                  <div class="pdf-header py-3">
                    <!-- <h3 class="pdf-title text-center pt-4 pb-1">
                      <img src="../../assets/Images/PTC_Drug_Programs_Compliance.jpg" class="logo" />
                    </h3> -->
                    <div>
                      <img src="../../assets/Images/PTC_Drug_Programs_Compliance.png" class="logo" />
                    </div>
                    <div class="text-right"><b>9 Compound Dr.</b></div>
                    <div class="text-right"><b>Hutchinson, KS 67502</b></div>
                    <div class="text-right"><b>620.669.8800</b></div>
                  </div>
                  <div>
                    <!-- col-lg-12 start here -->
                    <table style="width: 100%">
                      <tbody class="invoice-details">
                        <tr>
                          <td><strong>Invoice:</strong> {{ InvoiceNumber}}</td>
                        </tr>
                        <tr>
                          <td>
                            <strong>Date:</strong> {{formatDateToLong(AckAndAgreement.AckDate)}}
                          </td>
                        </tr>
                        <!-- <tr>
                            <td><strong> Due Date: </strong>Friday, March 11th, 2022</td>
                          </tr> -->
                        <tr>
                          <td>
                            <strong>Status:</strong><span class="badge badge-danger ms-2">UNPAID</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <br />
                  </div>
                  <div class="text-left"><strong>Invoiced To:</strong></div>
                  <table class="container" style="width: 100%; max-width:100%">
                    <tbody class="invoice-details">
                      <tr>
                        <td>
                          <strong>Company Name: </strong>{{  objCompanyInfo.CompanyName }}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Name: </strong>{{
                           objCompanyInfo.BillingContact
                          .BillingContactName
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Email: </strong>{{
                           objCompanyInfo.BillingContact
                          .BillingContactEmail
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Address: </strong>{{
                           objCompanyInfo.BillingContact.BillingAddress
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          {{
                           objCompanyInfo.BillingContact.BillingCity +
                          ", " +
                           objCompanyInfo.BillingContact.BillingState +
                          ", " +
                          GetZipFormat( objCompanyInfo.BillingContact.BillingZip) +
                          ", " +
                           objCompanyInfo.BillingContact.BillingCountry
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <br />
                  <div class="table-responsive" style="overflow: hidden; outline: none; letter-spacing: 0.01px;">
                    <table class="table table-bordered td_padding" style="width: 100%;letter-spacing: 0.01px;">
                      <thead>
                        <tr>
                          <th style="
                              width: 50%;
                              background-color: #003b71;
                              color: white;
                            " class="per70 text-center">
                            Description
                          </th>
                          <th style="
                              width: 25%;
                              background-color: #003b71;
                              color: white;
                            " class="per5 text-center">
                            Qty
                          </th>
                          <th style="
                              width: 25%;
                              background-color: #003b71;
                              color: white;
                            " class="per25 text-center">
                            Total
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="text-left">Account Setup Fee</td>
                          <td class="text-center">1</td>
                          <td class="text-right text-nowrap">
                            ${{
                            NumberWithCommasWithTwoDecimal(CustomerInfo?.CustomerDetails.FeeDetails.SetupFee)
                            }}
                            USD
                          </td>
                        </tr>
                        <tr>
                          <td class="text-left">Annual Subscription</td>
                          <td class="text-center">1</td>
                          <td class="text-right text-nowrap">
                            ${{
                            NumberWithCommasWithTwoDecimal(CustomerInfo?.CustomerDetails.FeeDetails
                            .AnnualSubscription)
                            }}
                            USD
                          </td>
                        </tr>
                        <tr>
                          <td class="text-left">Annual Employee Fee</td>
                          <td class="text-center">
                            {{
                            objProgramInfo.NumberOfEmployees
                            }}
                          </td>
                          <td class="text-right text-nowrap">
                            ${{ NumberWithCommasWithTwoDecimal(randomPool) }}
                            USD
                          </td>
                        </tr>
                        <tr>
                          <td class="text-left">Shipping & Handling</td>
                          <td class="text-center">1</td>
                          <td class="text-right text-nowrap">
                            ${{
                            NumberWithCommasWithTwoDecimal(CustomerInfo?.CustomerDetails.FeeDetails
                            .ExpeditedShippingFee)
                            }}
                            USD
                          </td>
                        </tr>
                        <tr>
                          <td class="text-left">Sales Tax ({{SalesTax > 0? SalesTaxPercent : 0}}%)**</td>
                          <td class="text-center">1</td>
                          <td class="text-right text-nowrap">
                            ${{
                            NumberWithCommasWithTwoDecimal(SalesTax)
                            }}
                            USD
                          </td>
                        </tr>
                        <tr>
                          <th colspan="2" class="text-right">
                            Enrollment Total
                          </th>
                          <th class="text-right text-nowrap">
                            ${{
                            NumberWithCommasWithTwoDecimal(EnrollmentTotalFee)
                            }}
                            USD
                          </th>
                        </tr>
                      </tbody>
                      <!-- <tfoot>
                        <tr>
                          <th style="background-color: #003b71; color: white" colspan="2" class="text-center">
                            Per Use Fees
                          </th>
                          <th class="text-center"></th>
                        </tr>
                        <tr *ngIf="
                            objProgramInfo.CompanyProgram.IsRandomTesting ==
                            true
                          ">
                          <td colspan="2" class="text-right">Drug Test</td>
                          <th class="text-center">
                            ${{
                              NumberWithCommasWithTwoDecimal(CustomerInfo?.CustomerDetails.FeeDetails.DrugTest)
                            }}
                            USD
                          </th>
                        </tr>
                        <tr *ngIf="
                            lstCheckBoxClientRequiremets[5].isSelected == true
                          ">
                          <td colspan="2" class="text-right">
                            ExxonMobil Drug Test
                          </td>
                          <th class="text-center">
                            ${{
                              NumberWithCommasWithTwoDecimal(CustomerInfo?.CustomerDetails.FeeDetails
                            .ExxonMobilDrugTest)
                            }}
                            USD
                          </th>
                        </tr>
                        <tr *ngIf="
                            objProgramInfo.CompanyProgram
                              .IsRandomDrugAndAlcoholTesting == true &&
                            objProgramInfo.CompanyProgram.IsRandomTesting ==
                              true
                          ">
                          <td colspan="2" class="text-right">Alcohol Test</td>
                          <th class="text-center">
                            ${{
                              NumberWithCommasWithTwoDecimal(CustomerInfo?.CustomerDetails.FeeDetails
                            .AlcoholTest)
                            }}
                            USD
                          </th>
                        </tr>
                      </tfoot> -->
                    </table>
                  </div>

                </div>

                
                <div class="mb-3 mt-4 d-flex justify-content-center">
                  <!-- <input (click)="previous()" type="button" name="previous" class="previous action-button-previous"
                    value="Previous" /> -->
                  <button kendoButton (click)="previous()" class="previous action-button-previous">Previous</button>
                  <!-- <input (click)="next()" type="button" name="next" class="next action-button" value="Next Step" /> -->                  
                  <button kendoButton (click)="next()" class="next action-button">Next Step</button>
                  <button class="action-button-print px-3" kendoButton (click)="pdfDownload()">
                    Export Invoice to Pdf
                  </button>
                </div>
              </fieldset>
            </form>
            <!-- <fieldset *ngIf="step == 5">
                  <div class="form-card">
                    <div class="row">
                      <div class="col-md-6">
                        <div style="font-size:15px">Review of PTC Fee</div>
                        <ul class="ul-circle">
                          <li>Drug Test Fee ($85)</li>
                          <li>Alcohol Test Fee ($85)</li>
                          <li>History Check (85$)</li>
                        </ul>
                      </div>
                      <div class="col-md-6">
                        <div style="font-size:15px">Review of Subscription costs</div>
                        <ul class="ul-circle">
                          <li>Annual Subscription Fee ($550)</li>
                          <li>1x Admin Fee ($8250)</li>
                          <li>EAP Fee ($30/# of employees in a random pool &#64; a max 200 employees)</li>
                          <li>Promo Code (for any applicable discount, i.e. affiliate)</li>
                          <li>Total Subscription Cost</li>
                        </ul>
  
  
                      </div>
                    </div>
                  </div>
                  <input (click)="previous()" type="button" name="previous" class="previous action-button-previous"
                    value="Previous" />
                  <input (click)="next()" type="button" name="next" class="next action-button" value="Next Step" />
  
                </fieldset> -->
            <!-- <form id="msform" [formGroup]="paymentForm" (submit)="PaymentFormSubmit()"> -->
            <form id="msform" [formGroup]="paymentForm">
              <fieldset *ngIf="step == 5">
                <div>
                  <ng-container #outlet> </ng-container>
                </div>
                <div #content class="form-card">
                  <h2 class="fs-title">Payment Information</h2>
                  <div class="radio-group" style="text-align: center">
                    <h4 *ngIf="objCompanyInfo?.AllowCheckPayment"><b>Choose your payment method</b></h4>
                    <!-- <div class="radio" kendoRadioButton data-value="credit" [ngClass]=" PaymentDetails.IsCreditCard ? 'selected' : 'notselected'" (click)="PaymentModeClick('CreditCard')"
                      *ngIf=" PaymentDetails.IsCreditCard">
                      <img src="https://i.imgur.com/XzOzVHZ.jpg" width="200px" height="100px" />
                    </div>
                    <div class="radio" kendoRadioButton data-value="paypal" [ngClass]="! PaymentDetails.IsCreditCard ? 'selected' : 'notselected'"  (click)="PaymentModeClick('Cheque')"
                      *ngIf=" PaymentDetails.IsCreditCard === true">
</div> -->
                    <div class="radio" kendoRadioButton data-value="credit" (click)="PaymentModeClick(true)"
                      [ngClass]=" PaymentDetails.IsCreditCard ? 'selected' : 'notselected'">
                      <img src="../../assets/Images/CreditCard.jpg" width="200px" height="100px" />
                    </div>
                    <div *ngIf="objCompanyInfo?.AllowCheckPayment" style="padding:5px" class="radio" kendoRadioButton data-value="paypal"
                      (click)="PaymentModeClick(false)"
                      [ngClass]="! PaymentDetails.IsCreditCard ? 'selected' : 'notselected'"
                      [ngClass]="  showTransactionId != '' ? 'opacity-5 ' : ''">
                      <img src="../../assets/Images/Check2.png" width="188px" height="94px" />
                    </div>
                    <br />
                  </div>

                  <div *ngIf="PaymentDetails.IsCreditCard" class="row mt-2 mx-0">
                    <!-- <form [formGroup]="paymentForm" class="form-last creditcard_tbalewidth" > -->
                    <div class="form-last creditcard_tbalewidth pb-4">
                      <div class="row">
                        <div class="col-md-6 col-sm-6 form-group d-flex-mobile">
                          <label class="col-4 pl-0 mt-1"><strong class="required-fileds">* </strong>Name On
                            Card:</label>
                          <div class="text-right"></div>
                          <div id="demoCheckname"></div>
                        </div>
                        <div class="col-md-6 col-sm-6 form-group d-flex-mobile">
                          <label class="col-3 pl-0 mt-1"><strong class="required-fileds">* </strong>CC
                            Number:
                          </label>
                          <div class="text-right"></div>
                          <div id="demoCcnumber"></div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6 col-sm-6 form-group d-flex-mobile">
                          <label class="col-4 pl-0 mt-1"><strong class="required-fileds">* </strong>CC
                            Exp:</label>
                          <div id="demoCcexp"></div>
                        </div>
                        <div class="col-md-6 col-sm-6 form-group d-flex-mobile">
                          <label class="col-3 pl-0 mt-1"><strong class="required-fileds">*
                            </strong>CVV:</label>
                          <div id="demoCvv"></div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6 col-sm-6 form-group d-flex-mobile">
                          <div class="col-lg-12 cdl-checkbox-pl text-xl-right px-0 ">
                            <div class="d-xl-inline custom_checkbox">
                              <input formControlName="fcIsCreditCardZipUSA" id="IsCreditCardZipUSA"
                                [(ngModel)]="PaymentDetails.IsCreditCardZipUSA" [tabIndex]="9" name="IsCreditCardZipUSA"
                                class="form-check-input k-checkbox k-rounded-md" type="checkbox"
                                (click)="ChangeCreditCardZipForamt('Canada')" />
                              <label for="IsCreditCardZipUSA">USA Zip Code</label>
                            </div>
                            <div class="d-xl-inline custom_checkbox">
                              <input formControlName="fcIsCreditCardPostalCodeCanada" id="IsCreditCardPostalCodeCanada"
                                [(ngModel)]="PaymentDetails.IsCreditCardPostalCodeCanada"
                                name="IsCreditCardPostalCodeCanada" [tabIndex]="10"
                                class="form-check-input k-checkbox k-rounded-md" type="checkbox"
                                (click)="ChangeCreditCardZipForamt('USA')" />
                              <label for="IsCreditCardPostalCodeCanada">Canada Postal Code</label>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-6 col-sm-6 form-group d-flex-mobile">
                          <label class="col-3 pl-0 mt-1">Billing
                            {{PaymentDetails.IsCreditCardZipUSA?'Zip Code':'Postal Code' }}:</label>
                          <kendo-maskedtextbox type="text" [(ngModel)]="PaymentDetails.CreditCardZip"
                            name="CreditCardZip" formControlName="fcCreditCardZip" class="billing_zipfield"
                            [mask]="CreditCardZipMask" [ngClass]="{
                              'is-invalid': !objZipValid.IsValidCreditCardZip
                            }" (keyup)="changeZip($event, objZipCollection.CreditCardZip)">
                          </kendo-maskedtextbox>
                          <!-- <kendo-maskedtextbox type="text" [(ngModel)]="PaymentDetails.CreditCardZip" name="CreditCardZip"
                            formControlName="fcCreditCardZip" [mask]="Der_Zip_no_mask" class="billing_zipfield"
                            [ngClass]="{
                              'is-invalid': !objZipValid.IsValidCreditCardZip
                            }"
                            (keyup)="changeZip($event, objZipCollection.CreditCardZip)" 
                            >
                          </kendo-maskedtextbox> -->
                          <!-- (keypress)="CreditCardZipKeyPress($event)" (keyup)="changeCreditCardZip($event)" -->
                          <!-- <div *ngIf="PaymentSubmitted && cf['fcCreditCardZip'].errors" class="invalid-feedback">
                            <div class="col-xl-7 offset-xl-5 pl-0" *ngIf="cf['fcCreditCardZip'].errors['required']">
                              Zip is required
                            </div>
                          </div> -->
                        </div>
                      </div>
                      <div class="required-fileds text-center pt-3">Please Note: Payment must be made in USD.</div>
                      <div class="mt-2 d-block text-center invalid-feedback">
                        <div>{{objZipValid.IsValidCreditCardZip?  InvalidCreditCardMessage :
                          (PaymentDetails.IsCreditCardZipUSA? 'Zip format required (00000)':'Postal Code required (e.g. K1A 0T6)')}} </div>
                      </div>
                      <div class="text-center pt-3">
                        <span (click)="downloadCreditCardPDF()" class="text-dark span-hyperlink">PTC Credit Card Security Policy</span>
                      </div>
                    </div>
                    <!-- </form> -->
                  </div>
                  <!-- <button
                        (click)="downloadReceipt()"
                        printSectionId="print"
                        ngxPrint
                        class="next btn-primary"
                      >
                        Download
                      </button> -->

                  <!-- Export Table -->
                 
                  <div *ngIf="!PaymentDetails.IsCreditCard" class="row pt-2">
                    <div class="container">
                      <p class="font-weight-bold">
                        You are electing to pay your PTC enrollment fees by company check. 
                        Please be aware that your enrollment information will not be processed until payment has been received. 
                        Click the Submit button below to send your information to PTC. 
                        A confirmation email with check payment instructions will be sent to you.
                      </p>
                      <p class="font-weight-normal">
                        If payment is not received within 30 days from submission, 
                        your enrollment information will expire, and a new enrollment link will need to be requested.
                      </p>
                    </div>
                    <!-- <div class="col-md-6">
      
      
                            <label class="pay col-md-4 label-right pl-0"><strong class="required-fileds">* </strong>ABA No.</label>
                            <input 
                            type="text"
                            name="" 
                            placeholder="ABA No."
                            class="form-control col-md-8"
                            [(ngModel)]="PaymentDetails.CheckDetails.ABANumber" 
                            />
                          </div>
                          <div class="col-md-6">
                            <label class="pay col-md-4 label-right pl-0"><strong class="required-fileds">* </strong>Account No.</label>
                            <input 
                            type="text" 
                            name="cardno" 
                            placeholder="" 
                            class="form-control col-md-8" 
                            [(ngModel)]="PaymentDetails.CheckDetails.AccountNumber"
                            />
                          </div>
                          <div class="col-md-6">
                            <label class="pay col-md-4 label-right pl-0"><strong class="required-fileds">* </strong>Check No.</label>
                            <input 
                            type="text" 
                            name="cardno" 
                            placeholder="" 
                            class="form-control col-md-8" 
                            [(ngModel)]="PaymentDetails.CheckDetails.CheckNumber"
                            />
                          </div> -->
                  </div>
                </div>

                <!-- <input (click)="previous()" type="button" name="previous" class="previous action-button-previous"
                  value="Previous" /> -->

                <div class="row mx-0">

                  <div class="col-lg-4"></div>
                  <div class="col-lg-4">


                    <span *ngIf=" showTransactionId == ''"><button kendoButton (click)="previous()" name="previous"
                        class="previous action-button-previous">Previous</button></span>
                    <span *ngIf=" showTransactionId !== ''"><button kendoButton (click)="previous()"
                        [disabled]="true" name="previous"
                        class="previous action-button-lightgray">Previous</button></span>

                    <!-- <button kendoButton (click)="previous()" name="previous" [disabled]=" showTransactionId !== ''"
                class="previous action-button-previous">Previous</button> -->
                    <!-- <input *ngIf="
                   showTransactionId === '' &&
                   objPaymentInfo.PaymentMode == 'CreditCard'
                " id="demoPayButton" type="button" name="make_payment" class="next action-button" value="Pay" /> -->
                    <!-- <button type="submit" kendoButton
                      *ngIf=" showTransactionId === '' &&  PaymentDetails.IsCreditCard"
                      class="next action-button">Pay
                    </button> -->


                    <button type="submit" kendoButton *ngIf="
               showTransactionId === '' &&
               PaymentDetails.IsCreditCard
            " name="make_payment" class="next action-button" (click)="PaymentFormSubmit()">Pay & Submit</button>
                    <button kendoButton *ngIf="
               showTransactionId !== '' ||
               PaymentDetails.IsCreditCard === false" name="make_payment" (click)="confirm(pdf)"
                      class="next action-button">Submit</button>

                  </div>                 
                </div>
              </fieldset>
            </form>

            <form id="msform">
              <fieldset *ngIf="step == 6">
                <div class="form-card">
                  <h2 class="fs-title">Success !</h2>
                  <div class="row justify-content-center">
                    <div class="col-md-11 text-center">
                      <img src="../../assets/Images/success_ico.png" class="mt-5 mb-4" />
                      <p style="line-height: 1.65rem; font-weight: normal;">
                        Thank you for choosing PTC for your company's drug and
                        alcohol testing program. We are excited to work with
                        you! Your enrollment subscription is being processed and
                        your Account Executive will be in touch with you soon
                        regarding the next steps in getting your company
                        compliant. Thank you!
                      </p>

                      <div style="position: absolute; left: -1000px; top: -10000px">
                        
                        <kendo-pdf-export #printTransactionInfo paperSize="A4" margin="1cm" [scale]=0.8
                          ViewerRenderToolTips="true">
                          <div class="text-left">
                            <div>
                              <div class="pdf-header" style="border-bottom: 1px solid #000; float: left;  width: 100%;
                            padding-bottom: 15px;  margin-bottom: 30px;">
                                <div>
                                  <img src="../../assets/Images/PTC_Drug_Programs_Compliance.png" class="logo">
                                </div>
                                <div class="text-right">
                                  <b>9 Compound Dr.</b>
                                </div>
                                <div class="text-right">
                                  <b>Hutchinson, KS 67502</b>
                                </div>
                                <div class="text-right">
                                  <b>620.669.8800</b>
                                </div>
                              </div>
                            </div>
                            <h1><b>Payment Information</b></h1>
                            <div class="mt-4">
                              <div class=" mb-2">
                                <table class="w-100">
                                  <tr>
                                    <td style="width:184px; vertical-align: top;">Payment Method:&nbsp;</td>
                                    <td style="font-weight: normal;">Credit Card</td>
                                  </tr>
                                  <tr>
                                    <td style="vertical-align: top;">
                                      Customer&nbsp;Name:&nbsp;
                                    </td>
                                    <td style="font-weight:normal; ">
                                      {{
                                       objCompanyInfo.CompanyName
                                      }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style="vertical-align: top;">
                                      Transaction&nbsp;ID:&nbsp;
                                    </td>
                                    <td style="font-weight:normal; ">
                                      {{  showTransactionId }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style="vertical-align: top;">
                                      Transaction&nbsp;Date:&nbsp;
                                    </td>
                                    <td style="font-weight:normal; ">
                                      {{ TransactionDate }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style="vertical-align: top;">
                                      Transaction&nbsp;Amount:&nbsp;
                                    </td>
                                    <td style="font-weight: normal;">
                                      ${{
                                      NumberWithCommasWithTwoDecimal( EnrollmentTotalFee )
                                      }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style="vertical-align: top;">
                                      Credit&nbsp;Card&nbsp;(Last&nbsp;4&nbsp;digits):
                                    </td>
                                    <td style="font-weight: normal;">
                                      {{ PaymentDetails.CreditCardDetails.CardNumber }}
                                    </td>
                                  </tr>
                                </table>
                              </div>
                            </div>
                            <table
                              style="width:100%;font-weight:normal; font-size:11px; line-height:14px; margin-top: 30rem;">
                              <tr>
                                <td>
                                  <div style="font-size: 12px;"><strong>No Refund & Credit Policy:</strong></div>
                                  Due to the nature of our services, we have, without exception, a NO REFUND policy. For this reason, we strongly recommend that before payment, you make certain that you understand the nature and cost of the services we provide. Invoices sent by PTC under this agreement are due upon receipt. The company shall owe a finance charge on any balance not paid within 30 days of the date of the invoice at the rate of 1.5% per month or 18% annually and the account may be subject to hold. In the event the company fails to make payments of amounts due under this agreement, PTC is authorized to suspend performance of its obligations to the company until full payment of the amount which the company is in default is received. PTC is not obligated to keep accounts open once an invoice balance has reached 60 days. By way of illustration and not limitation, PTC is expressly allowed, during such period of default, to remove the company from the Consortium and to report on any listing or report of compliance with applicable regulations or, in the case where PTC is listing only the company in compliance to omit such defaulting company. Such action by PTC shall not relieve the company of its obligation to pay any annual, administration, or other fees provided under this agreement.
                                </td>
                              </tr>
                            </table>
                          </div>
                        </kendo-pdf-export>
                      </div>
                      <div class="mt-4 mb-4 form-last" id="print">
                        <div class="row transaction_table_width text-left"  *ngIf="  showTransactionId !== '' && PaymentDetails.IsCreditCard">
                              <div class="col-md-12 col-lg-7 d-sm-table form-group">
                                  <label class="trans_label_width "> Customer&nbsp;Name:&nbsp; </label>
                                  <div class="font-weight-normal"> {{  objCompanyInfo.CompanyName }} </div>
                              </div>
                              <div class="col-md-12 col-lg-5 d-sm-table form-group">
                                <label class="trans_label_width2">Transaction&nbsp;ID:&nbsp;</label>
                                  <div class="font-weight-normal">{{  showTransactionId }}</div>
                              </div>
                              <div class="col-md-12 col-lg-7 d-sm-table form-group">
                                <label class="trans_label_width">Transaction&nbsp;Date:&nbsp;</label>
                                  <div class="font-weight-normal">{{ TransactionDate }}</div>
                              </div>
                              <div class="col-md-12 col-lg-5 d-sm-table form-group">
                                <label class="trans_label_width2">Transaction&nbsp;Amount:&nbsp;</label>
                                <div class="font-weight-normal">${{
                                    NumberWithCommasWithTwoDecimal( EnrollmentTotalFee )
                                    }}</div>
                              </div>
                              <div class="col-md-12 col-lg-7 d-sm-table">
                                <label class="trans_label_width">Credit&nbsp;Card&nbsp;(Last&nbsp;4&nbsp;digits)&nbsp;:</label>
                                <div class="font-weight-normal">{{ PaymentDetails.CreditCardDetails.CardNumber }}</div>
                              </div>
                          </div>
                      </div>

                      <!-- <button (click)="Finish()" type="button" class="print_btn mt-4 px-4" name="startover"
                        id="startover">Finish
                      </button> -->
                      
                       <button kendoButton *ngIf=" showTransactionId !== ''"
                          (click)="printTransactionInfoDownload()" ngxPrint
                          class="next action-button-print px-3 ">
                          Download Transaction Details
                        </button>
                      
                      <button class="action-button-print px-3" (click)="pdfViewDownload()">
                        Download Service Agreement
                      </button>
                    </div>


                    <div style="position: absolute; left: -1000px; top: -10000px;">
                      <!-- <div > -->
                      <kendo-pdf-export #pdfView class="pdf-ack-export" paperSize="A4" margin="1.4cm" [scale]="0.7" ViewerRenderToolTips="true"
                        forcePageBreak=".pdf-new-page" keepTogether="h2, tr, ul[style*='list-style-type'] > li, .row.mx-0">
                        <div class="print_service_agreement" *ngIf="IsPassCustomerDetail">
                          <div class="col section-2" *ngIf="customerByIdData" style="font-size: 14px;">
                            <h2 class="section-2-heading">Service Agreement
                            </h2>
                            <mat-divider></mat-divider>
                            <ng-container>
                              <div class="text-pdf-cap">
                                <div>
                                  <h2 class="company-info-heading mt-3 mb-3">
                                    Company Information
                                  </h2>
                                  <div class="companyInfo ">
                                    <div class="pr-5">
                                      <p>
                                        <label>Company Name:</label>
                                        {{ customerByIdData.CompanyName }}
                                      </p>
                                      <p>
                                        <label>Country:</label>
                                        {{
                                        customerByIdData?.CustomerDetails.CompanyDetails.Country?customerByIdData?.CustomerDetails.CompanyDetails.Country:''}}
                                      </p>
                                      <p>
                                        <label>Mailing Address:</label>
                                        {{
                                        customerByIdData?.CustomerDetails.CompanyDetails
                                        .MailingAddress.StreetName
                                        }}
                                      </p>
                                      <p>
                                        <label>City:</label>
                                        {{
                                        customerByIdData?.CustomerDetails.CompanyDetails
                                        .MailingAddress? customerByIdData?.CustomerDetails.CompanyDetails
                                        .MailingAddress.City : ''
                                        }}
                                      </p>
                                      <p>
                                        <label>{{customerByIdData?.CustomerDetails.CompanyDetails.Country ===
                                          'Canada'?'Province':'State'
                                          }}:</label>
                                        {{
                                        customerByIdData?.CustomerDetails.CompanyDetails
                                        .MailingAddress.State
                                        }}
                                      </p>
                                      <p>
                                        <label>{{customerByIdData?.CustomerDetails.CompanyDetails.Country === 'Canada'?
                                          'Postal Code':
                                          'Zip'}}:</label>
                                        {{
                                        GetZipFormat(customerByIdData?.CustomerDetails.CompanyDetails
                                        .MailingAddress.Zip)
                                        }}
                                      </p>
                                      <p>
                                        <label>Same as Mailing:</label>{{
                                        customerByIdData?.CustomerDetails.CompanyDetails
                                        .PhysicalAddressSameAsMailingAddress? 'YES' : 'NO'
                                        }}
                                      </p>
                                      <p>
                                        <label>Physical Address: </label>{{
                                        customerByIdData?.CustomerDetails.CompanyDetails
                                        .PhysicalAddress.StreetName
                                        }}
                                      </p>
                                      <p>
                                        <label>City: </label>{{
                                        customerByIdData?.CustomerDetails.CompanyDetails
                                        .PhysicalAddress.City
                                        }}
                                      </p>
                                      <p>
                                        <label>{{customerByIdData?.CustomerDetails.CompanyDetails.Country ===
                                          'Canada'?'Province':'State'
                                          }}:</label>
                                        {{
                                        customerByIdData?.CustomerDetails.CompanyDetails
                                        .PhysicalAddress.State
                                        }}
                                      </p>
                                      <p>
                                        <label>{{customerByIdData?.CustomerDetails.CompanyDetails.Country === 'Canada'?
                                          'Postal Code':
                                          'Zip'}}:</label>
                                        {{
                                        GetZipFormat(customerByIdData?.CustomerDetails.CompanyDetails
                                        .PhysicalAddress.Zip)
                                        }}
                                      </p>
                                      <p><label>Affiliate Company Name:</label>
                                        {{customerByIdData?.CustomerDetails.CompanyDetails.AffiliatedCompanyName?customerByIdData?.CustomerDetails.CompanyDetails.AffiliatedCompanyName:
                                        'None'}}</p>
                                      <p><label>Reinstatement Account:</label>
                                        {{customerByIdData?.CustomerDetails.CompanyDetails.ReinstatedAccountNumber?customerByIdData?.CustomerDetails.CompanyDetails.ReinstatedAccountNumber:'None'}}
                                      </p>
                                      <p>
                                        <label>IsNetworld Account No:</label>
                                        {{
                                        GetISNFormat(customerByIdData?.CustomerDetails.CompanyDetails.IsNetworldAccountNo)
                                        }}
                                      </p>
                                      <p>
                                        <label>ITS Account No:</label>
                                        {{
                                        customerByIdData?.CustomerDetails.CompanyDetails
                                        .ITSAccountNumber
                                        }}
                                      </p>
                                      <p>
                                        <label>Type Of Work:</label>
                                        {{
                                        customerByIdData?.CustomerDetails.CompanyDetails
                                        .TypeOfWork
                                        }}
                                      </p>
                                      <p>
                                        <label>Federal Tax ID:</label>
                                        {{
                                        GetFederalTaxFormat(customerByIdData?.CustomerDetails.CompanyDetails
                                        .FederalTaxID)
                                        }}
                                      </p>
                                      <p>
                                        <label>Are you an Oil & Gas Operator:</label>
                                        {{
                                        customerByIdData?.CustomerDetails.CompanyDetails
                                        .IsOilAndGasOperator? 'YES' : 'NO'
                                        }}
                                      </p>
                                      <p>
                                        <label>List the Oil & Gas Operators you work for:</label>
                                        {{
                                        customerByIdData?.CustomerDetails.CompanyDetails
                                        .OilAndGasOperatorCompanyNames
                                        }}
                                      </p>
                                      <p>
                                        <label>Sub Contractor Company Names:</label>
                                        {{
                                        customerByIdData?.CustomerDetails.CompanyDetails
                                        .SubContractorCompanyNames
                                        }}
                                      </p>
                                      <p>
                                        <label>Hear About PTC:</label>
                                        {{
                                        HearAboutValue
                                        }}
                                      </p>
                                      <p *ngIf="HearAboutValue === 'Other' && customerByIdData?.CustomerDetails.CompanyDetails
                                      .HearAboutPTCOther != ''">
                                        <label>Hear About PTC Other:</label>
                                        {{
                                        customerByIdData?.CustomerDetails.CompanyDetails
                                        .HearAboutPTCOther
                                        }}
                                      </p>
                                      <!-- <p><label>List of Auditing Agencies:</label>                   
                                      {{ customerByIdData?.CustomerDetails.AuditAgencies === null? '' :
                                      customerByIdData?.CustomerDetails.AuditAgencies.join(", ")}}</p> -->
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="text-pdf-cap page-break">
                                <div>
                                  <h2 class="company-info-heading mt-3 mb-3">
                                    Designated Employee Representative (DER)

                                    <!-- <button class="tooltip_btn"
                                      
                                    kendoTooltip
                                    [tooltipTemplate]="htmlContent2"
                                    
                                      placement ="auto"
                                      data-html="true"
                                    >
                                    <i class="fa fa-info-circle"></i>
                                    </button> -->
                                  </h2>
                                  <div class="companyInfo row">
                                    <div class="col-md-12 pr-5">
                                      <p>
                                        <label>DER Name:</label>
                                        {{ customerByIdData?.CustomerDetails.DERs[0].Name }}
                                      </p>
                                      <p>
                                        <label>DER Title:</label>
                                        {{
                                        customerByIdData?.CustomerDetails.DERs.length>0?customerByIdData?.CustomerDetails.DERs[0].Title:''
                                        }}
                                      </p>
                                      <p>
                                        <label>DER Phone No:</label>
                                        {{
                                        GetPhoneNoFormat(customerByIdData?.CustomerDetails.DERs[0].Address?customerByIdData?.CustomerDetails.DERs[0].Address.PhoneNumber:'')
                                        }}
                                      </p>
                                      <p>
                                        <label>DER Ext No:</label>
                                        {{
                                        customerByIdData?.CustomerDetails.DERs[0].Address?customerByIdData?.CustomerDetails.DERs[0].Address
                                        .Extension:''
                                        }}
                                      </p>
                                      <p>
                                        <label>DER Cell No:</label>
                                        {{
                                        GetPhoneNoFormat(
                                        customerByIdData?.CustomerDetails.DERs[0].Address?customerByIdData?.CustomerDetails.DERs[0].Address
                                        .MobileNumber:'')
                                        }}
                                      </p>
                                      <p>
                                        <label>DER Email:</label>
                                        {{
                                        customerByIdData?.CustomerDetails.DERs[0]
                                        .EmailAddress
                                        }}
                                      </p>


                                      <p>
                                        <label>DER Fax:</label>
                                        {{
                                        GetFaxNoFormat(customerByIdData?.CustomerDetails.DERs[0].Address?customerByIdData?.CustomerDetails.DERs[0].Address
                                        .FaxNumber:'')
                                        }}
                                      </p>
                                      <p>
                                        <label>Alt. DER Name:</label>
                                        {{
                                        customerByIdData?.CustomerDetails.DERs.length===2?customerByIdData?.CustomerDetails.DERs[1].Name:''
                                        }}
                                      </p>
                                      <p>
                                        <label>Alt. DER Phone No:</label>
                                        {{
                                        GetPhoneNoFormat(customerByIdData?.CustomerDetails.DERs.length===2?customerByIdData?.CustomerDetails.DERs[1].Address
                                        .PhoneNumber:'')
                                        }}
                                      </p>
                                      <p>
                                        <label>Alt. DER Ext No:&nbsp;</label>
                                        {{
                                        customerByIdData?.CustomerDetails.DERs.length===2?customerByIdData?.CustomerDetails.DERs[1].Address
                                        .Extension:''
                                        }}
                                      </p>
                                      <p>
                                        <label>Alt. DER Cell No:</label>
                                        {{
                                        GetPhoneNoFormat(customerByIdData?.CustomerDetails.DERs.length===2?customerByIdData?.CustomerDetails.DERs[1].Address
                                        .MobileNumber:'')
                                        }}
                                      </p>
                                      <p>
                                        <label>Alt. DER Email:</label>
                                        {{
                                        customerByIdData?.CustomerDetails.DERs.length===2?customerByIdData?.CustomerDetails.DERs[1]
                                        .EmailAddress:''
                                        }}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div class="pdf-new-page">
                                  <h2 class="company-info-heading mt-3 mb-3">
                                    Billing Contact
                                  </h2>
                                  <div class="companyInfo row">
                                    <div class="col-md-12 pr-5">
                                      <p>
                                        <label>Country:</label>
                                        {{
                                        customerByIdData?.CustomerDetails.CompanyDetails.BillingCountry?customerByIdData?.CustomerDetails.CompanyDetails.BillingCountry:''}}
                                      </p>
                                      <p>
                                        <label>Contact Name:</label>
                                        {{
                                        customerByIdData?.CustomerDetails
                                        .BillingContacts.length > 0? customerByIdData?.CustomerDetails
                                        .BillingContacts[0].Name:''
                                        }}
                                      </p>
                                      <p>
                                        <label>Contact Email:</label>
                                        {{
                                        customerByIdData?.CustomerDetails
                                        .BillingContacts.length > 0?customerByIdData?.CustomerDetails
                                        .BillingContacts[0].EmailAddress:''
                                        }}
                                      </p>
                                      <p>
                                        <label>Billing Address:</label>
                                        {{
                                        customerByIdData?.CustomerDetails
                                        .BillingContacts.length > 0?customerByIdData?.CustomerDetails
                                        .BillingContacts[0].Address.StreetName:''
                                        }}
                                      </p>
                                      <p>
                                        <label>City:</label>
                                        {{
                                        customerByIdData?.CustomerDetails
                                        .BillingContacts.length > 0?customerByIdData?.CustomerDetails
                                        .BillingContacts[0].Address.City:''
                                        }}
                                      </p>

                                      <p>
                                        <label>{{customerByIdData?.CustomerDetails.CompanyDetails.Country ===
                                          'Canada'?'Province':'State'
                                          }}:</label>
                                        {{
                                        customerByIdData?.CustomerDetails
                                        .BillingContacts.length > 0?customerByIdData?.CustomerDetails
                                        .BillingContacts[0].Address.State:''
                                        }}
                                      </p>
                                      <p>
                                        <label>{{customerByIdData?.CustomerDetails.CompanyDetails.Country === 'Canada'?
                                          'Postal Code':
                                          'Zip'}}:</label>
                                        {{
                                        GetZipFormat(customerByIdData?.CustomerDetails
                                        .BillingContacts.length > 0?customerByIdData?.CustomerDetails
                                        .BillingContacts[0].Address.Zip:'')
                                        }}
                                      </p>
                                      <p>
                                        <label>Billing Phone No:</label>
                                        {{
                                        GetPhoneNoFormat(customerByIdData?.CustomerDetails
                                        .BillingContacts.length > 0?customerByIdData?.CustomerDetails
                                        .BillingContacts[0].Address.PhoneNumber:'')
                                        }}
                                      </p>
                                      <p>
                                        <label>Billing Fax No:</label>
                                        {{
                                        GetFaxNoFormat(customerByIdData?.CustomerDetails
                                        .BillingContacts.length > 0?customerByIdData?.CustomerDetails
                                        .BillingContacts[0].Address.FaxNumber:'')
                                        }}
                                      </p>
                                      <p>
                                        <label>Alt. Contact Name:</label>
                                        {{
                                        customerByIdData?.CustomerDetails
                                        .BillingContacts.length > 1?customerByIdData?.CustomerDetails
                                        .BillingContacts[1].Name:''
                                        }}
                                      </p>
                                      <p>
                                        <label>Email:</label>
                                        {{
                                        customerByIdData?.CustomerDetails
                                        .BillingContacts.length > 1?customerByIdData?.CustomerDetails
                                        .BillingContacts[1].EmailAddress:''
                                        }}
                                      </p>
                                      <p>
                                        <label>Phone No:</label>
                                        {{
                                        GetPhoneNoFormat(customerByIdData?.CustomerDetails
                                        .BillingContacts.length > 1?customerByIdData?.CustomerDetails
                                        .BillingContacts[1].Address.PhoneNumber:'')
                                        }}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </ng-container>
                            <div class="text-pdf-cap pdf-new-page">
                              <h2 class="section-2-heading">Program Information</h2>
                              <mat-divider></mat-divider>
                              <div class="companyInfo row">
                                <div class="col-md-12 col-sm-12">
                                  <p class="mt-3">
                                    <label>Number Of Employees:&nbsp;</label>{{
                                    customerByIdData?.CustomerDetails.PTCProgramDetails
                                    .NumberOfEmployees
                                    }}
                                  </p>
                                  <h2 class="company-info-heading-pdf mt-3 mb-3">
                                    Federal Program
                                  </h2>
                                  <p>
                                    <label>Federal Programs:&nbsp;</label>{{
                                    FederalPrgramsSelected
                                    }}
                                  </p>
                                  <p>
                                    <label>List of Auditors:&nbsp;</label>{{
                                    customerByIdData?.CustomerDetails.Auditors === null? ''
                                    :customerByIdData?.CustomerDetails.Auditors.join(", ")
                                    }}
                                  </p>
                                  <!-- <p>
                                    <label>Number Of Employees:&nbsp;</label>{{
                                    customerByIdData?.CustomerDetails.PTCProgramDetails
                                    .FederalProgram.NumberOfEmployees
                                    }}
                                  </p> -->
                                  <p>
                                    <label>Federal CDL:&nbsp;</label>{{
                                    customerByIdData?.CustomerDetails.PTCProgramDetails
                                    .FederalProgram.FederalCDL
                                    ? 'YES'
                                    : 'NO'
                                    }}
                                  </p>
                                  <table class="table table-light table-bordered mt-1">
                                    <tr>
                                      <th>Title</th>
                                      <th>Supervisor Position</th>
                                      <th>CDL</th>
                                    </tr>
                                    <tr *ngFor="
                                        let item of customerByIdData?.CustomerDetails
                                          .PTCProgramDetails.FederalProgram.Employees;
                                        let i = index
                                      " [attr.data-index]="i">
                                      <td>{{ item.Title }}</td>
                                      <td>{{ item.IsSupervisor? 'Yes': 'No' }}</td>
                                      <td>{{ item.CDL? 'Yes': 'No' }}</td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                              <div class="companyInfo row">
                                <div class="col-md-12 col-sm-12">
                                  <h2 class="company-info-heading-pdf mt-3 mb-3">
                                    Company Program
                                  </h2>
                                  <p>
                                    <label>Random Testing:&nbsp;</label>{{
                                    customerByIdData?.CustomerDetails.PTCProgramDetails
                                    .CompanyProgram.IsRandomTesting
                                    ? 'YES'
                                    : 'NO'
                                    }}
                                  </p>
                                  <p>
                                    <label>Random Drug And Alcohol Testing:&nbsp;</label>{{
                                    customerByIdData?.CustomerDetails.PTCProgramDetails
                                    .CompanyProgram.IsRandomDrugAndAlcoholTesting
                                    ? 'YES'
                                    : 'NO'
                                    }}
                                  </p>
                                  <p>
                                    <label>Drug Test Panel:&nbsp;</label>{{
                                    DrugTestPanelValue
                                    }}
                                  </p>
                                  <!-- <p>
                                    <label>Number Of Employees:&nbsp;</label>{{
                                    customerByIdData?.CustomerDetails.PTCProgramDetails
                                    .CompanyProgram.NumberOfEmployees
                                    }}
                                  </p> -->
                                  <table class="table table-light table-bordered mt-1">
                                    <tr>
                                      <th>Title</th>
                                      <th>Supervisor Position</th>
                                    </tr>
                                    <tr *ngFor="
                                        let item of customerByIdData?.CustomerDetails
                                          .PTCProgramDetails.CompanyProgram.Employees;
                                        let i = index
                                      " [attr.data-index]="i">
                                      <td>{{ item.Title }}</td>
                                      <td>{{ item.IsSupervisor? 'Yes': 'No' }}</td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                              <div class="companyInfo row">
                                <div class="col-md-12 col-sm-12">
                                  <h2 class="company-info-heading-pdf mt-3 mb-3">Client Required</h2>
                                  <p>
                                    <label> Programs:&nbsp;</label>{{
                                    ClientProgramSelected
                                    }}
                                  </p>
                                  <p *ngIf="customerByIdData?.CustomerDetails.PTCProgramDetails.OtherProgram.OtherName">
                                    <label>Other Name:&nbsp;</label>{{
                                    customerByIdData?.CustomerDetails.PTCProgramDetails
                                    .OtherProgram.OtherName
                                    }}
                                  </p>
                                  <!-- <p>
                                    <label>Number Of Employees:&nbsp;</label>{{
                                    customerByIdData?.CustomerDetails.PTCProgramDetails
                                    .OtherProgram.NumberOfEmployees
                                    }}
                                  </p> -->
                                </div>
                              </div>
                            </div>

                            <div class="page-break acknowled pdf-new-page">
                              <h2 class="section-2-heading">Acknowledgments</h2>
                              <mat-divider></mat-divider>

                              <div class="companyInfo row mt-2">
                                <div class="col-md-12 col-sm-12">
                                  <h2 class="company-info-heading-pdf mt-3 mb-2">Outline of Services and Costs</h2>
                                  <p class="mt-4">The following services will be performed by our company:</p>

                                  <ul style="list-style-type: none;">
                                    <li>
                                      <h2 class="company-info-heading-pdf mt-3 mb-2">Policy & Procedure Manual</h2>
                                      <p>Implementation of your individualized Alcohol and Drug Testing Plans (written
                                        policy & procedure manual). Applicant and employee acknowledgment forms are
                                        included.</p>
                                    </li>
                                    <li>
                                      <h2 class="company-info-heading-pdf mt-3 mb-2">Certified Laboratory Services</h2>
                                      <p>Drug testing laboratory services for the program is a Substance Abuse and
                                        Mental Health Services Administration (SAMHSA), certified laboratory. The lab
                                        for our program is: Clinical Reference Laboratory, 8433 Quivira, Lenexa, Kansas
                                        66215.</p>
                                    </li>
                                    <li>
                                      <h2 class="company-info-heading-pdf mt-3 mb-2">Medical Review Officer (MRO)
                                        Services
                                      </h2>
                                      <p>The MRO oversees the drug testing results to ensure validity of the results and
                                        to make sure that the employee's rights are preserved. The MRO for our program
                                        is: Dr. David W. Paine, American Medical Review Officers, LLC, 9 Compound Drive,
                                        Hutchinson, Kansas 67502.</p>

                                    </li>
                                    <li>
                                      <h2 class="company-info-heading-pdf mt-3 mb-2">Collection Kit</h2>
                                      <p>Testing supplies and kits are provided at no charge with clients only paying for shipping and handling.</p>

                                    </li>
                                    <li>
                                      <h2 class="company-info-heading-pdf mt-3 mb-2">Collection Sites</h2>
                                      <p>Included with drug testing is a specimen collection site (your local clinic, hospital or doctors office). 
                                        Approved collection sites are identified on our website (www.pipelinetesting.com). All collection sites 
                                        utilized must be listed in the PTC Collection Site Network. Additional charges may apply for collection 
                                        sites used outside the approved network, for after-hour services, on-site(mobile) testing, and other situations.
                                      </p>
                                    </li>
                                    <li>
                                      <h2 class="company-info-heading-pdf mt-3 mb-2">Breath Alcohol Technician (BAT)
                                        Services</h2>
                                      <p>Trained BATs and collection facilities are provided by either mobile service or
                                        walk-in facilities.</p>

                                    </li>
                                    <li>
                                      <h2 class="company-info-heading-pdf mt-3 mb-2">Testing Schedule</h2>
                                     
                                        <div><span style="margin-right: -30px;">All employees working in a "covered" position are subject to unannounced testing based on
                        random selection. All random selections are computer generated. The current annualized random
                        drug testing rate is published on</span> <a style="margin-right: -7px;" class="a-link d-inline py-0" href="https://www.transportation.gov/odapc/random-testing-rates" target="_blank">Random Testing Rates</a> 
                        <span>for employees subject to the PHMSA regulations.</span>
                      </div>

                                    </li>
                                  </ul>
                                  <!-- <h2 class="company-info-heading mt-3 mb-3">Policy & Procedure Manual</h2>
                                  <p>Implementation of your individualized Alcohol and Drug Testing Plans (written policy & procedure manual). Applicant and employee acknowledgment forms are included.</p>
                                  <h2 class="company-info-heading mt-3 mb-3">Certified Laboratory Services</h2>
                                  <p>Drug testing laboratory services for the program is a Substance Abuse and Mental Health Services Administration (SAMHSA), certified laboratory. The lab for our program is: Clinical Reference Laboratory, 8433 Quivira, Lenexa, Kansas 66215.</p>
                                  <h2 class="company-info-heading mt-3 mb-3">Medical Review Officer (MRO) Services</h2>
                                  <p>The MRO oversees the drug testing results to ensure validity of the results and to make sure that the employee's rights are preserved. The MRO for our program is: Dr. David W. Paine, American Medical Review Officers, LLC, 9 Compound Drive, Hutchinson, Kansas 67502.</p>
                                  <h2 class="company-info-heading mt-3 mb-3">Collection Kit</h2>
                                  <p>PTC furnishes all relevant drug and alcohol collection supplies, including chain of custody forms, to the employer at no extra charge via ground delivery. Overnight shipping and handling of the specimen to the lab is also included.</p>
                                  <h2 class="company-info-heading mt-3 mb-3">Collection Sites</h2>
                                  <p>Included with drug testing is a specimen collection site (your local clinic, hospital or doctor’s office). Approved collection sites are identified on our website (www.pipelinetesting.com) as Preferred (P), Standard (blue pushpin), and even sites with higher than average testing fees (yellow pushpin) in which a surcharge may apply.   All collection sites utilized must be listed in the PTC Collection Site Network.  Additional charges may apply for collection sites used outside the approved network,  for after-hour   services, on-site(mobile) testing, and other situations.</p>
                                  <h2 class="company-info-heading mt-3 mb-3">Breath Alcohol Technician (BAT) Services</h2>
                                  <p>Trained BATs and collection facilities are provided by either mobile service or walk-in facilities.</p>
                                  <h2 class="company-info-heading mt-3 mb-3">Testing Schedule</h2>
                                  <p>All employees working in a "covered" position are subject to unannounced testing based on random selection. All random selections are computer generated. The current annualized random drug testing rate is published on https://www.transportation.gov/odapc/random-testing-rates for employees subject to the PHMSA regulations.</p> -->
                                </div>
                              </div>
                            </div>

                            <div class="page-break acknowled">
                              <div class="companyInfo row ">
                                <div class="col-md-12 col-sm-12">
                                  <ul style="list-style-type: none;">
                                    <li>
                                      <h2 class="company-info-heading-pdf mt-3 mb-2">Employee Assistance Program (EAP) &
                                        Supervisor Training</h2>
                                      <p>The employee assistance program (EAP) includes informational material for each
                                        employee, hot- line number posters, and an online training module covering drug
                                        and alcohol recognition, testing and understanding for supervisors and managers.
                                      </p>

                                    </li>
                                    <li>
                                      <h2 class="company-info-heading-pdf mt-3 mb-2">Substance Abuse Professional (SAP)
                                        Services</h2>
                                      <p>The Substance Abuse Professional (SAP) provides an evaluation of an employee
                                        who tests positive for alcohol and/or drugs. PTC will coordinate the follow-up
                                        program established by the Substance Abuse Professional.</p>

                                    </li>
                                    <li>
                                      <h2 class="company-info-heading-pdf mt-3 mb-2">Drug/Alcohol History Checks</h2>
                                      <p>Employers hiring any applicant for a DOT position must obtain information about
                                        any DOT alcohol and/or drug misuse from the applicant's previous employers for
                                        the previous two years (three years if applicant is a CDL driver.) PTC Assist,
                                        LLC provides this verification service for PTC. This service is done in
                                        accordance with 49 CFR Part 40.25 requirements.</p>

                                    </li>
                                    <li>
                                      <h2 class="company-info-heading-pdf mt-3 mb-2">Recordkeeping</h2>
                                      <p>Maintenance and recordkeeping functions are provided. The records are kept
                                        electronically via a secure digital file source and can be retrieved quickly for
                                        submission. PTC also maintains BAT and QAP records.</p>

                                    </li>
                                    <li>
                                      <h2 class="company-info-heading-pdf mt-3 mb-2">PTC Online Access</h2>
                                      <p>Allows employers to access their pool information 24/7. Employers can view
                                        employee test result history, current random pool lists, history check
                                        information and much more.</p>

                                    </li>
                                    <li>
                                      <h2 class="company-info-heading-pdf mt-3 mb-2">ePay<sup>TM</sup></h2>
                                      <p>View and pay invoices online. Members are given unique login criteria to view
                                        their specific account details quickly and securely. View payment history and
                                        pending statements.</p>

                                    </li>

                                    <li>
                                      <h2 class="company-info-heading-pdf mt-3 mb-2">Statistical Data Reporting</h2>
                                      <p>Quarterly statistical data reports are provided to the pipeline contractor and
                                        to the pipeline operators that each contractor works for.</p>
                                    </li>
                                    <li>
                                      <h2 class="company-info-heading-pdf mt-3 mb-2">Compliance Audits and/or Updates
                                      </h2>
                                      <p>All operator audit requests are handled by Pipeline Testing Consortium, Inc.
                                        When a pipeline contractor is solicited by the operator, all requested
                                        information is to be sent to PTC for response directly to the operator.</p>
                                      <p>All new and existing regulations are monitored to maintain complete compliance
                                        of the DOT regulations.</p>
                                    </li>
                                  </ul>
                                  <!-- <h2 class="company-info-heading mb-3">Employee Assistance Program (EAP) & Supervisor Training</h2>
                                  <p>The employee assistance program (EAP) includes informational material for each employee, hot- line number posters, and an online training module covering drug and alcohol recognition, testing and understanding for supervisors and managers.</p>
                                  <h2 class="company-info-heading mt-3 mb-3">Substance Abuse Professional (SAP) Services</h2>
                                  <p>The Substance Abuse Professional (SAP) provides an evaluation of an employee who tests positive for alcohol and/or drugs. PTC will coordinate the follow-up program established by the Substance Abuse Professional.</p>
                                  <h2 class="company-info-heading mt-3 mb-3">Drug/Alcohol History Checks</h2>
                                  <p>Employers hiring any applicant for a DOT position must obtain information about any DOT alcohol and/or drug misuse from the applicant's previous employers for the previous two years (three years if applicant is a CDL driver.) PTC Assist, LLC provides this verification service for PTC. This service is done in accordance with 49 CFR Part 40.25 requirements.</p>
                                  <h2 class="company-info-heading mt-3 mb-3">Recordkeeping</h2>
                                  <p>Maintenance and recordkeeping functions are provided. The records are kept electronically via a secure digital file source and can be retrieved quickly for submission. PTC also maintains BAT and QAP records.</p>
                                  <h2 class="company-info-heading mt-3 mb-3">PTC Online Access</h2>
                                  <p>Allows employers to access their pool information 24/7. Employers can view employee test result history, current random pool lists, history check information and much more.</p>
                                  <h2 class="company-info-heading mt-3 mb-3">ePay<sup>TM</sup></h2>
                                  <p>View and pay invoices online. Members are given unique login criteria to view their specific account details quickly and securely. View payment history and pending statements.</p>
                                  <h2 class="company-info-heading mt-3 mb-3">Statistical Data Reporting</h2>
                                  <p>Quarterly statistical data reports are provided to the pipeline contractor and to the pipeline operators that each contractor works for.</p>
                                  <h2 class="company-info-heading mt-3 mb-3">Compliance Audits and/or Updates</h2>
                                  <p>All operator audit requests are handled by Pipeline Testing Consortium, Inc. When a pipeline contractor is solicited by the operator, all requested information is to be sent to PTC for response directly to the operator.</p>
                                  <p>All new and existing regulations are monitored to maintain complete compliance of the DOT regulations.</p> -->
                                </div>
                              </div>
                            </div>

                            <div class="page-break acknowled">
                              <div class="companyInfo row">
                                <div class="col-md-12 col-sm-12">
                                  <h2 class="company-info-heading-pdf mb-3">FEES FOR ALL SERVICES AS OUTLINED</h2>
                                  <div class="table-responsive">
                                    <table class="table-border-none-padding col-xl-11 mx-auto">
                                      <tr>
                                        <td style="width:90px" class="text-right pr-3 align-top">$250.00</td>
                                        <td><b>Account Setup Fee</b><br />
                                          <span style="font-size:13px; line-height:13px">(one time set-up charge)</span>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td style="width:90px" class="text-right pr-3 align-top">$550.00</td>
                                        <td><b>Annual Subscription Fee / Renewal</b><br />
                                          <span style="font-size:13px; line-height:13px">(This fee covers statistical data reporting, assistance with compliance audits, record keeping and etc.)</span>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td style="width:90px" class="text-right pr-3 align-top">$30.00</td>
                                        <td><b>Annual Employee Fee</b><br />
                                          <span style="font-size:13px; line-height:13px"><i>(This fee covers the supervisor
                                            training module, EAP informational materials, posters, testing schedules,
                                            and related program resources. The annual employee fee is calculated based on
                                              the average number of employees during the previous 12 months at a rate of
                                              $30.00 per employee, with a maximum annual employee fee of $6,000.00.)</i></span>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td style="width:90px" class="text-right pr-3 align-top">$85.00</td>
                                        <td><b>Each Drug Test</b><br />
                                          <span style="font-size:13px; line-height:13px">(This fee covers the specimen
                                            collection, laboratory and MRO fees.)*</span>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td style="width:90px" class="text-right pr-3 align-top">$85.00</td>
                                        <td><b>Each Alcohol Test</b><br />
                                          <span style="font-size:13px; line-height:13px">(This fee covers the initial
                                            and confirmation alcohol testing fee.)*</span>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td style="width:90px" class="text-right pr-3 align-top">$18.00</td>
                                        <td><b>Each Drug/Alcohol History Check</b><br />
                                          <span style="font-size:13px; line-height:13px">Required by 49 CFR Part
                                            40.25.<br />
                                            <i>$25 history check fee applies if legacy paper authorization method
                                              utilized.
                                              (Checks performed through PTC Assist, LLC.)</i></span>
                                        </td>
                                      </tr>
                                    </table>
                                  </div>
                                  <div style="border:2px solid #ccc" class="px-5 py-3 my-4">
                                    <h2 class="text-center mb-1">"Example Estimate Based on Five (5) Employees"
                                    </h2>
                                    <p class="text-center">(Adjust the estimate for the number of "covered" employees
                                      for your company.)</p>
                                    <div class="table-responsive mt-3">
                                      <table class="table-border-none col-xl-11 mx-auto" cellpadding="0">
                                        <tr>
                                          <td><strong>Account Setup Fee (1x fee)</strong></td>
                                          <td class="text-right">$250.00</td>
                                          <td></td>
                                        </tr>
                                        <tr>
                                          <td><strong>Annual Subscription Fee / Renewal</strong></td>
                                          <td class="text-right">$550.00</td>
                                          <td></td>
                                        </tr>
                                        <tr>
                                          <td><strong>Annual Employee Fee</strong></td>
                                          <td class="text-right"></td>
                                          <td></td>
                                        </tr>
                                        <tr>
                                          <td><strong>(5 Employees X $30.00)</strong></td>
                                          <td class="text-right"><span
                                              style="text-decoration:underline">$150.00</span>&nbsp;</td>
                                          <td><span style="font-size:13px">(Maximum Employee Fee $6,000)</span></td>
                                        </tr>
                                        <tr>
                                          <td><strong>Total</strong></td>
                                          <td class="text-right">$950.00</td>
                                          <td></td>
                                        </tr>
                                      </table>
                                    </div>
                                    <p style="font-size:13px;font-weight:bold; padding-top:20px">**NOTE** All drug
                                      and/or alcohol tests will be invoiced after completion at $85.00 per test if and
                                      when any testing is completed. The DOT required history checks will also be
                                      invoiced after completion.</p>
                                    <p style="font-size:13px;">If previous drug testing had been conducted with a SAMHSA
                                      certified lab and all
                                      tests were DOT 5-panel tests and your company has been conducting random testing
                                      at the proper annualized rate. The drug testing records may be transferred with
                                      employee release. Contact us with further questions regarding the potential for
                                      you to transfer your past DOT records.</p>
                                  </div>
                                  <p style="font-size:13px">*PTC consolidates all fees associated with alcohol and drug
                                    testing. PTC will pay up to a pre-determined, maximum collection fee per test. Other
                                    charges may apply for after-hour, on-site, out-of-network, or non-standard rate
                                    testing.</p>
                                </div>
                              </div>
                            </div>
                            <div class="page-break acknowled">
                              <div class="companyInfo row ">
                                <div class="col-md-12 col-sm-12">

                                  <h2 class="company-info-heading-pdf mb-3">No Refund & Credit Policy</h2>
                                  <p>Due to the nature of our services, we have, without exception, a NO REFUND policy. For this reason, we strongly recommend that before payment, you make certain that you understand the nature and cost of the services we provide. Invoices sent by PTC under this agreement are due upon receipt. The company shall owe a finance charge on any balance not paid within 30 days of the date of the invoice at the rate of 1.5% per month or 18% annually and the account may be subject to hold. In the event the company fails to make payments of amounts due under this agreement, PTC is authorized to suspend performance of its obligations to the company until full payment of the amount which the company is in default is received. PTC is not obligated to keep accounts open once an invoice balance has reached 60 days. By way of illustration and not limitation, PTC is expressly allowed, during such period of default, to remove the company from the Consortium and to report on any listing or report of compliance with applicable regulations or, in the case where PTC is listing only the company in compliance to omit such defaulting company. Such action by PTC shall not relieve the company of its obligation to pay any annual, administration, or other fees provided under this agreement.</p>

                                  <h2 class="company-info-heading-pdf mt-3 mb-3">Electronic Transmission Acknowledgment
                                  </h2>
                                  <p>This is to confirm your company's permission to use web or e-mail as a means of
                                    receiving test
                                    results, as opposed to calling the test results out by phone. As the contracted
                                    agent, Pipeline
                                    Testing Consortium, Inc. maintains all original records on behalf of your company.
                                    The guidelines
                                    will be as follows: </p>
                                  <p>• Individual expectations of privacy and confidentiality must be carefully
                                    maintained. Any
                                    transmission is confidential and is intended only for the use of the individual or
                                    entity
                                    identified. If the reader of the communication is not the intended recipient, they
                                    are hereby
                                    notified that dissemination or distribution of the data contained therein is
                                    prohibited under
                                    federal and state laws. </p>
                                  <p> Please acknowledge that you have read the above requirements/ restrictions for
                                    giving / receiving
                                    tests results via web or e-mail. </p>

                                  <h2 class="company-info-heading-pdf mt-3 mb-3">Consumer Report Service Agreement for
                                    Employers Subject to
                                    Substance Abuse Testing Verification Requirements</h2>
                                  <p>(hereinafter "{{CompanyName}}") and PTC Assist, LLC have entered into a Consumer
                                    Report Service
                                    Agreement (hereinafter "Agreement") through which {{CompanyName}} will utilize PTC
                                    Assist to obtain
                                    consumer reports for employment purposes. {{CompanyName}} and PTC Assist mutually
                                    desire to add the
                                    authorization provisions set forth below to the scope of that Agreement.
                                  </p>
                                </div>
                              </div>
                              <p> {{CompanyName}} is subject to drug and alcohol testing requirements under federal,
                                state, or local laws,
                                including those enforced by the U.S. Department of Transportation. {{CompanyName}}
                                understands that compliance
                                with these requirements includes verifying the drug and alcohol testing record of
                                certain of its
                                employees or prospective employees. In addition, {{CompanyName}} understands that these
                                requirements impose an
                                obligation on {{CompanyName}} to disclose information regarding the testing history of
                                its current or former
                                employees in response to verification requests from other employers also subject to
                                these requirements.
                                {{CompanyName}} has determined to utilize a consortium / third party
                                administrator(hereinafter "TPA"), to act as
                                {{CompanyName}}'s agent in complying with its alcohol and drug testing requirements.
                                {{CompanyName}}'s TPA is as follows:
                              </p>
                              <p>Third Party Administrator: Pipeline Testing Consortium, Inc.<br />Contact Address: 9
                                Compound Drive,
                                Hutchinson, KS 67502<br />Contact Phone: 620 - 669 - 8800</p>
                            </div>
                            <div class="page-break acknowled">
                              <p>For the mutual benefit of {{CompanyName}} and PTC Assist, {{CompanyName}} provides the
                                following additional
                                authorizations:</p>

                              <p>Whether in response to a request from {{CompanyName}} or from another employer also
                                subject to the drug and
                                alcohol testing requirements, {{CompanyName}} authorizes PTC Assist to communicate
                                directly with TPA to obtain
                                information regarding the alcohol or drug testing record of any of {{CompanyName}}'s
                                current or former employees.
                              </p>
                              <p>{{CompanyName}} authorizes TPA to release to PTC Assist any information that
                                {{CompanyName}} would be required to release
                                in response to a drug and alcohol testing record verification request regarding any
                                current or former
                                employee of {{CompanyName}}'s. {{CompanyName}} further authorizes PTC Assist to share a
                                copy of this Addendum with TPA, on
                                request, to confirm {{CompanyName}}'s authorization.</p>
                              <p>So that TPA may maintain accurate records for {{CompanyName}}, {{CompanyName}}
                                authorizes PTC Assist to share the results
                                of its testing verifications directly with TPA.</p>
                              <p>The authorizations set forth above shall remain in effect until the termination of the
                                Agreement.</p>
                            </div>
                            <div class="page-break acknowled pdf-new-page">
                              <app-service-agreement-pdf [CompanyName]="objCompanyInfo.CompanyName"></app-service-agreement-pdf>
                               <ul style="padding-left:20px; margin:12px 0;">
                            <li style="margin-bottom:12px;">
                              <span style="font-weight:bold;">TERM:</span> The Term of this Agreement will start on the 1st day of the Month in which this Agreement is electronically signed by the
                              {{ objCompanyInfo.CompanyName }}
                              and will continue until terminated in accordance with the terms and conditions of this Agreement.
                            </li>

                            <li style="margin-bottom:12px;">
                              <span style="font-weight:bold;">SUBSCRIPTION FEES.</span> In exchange for the Services and Membership in the PTC Consortium, the
                              {{ objCompanyInfo.CompanyName }}
                              shall pay an Annual Subscription Fee and Annual Employee Fee as established by PTC from time to time (the “Fees”) which shall be paid in accordance with PTC’s No Refund and Credit Policy. PTC may terminate or suspend this Agreement, the Services under this Agreement, and remove
                              {{ objCompanyInfo.CompanyName }}
                              from the Consortium if {{ objCompanyInfo.CompanyName }} is in default of its obligations to pay the Fees or is in default under PTC’s No Refund and Credit Policy. This Agreement and Membership in the Consortium may be canceled in writing by
                              {{ objCompanyInfo.CompanyName }} at any time, however, there is NO REFUND for any unused portion of the Fees.
                            </li>
                            </ul>
                            </div>
                            <div class="page-break acknowled">
                              <ul style="padding-left:20px; margin:12px 0;">
                            <li style="margin-bottom:12px;">
                              <span style="font-weight:bold;">RECORDS RETENTION:</span> PTC shall retain records, including the {{ objCompanyInfo.CompanyName }}’s records, for the period of their immediate or current use, unless longer retention is necessary for historical reference or to comply with contractual or legal requirements. Thereafter, all records may be destroyed in accord with PTC’s then-current records retention policy.
                            </li>
                            <li style="margin-bottom:12px;">
                              <span style="font-weight:bold;">COOPERATION.</span>
                              {{ objCompanyInfo.CompanyName }} will reasonably cooperate with PTC to facilitate PTC's responsibilities under this Agreement. Reasonable cooperation shall include, but not be limited to, making reasonable efforts to insure that those employees subject to DOT regulations and/or NON-DOT requirements adhere to the
                              {{ objCompanyInfo.CompanyName }}’s
                              Alcohol and Drug Program and PTC procedures; submit to drug and alcohol testing, conduct DOT background/history checks, education or training as appropriate and travel to PTC specimen collection sites when required by PTC and/or
                              {{ objCompanyInfo.CompanyName }}.
                              <br><br>
                              The {{ objCompanyInfo.CompanyName }} shall designate PTC as its agent and hereby authorize PTC to receive all test results from the MRO. PTC shall promptly, upon receipt from the MRO, report all test results to {{ objCompanyInfo.CompanyName }}. {{ objCompanyInfo.CompanyName }} shall designate a {{ objCompanyInfo.CompanyName }} management official as the Designated Employer Representative (DER) to receive such confidential test results from PTC. PTC shall maintain all test results and records in strict confidence consistent with applicable DOT regulations and/or NON-DOT requirements.
                            </li>
                              <li style="margin-bottom:12px;">
                              <span style="font-weight:bold;">DEFAULT.</span> In the event
                              {{ objCompanyInfo.CompanyName }}
                              fails to make payments of amounts due under this contract within 30 days from the date of invoice, PTC is authorized to suspend performance of its obligations to
                              {{ objCompanyInfo.CompanyName }}
                              until full payment of the amount upon which
                              {{ objCompanyInfo.CompanyName }}
                              is in default. PTC is not obligated to keep accounts open once an invoice balance has reached 60 days. By way of illustration and not limitation, PTC is expressly allowed, during such period of default, to remove
                              {{ objCompanyInfo.CompanyName }}
                              from the Consortium and to report on any listing or report of compliance prepared or caused to be prepared by PTC that
                              {{ objCompanyInfo.CompanyName }}
                              is not in compliance with applicable regulations (or, in the case where PTC is listing only
                              {{ objCompanyInfo.CompanyName }}’s
                              in compliance, to omit such defaulting
                              {{ objCompanyInfo.CompanyName }}). Such action by PTC shall not relieve
                              {{ objCompanyInfo.CompanyName }}
                              of its obligation to pay any annual, administration, or other fees provided herein.
                            </li>
                             <li style="margin-bottom:12px;">
                              <span style="font-weight:bold;">REIMBURSEMENT.</span>
                              {{ objCompanyInfo.CompanyName }}
                              agrees to be solely responsible for obtaining reimbursement for testing costs from
                              {{ objCompanyInfo.CompanyName }}
                              employees where desired by
                              {{ objCompanyInfo.CompanyName }}
                              and where permissible under applicable laws and employment contracts.
                            </li>

                            <li style="margin-bottom:12px;">
                              <span style="font-weight:bold;">ADDITIONAL COMPENSATION.</span> To the extent the issuance of new, amended or supplemental regulations by the Department of Transportation necessitates additional testing or other services not contemplated by the terms of this Agreement, the compensation to be paid to PTC as a result of the additional testing or other services shall be agreed upon by the parties to this Agreement, but shall in no event be less than the actual cost incurred by PTC in providing the additional testing or other services.
                            </li>
                            <li style="margin-bottom:12px;">
                              <span style="font-weight:bold;">RESPONSIBILITY REGARDING TEST RESULTS, DETERMINATIONS, REFERRALS, AND REPORTING;</span> {{ objCompanyInfo.CompanyName }} shall be solely responsible for taking any action required by applicable DOT regulations or NON-DOT requirements based on an employee’s positive or refused drug or alcohol test. {{ objCompanyInfo.CompanyName }} shall also be solely responsible for any other post-testing action concerning the employment status of its employee, whether required by applicable regulations, {{ objCompanyInfo.CompanyName }} requirements, or {{ objCompanyInfo.CompanyName }}’s discretion. In addition, {{ objCompanyInfo.CompanyName }} is responsible for making any testing determinations required by applicable DOT regulations or NON-DOT requirements for post-accident, reasonable-cause, or refusal-to-test situations. {{ objCompanyInfo.CompanyName }} shall make any required referral to a qualified Substance Abuse Professional following a positive or refused drug or alcohol test. If applicable, {{ objCompanyInfo.CompanyName }} is responsible for any required reporting to the Federal Motor Carrier Safety Administration Clearinghouse, except those items required to be reported by the Medical Review Officer.
                            </li>
                              </ul>
                            </div>
                          <div class="page-break acknowled">
                          <ul style="padding-left:20px; margin:12px 0;">
                            <li style="margin-bottom:12px;">
                              <span style="font-weight:bold;">INDEMNITY.</span> {{ objCompanyInfo.CompanyName }} agrees to hold PTC harmless and to indemnify and defend PTC from all claims, causes of action, or suits by employees or third parties except those that are a direct and proximate result of PTC’s willful wrongdoing, gross negligence, or fraud in the performance of functions administered by it under this Agreement.
                            </li>

                            <li style="margin-bottom:12px;">
                              <span style="font-weight:bold;">JURISDICTION.</span> This Agreement shall be governed by and construed under the laws of the State of Kansas without regard to conflicts of laws principles. Any action or proceeding seeking to enforce any provision of, or based on any right arising out of, this Agreement shall be brought against either of the parties only in the courts of the State of Kansas, County of Reno, or, if it has or can acquire jurisdiction, in the United States District Court for the District of Kansas, and each of the parties consents to the exclusive jurisdiction of such courts (and of the appropriate appellate courts) in any such action or proceeding and waives any objection to venue laid therein. Process in any action or proceeding referred to in the preceding sentence may be served on either party anywhere in the world.
                            </li>

                            <li style="margin-bottom:12px;">
                              <span style="font-weight:bold;">SEVERABILITY.</span> If any provision of this Agreement is held invalid or unenforceable by any court of competent jurisdiction, the other provisions of this Agreement will remain in full force and effect. Any provision of this Agreement held invalid or unenforceable only in part or degree will remain in full force and effect to the extent not held invalid or unenforceable.
                            </li>

                            <li style="margin-bottom:12px;">
                              <span style="font-weight:bold;">BINDING EFFECT.</span> This Agreement shall be binding upon and inure to the benefit of the successors and assigns of the parties hereto.
                            </li>
                          </ul>

                              <!-- //let signedDate = new Date( AckAndAgreement.AckDate); //use your date here
                            //let currentDate = datePipe.transform(signedDate, 'MM/dd/yyyy'); -->

                              <p style='font-size:11px;font-weight:bold; line-height: 16px;'>I Agree By checking the "I
                                Accept" box, you are signing these
                                acknowledgments and policies electronically. You agree your electronic signature is the
                                legal equivalent
                                of your manual/handwritten signature on these documents. By selecting "I Accept" using
                                any device,
                                means, or action, you consent to the legally binding terms and conditions of these
                                documents. You
                                further agree that your electronic signature on this document is as valid as if you
                                signed these
                                documents in writing.</p>

                              <div class="row mx-0">
                                <div class="companyname-width-print">
                                  <div class="signature-wrap-height-print text-pdf-cap" style="padding-bottom:5px">
                                    {{CompanyName}}
                                  </div>
                                  <div style="border-top:1px solid #000;padding-top:5px">
                                    <b>Company Name</b>
                                  </div>
                                </div>

                                <div class="ms-auto auth authorized-width-print">
                                  <div class="signature-wrap-height-print text-pdf-cap" style="padding-bottom:5px">
                                    {{AckAndAgreementValue?AckAndAgreementValue.CompanyRepresentativeName:''}}</div>
                                  <div style="border-top:1px solid #000;padding-top:5px; line-height: 16px;">
                                    <b>Name of Authorized Company Representative</b>
                                  </div>
                                </div>

                                <div class="ms-auto date-width-print">
                                  <div class="signature-wrap-height-print text-pdf-cap" style="padding-bottom:5px">
                                    {{AckDate}}</div>
                                  <div style="border-top:1px solid #000; padding-top:5px">
                                    <b>Date</b>
                                  </div>
                                </div>
                              </div>
                              <!-- <div style="float:left; width:250px; margin-right:30px"><div  style="padding-bottom:5px"></div>
                            <div style="border-top:1px solid #000;padding-top:5px"><b>Company Name</b></div></div> 
                            <div style="float:left; width:250px; margin-right:30px;"> <div style="padding-bottom:5px"></div>
                
                            <div style="border-top:1px solid #000;padding-top:5px"><b>Name of Authorized Company Representative</b></div></div>
                            <div style="float:right; width:160px;"><div style="padding-bottom:5px"></div>
                            <div style="border-top:1px solid #000; padding-top:5px"><b>Date</b></div>
                            </div> -->

                            </div>

                   

                            <div class="page-break text-pdf-cap pdf-new-page">
                              <h2 class="section-2-heading">Summary</h2>
                              <mat-divider></mat-divider>
                              <div class="companyInfo mt-4">
                                <div class="me-5">
                                  <p>
                                    <label>Company Name:&nbsp;</label>
                                    {{customerByIdData?.CustomerDetails.CompanyDetails.CompanyName}}
                                  </p>
                                  <p><label>Affiliate Company Name:</label>
                                    {{customerByIdData?.CustomerDetails.CompanyDetails.AffiliatedCompanyName?customerByIdData?.CustomerDetails.CompanyDetails.AffiliatedCompanyName:
                                    'None'}}</p>
                                  <p><label>Reinstatement Account:</label>
                                    {{customerByIdData?.CustomerDetails.CompanyDetails.ReinstatedAccountNumber?customerByIdData?.CustomerDetails.CompanyDetails.ReinstatedAccountNumber:'None'}}
                                  </p>
                                  <p>
                                    <label>Address:</label>
                                    {{
                                    customerByIdData?.CustomerDetails.CompanyDetails
                                    .MailingAddress.StreetName !=null? customerByIdData?.CustomerDetails.CompanyDetails
                                    .MailingAddress.StreetName +
                                    ",
                                    " +
                                    customerByIdData?.CustomerDetails.CompanyDetails
                                    .MailingAddress.City +
                                    ", " +
                                    customerByIdData?.CustomerDetails.CompanyDetails
                                    .MailingAddress.State +
                                    ", " +
                                    GetZipFormat(customerByIdData?.CustomerDetails.CompanyDetails
                                    .MailingAddress.Zip) +
                                    ", " +
                                    customerByIdData?.CustomerDetails.CompanyDetails
                                    .Country:''

                                    }}
                                  </p>
                                  <p>
                                    <label>DER:&nbsp;</label>
                                    {{ customerByIdData?.CustomerDetails.DERs[0].Name }}
                                  </p>
                                  <p>
                                    <label>Phone No:</label>
                                    {{
                                    GetPhoneNoFormat(customerByIdData?.CustomerDetails.DERs[0].Address?customerByIdData?.CustomerDetails.DERs[0].Address
                                    .PhoneNumber:'')
                                    }}
                                  </p>
                                  <p>
                                    <label>Email:</label>
                                    {{
                                    customerByIdData?.CustomerDetails.DERs[0].EmailAddress?customerByIdData?.CustomerDetails.DERs[0].EmailAddress:''
                                    }}
                                  </p>
                                  <p>
                                    <label>Main Billing Contact:</label>
                                    {{
                                    customerByIdData?.CustomerDetails.BillingContacts.length
                                    >0?customerByIdData?.CustomerDetails.BillingContacts[0].Name:''
                                    }}
                                  </p>
                                  <p><label>Programs Requested:</label>{{InvoiceNumber? ProgramsRequested: ''}}</p>
                                  <p>
                                    <label># of Employees in a Random Pool:</label>
                                    {{TotalEmployees}}
                                  </p>
                                  <p>
                                    <label>Payment Method:</label>
                                    {{InvoiceNumber? (customerByIdData?.CustomerDetails.PaymentDetails.IsCreditCard?
                                    'Credit Card':'Check'):''}}
                                  </p>
                                  <div *ngIf="customerByIdData?.CustomerDetails.PaymentDetails.CreditCardDetails">
                                    <p *ngIf="customerByIdData?.CustomerDetails.PaymentDetails.IsCreditCard">
                                      <label>Credit Card (Last 4 digits):</label>
                                      {{
                                      customerByIdData?.CustomerDetails.PaymentDetails.CreditCardDetails.CardNumber
                                      }}
                                    </p>
                                    <p *ngIf="customerByIdData?.CustomerDetails.PaymentDetails.IsCreditCard">
                                      <label>Transaction ID:</label>
                                      {{
                                      customerByIdData?.CustomerDetails.RepayTransactionId
                                      }}
                                    </p>
                                    <p *ngIf="customerByIdData?.CustomerDetails.PaymentDetails.IsCreditCard">
                                      <label>GUID:</label>
                                      {{
                                      customerByIdData.GUID
                                      }}
                                    </p>
                                  </div>
                                  <p>
                                    <label>Invoice Number:</label>
                                    {{
                                    customerByIdData?.CustomerDetails.InvoiceNumber
                                    }}
                                  </p>
                                  <p>
                                    <label>Account Setup Fee:</label> ${{
                                    NumberWithCommasWithTwoDecimal(customerByIdData?.CustomerDetails.FeeDetails.SetupFee)
                                    }}
                                  </p>
                                  <p>
                                    <label>Annual Subscription:</label> ${{
                                    NumberWithCommasWithTwoDecimal(customerByIdData?.CustomerDetails.FeeDetails.AnnualSubscription)
                                    }}
                                  </p>
                                  <p>
                                    <label>Annual Employee
                                      Fee*:&nbsp;</label>${{ NumberWithCommasWithTwoDecimal(randomPool)}}
                                  </p>
                                  <!-- <p>
                                    <label
                                      >>(18 employees in a random pool x $30 per)$540</label
                                    >
                                  </p> -->

                                  <p><label>Shipping & Handling:</label> ${{
                                    NumberWithCommasWithTwoDecimal(customerByIdData?.CustomerDetails.FeeDetails.ExpeditedShippingFee)}}
                                  </p>
                                  <p><label>Sales Tax ({{SalesTax>0?SalesTaxPercent:0}}%)**:</label> ${{
                                    NumberWithCommasWithTwoDecimal(SalesTax) }}</p>
                                  <p class="mt-3"><label>Enrollment Total: ${{
                                      NumberWithCommasWithTwoDecimal(EnrollmentTotalFee)}}</label></p>

                                  <h5 _ngcontent-ijn-c460="" class="mb-1" style="text-transform: none;">
                                    *The annual employee fee is calculated based on the average number of employees
                                    during the previous 12 months at a rate of $30.00 per employee, with a maximum
                                    annual employee fee of $6,000.00
                                  </h5>
                                  <h5 _ngcontent-ijn-c460="" class="mb-0" style="text-transform: none;">**All South
                                    Dakota based accounts are subject
                                    to sales
                                    tax. Completing and submitting this enrollment authorizes PTC to charge the
                                    applicable sales tax
                                    rate based upon your jurisdiction at the time the credit card is processed or
                                    invoice is issued.
                                  </h5>
                                  <!-- <p>
                                    <label
                                      >Total:
                                      {{
                                        NumberWithCommasWithTwoDecimal(customerByIdData?.CustomerDetails.FeeDetails
                                          .EnrollmentTotal)
                                      }}</label
                                    >
                                  </p> -->
                                  <h2 class="company-info-heading-pdf mt-3 mb-3">Per Use Fees</h2>
                                  <p
                                    *ngIf="objProgramSelection.DotFederal  == true || objProgramSelection.NonDotCompnay == true || objProgramSelection.ClientRequired === true">
                                    <label>Drug Test:</label> ${{
                                    NumberWithCommasWithTwoDecimal(customerByIdData?.CustomerDetails.FeeDetails.DrugTest)
                                    }}
                                  </p>
                                  <p *ngIf="IsExxonMobilDrugTest">
                                    <label>ExxonMobil Drug Test:</label> ${{
                                    NumberWithCommasWithTwoDecimal(customerByIdData?.CustomerDetails.FeeDetails
                                    .ExxonMobilDrugTest)
                                    }}
                                  </p>
                                  <p
                                    *ngIf="objProgramSelection.DotFederal  == true || objProgramSelection.NonDotCompnay == true || objProgramSelection.ClientRequired === true">
                                    <label>Alcohol Test:</label> ${{
                                    NumberWithCommasWithTwoDecimal(customerByIdData?.CustomerDetails.FeeDetails
                                    .AlcoholTest)
                                    }}
                                  </p>
                                  <p
                                    *ngIf="objProgramSelection.DotFederal  == true || objProgramSelection.NonDotCompnay == true || objProgramSelection.ClientRequired === true">
                                    <label>Electronic Drug/Alcohol History Check:</label>${{
                                    NumberWithCommasWithTwoDecimal(customerByIdData?.CustomerDetails.FeeDetails
                                    .DOTHistoryCheck)
                                    }}
                                  </p>
                                  <p>
                                    <label>Paper Based Drug/Alcohol History Check:</label>${{
                                    NumberWithCommasWithTwoDecimal(customerByIdData?.CustomerDetails.FeeDetails
                                    .PaperBasedDrugAlcoholHistoryCheckFee)
                                    }}
                                  </p>
                                </div>
                              </div>
                            </div>

                          </div>
                          <!-- <download-enrollment-profile  CustomerData={{CustomerDetail}}></download-enrollment-profile> -->
                        </div>

                      </kendo-pdf-export>
                    </div>
                  </div>
                  <!--<input (click)="previous()" type="button" name="previous" class="previous action-button-previous" value="Previous" />-->
                  <!--<input (click)="StartOver()" type="button" name="startover" class="previous action-button-previous btn btn-primary" style="background-color: #1b6ec2 !important;" value="Start Over" />-->
                </div>
              </fieldset>
            </form>
            <div class="text-center">
              Questions? Contact PTC at <b>(800) 294-8758</b>
            </div>
          </div>
        </div>
      </div>
      <app-footer></app-footer>
    </div>
  </div>
</div>

<div *ngIf="IsFormShow === false" class="mx-3">
  <div class="access-bg col-10 col-sm-7 col-md-6 col-lg-5 col-xl-4 mx-auto">
    <img src="../../assets/Images/access_ico.png" />
    <div class="acc-message">
      <h2>Access Denied</h2>
      <p>
        <!-- Looks like you don't have right permission to access the system. Please
        contact Customer Support at 888-555-1212 to resolve the issue -->

        <!--The URL tied to this message has expired. -->
        For assistance, please contact PTC Sales Department <span class="text-nowrap">at 800-294-8758 ext. 405.</span>

      </p>
      <div *ngIf="IsCreateTestGUID">
        <button type="button" class="btn btn-primary btn-lg" (click)="createNewGuid()">
          Create Test Guid
        </button>
      </div>
    </div>
  </div>


</div>